export default [
    {
        id: "010105",
        value: "Oficial general da aeron\u00e1utica"
    },
    {
        id: "010110",
        value: "Oficial general do ex\u00e9rcito"
    },
    {
        id: "010115",
        value: "Oficial general da marinha"
    },
    {
        id: "010215",
        value: "Oficial da marinha"
    },
    {
        id: "010210",
        value: "Oficial do ex\u00e9rcito"
    },
    {
        id: "010205",
        value: "Oficial da aeron\u00e1utica"
    },
    {
        id: "010310",
        value: "Pra\u00e7a do ex\u00e9rcito"
    },
    {
        id: "010315",
        value: "Pra\u00e7a da marinha"
    },
    {
        id: "010305",
        value: "Pra\u00e7a da aeron\u00e1utica"
    },
    {
        id: "020115",
        value: "Major da pol\u00edcia militar"
    },
    {
        id: "020105",
        value: "Coronel da pol\u00edcia militar"
    },
    {
        id: "020110",
        value: "Tenente-coronel da pol\u00edcia militar"
    },
    {
        id: "020205",
        value: "Capit\u00e3o da pol\u00edcia militar"
    },
    {
        id: "020305",
        value: "Primeiro tenente de pol\u00edcia militar"
    },
    {
        id: "020310",
        value: "Segundo tenente de pol\u00edcia militar"
    },
    {
        id: "021105",
        value: "Subtenente da policia militar"
    },
    {
        id: "021110",
        value: "Sargento da policia militar"
    },
    {
        id: "021205",
        value: "Cabo da pol\u00edcia militar"
    },
    {
        id: "021210",
        value: "Soldado da pol\u00edcia militar"
    },
    {
        id: "030115",
        value: "Tenente-coronel bombeiro militar"
    },
    {
        id: "030105",
        value: "Coronel bombeiro militar"
    },
    {
        id: "030110",
        value: "Major bombeiro militar"
    },
    {
        id: "030205",
        value: "Capit\u00e3o bombeiro militar"
    },
    {
        id: "030305",
        value: "Tenente do corpo de bombeiros militar"
    },
    {
        id: "031105",
        value: "Subtenente bombeiro militar"
    },
    {
        id: "031110",
        value: "Sargento bombeiro militar"
    },
    {
        id: "031210",
        value: "Soldado bombeiro militar"
    },
    {
        id: "031205",
        value: "Cabo bombeiro militar"
    },
    {
        id: "111120",
        value: "Vereador"
    },
    {
        id: "111115",
        value: "Deputado estadual e distrital"
    },
    {
        id: "111110",
        value: "Deputado federal"
    },
    {
        id: "111105",
        value: "Senador"
    },
    {
        id: "111220",
        value: "Secret\u00e1rio - executivo"
    },
    {
        id: "111215",
        value: "Ministro de estado"
    },
    {
        id: "111255",
        value: "Vice-prefeito"
    },
    {
        id: "111250",
        value: "Prefeito"
    },
    {
        id: "111245",
        value: "Vice-governador do distrito federal"
    },
    {
        id: "111205",
        value: "Presidente da rep\u00fablica"
    },
    {
        id: "111225",
        value: "Membro superior do poder executivo"
    },
    {
        id: "111230",
        value: "Governador de estado"
    },
    {
        id: "111210",
        value: "Vice-presidente da rep\u00fablica"
    },
    {
        id: "111240",
        value: "Vice-governador de estado"
    },
    {
        id: "111235",
        value: "Governador do distrito federal"
    },
    {
        id: "111345",
        value: "Juiz do trabalho"
    },
    {
        id: "111340",
        value: "Juiz auditor estadual - justi\u00e7a militar"
    },
    {
        id: "111335",
        value: "Juiz auditor federal - justi\u00e7a militar"
    },
    {
        id: "111330",
        value: "Juiz federal"
    },
    {
        id: "111325",
        value: "Juiz de direito"
    },
    {
        id: "111320",
        value: "Ministro do  superior tribunal do trabalho"
    },
    {
        id: "111310",
        value: "Ministro do superior tribunal de justi\u00e7a"
    },
    {
        id: "111315",
        value: "Ministro do  superior tribunal militar"
    },
    {
        id: "111305",
        value: "Ministro do supremo tribunal federal"
    },
    {
        id: "111405",
        value: "Dirigente do servi\u00e7o p\u00fablico federal"
    },
    {
        id: "111410",
        value: "Dirigente do servi\u00e7o p\u00fablico estadual e distrital"
    },
    {
        id: "111415",
        value: "Dirigente do servi\u00e7o p\u00fablico municipal"
    },
    {
        id: "111505",
        value: "Especialista de pol\u00edticas p\u00fablicas e gest\u00e3o governamental - eppgg"
    },
    {
        id: "111510",
        value: "Analista de planejamento e or\u00e7amento - apo"
    },
    {
        id: "113015",
        value: "Membro de lideran\u00e7a quilombola"
    },
    {
        id: "113005",
        value: "Cacique"
    },
    {
        id: "113010",
        value: "L\u00edder de comunidade cai\u00e7ara"
    },
    {
        id: "114105",
        value: "Dirigente de partido pol\u00edtico"
    },
    {
        id: "114210",
        value: "Dirigentes de entidades patronais"
    },
    {
        id: "114205",
        value: "Dirigentes de entidades de trabalhadores"
    },
    {
        id: "114305",
        value: "Dirigente e administrador de organiza\u00e7\u00e3o religiosa"
    },
    {
        id: "114405",
        value: "Dirigente e administrador de organiza\u00e7\u00e3o da sociedade civil sem fins lucrativos"
    },
    {
        id: "121005",
        value: "Diretor de planejamento estrat\u00e9gico"
    },
    {
        id: "121010",
        value: "Diretor geral de empresa e organiza\u00e7\u00f5es (exceto de interesse p\u00fablico)"
    },
    {
        id: "122120",
        value: "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa pesqueira"
    },
    {
        id: "122115",
        value: "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa florestal"
    },
    {
        id: "122105",
        value: "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa agropecu\u00e1ria"
    },
    {
        id: "122110",
        value: "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa aq\u00fc\u00edcola"
    },
    {
        id: "122205",
        value: "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es da ind\u00fastria de transforma\u00e7\u00e3o, extra\u00e7\u00e3o mineral e utilidades"
    },
    {
        id: "122305",
        value: "Diretor de opera\u00e7\u00f5es de obras p\u00fablica e civil"
    },
    {
        id: "122405",
        value: "Diretor de opera\u00e7\u00f5es comerciais (com\u00e9rcio atacadista e varejista)"
    },
    {
        id: "122515",
        value: "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de turismo"
    },
    {
        id: "122520",
        value: "Turism\u00f3logo"
    },
    {
        id: "122505",
        value: "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de alimenta\u00e7\u00e3o"
    },
    {
        id: "122510",
        value: "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de hotel"
    },
    {
        id: "122620",
        value: "Diretor de opera\u00e7\u00f5es de servi\u00e7os de transporte"
    },
    {
        id: "122615",
        value: "Diretor de opera\u00e7\u00f5es de servi\u00e7os de telecomunica\u00e7\u00f5es"
    },
    {
        id: "122605",
        value: "Diretor de opera\u00e7\u00f5es de correios"
    },
    {
        id: "122610",
        value: "Diretor de opera\u00e7\u00f5es de servi\u00e7os de armazenamento"
    },
    {
        id: "122705",
        value: "Diretor comercial em opera\u00e7\u00f5es de intermedia\u00e7\u00e3o financeira"
    },
    {
        id: "122710",
        value: "Diretor de produtos banc\u00e1rios"
    },
    {
        id: "122715",
        value: "Diretor de cr\u00e9dito rural"
    },
    {
        id: "122720",
        value: "Diretor de c\u00e2mbio e com\u00e9rcio exterior"
    },
    {
        id: "122725",
        value: "Diretor de compliance"
    },
    {
        id: "122730",
        value: "Diretor de cr\u00e9dito (exceto cr\u00e9dito imobili\u00e1rio)"
    },
    {
        id: "122735",
        value: "Diretor de cr\u00e9dito imobili\u00e1rio"
    },
    {
        id: "122740",
        value: "Diretor de leasing"
    },
    {
        id: "122745",
        value: "Diretor de mercado de capitais"
    },
    {
        id: "122750",
        value: "Diretor de recupera\u00e7\u00e3o de cr\u00e9ditos em opera\u00e7\u00f5es de intermedia\u00e7\u00e3o financeira"
    },
    {
        id: "122755",
        value: "Diretor de riscos de mercado"
    },
    {
        id: "123105",
        value: "Diretor administrativo"
    },
    {
        id: "123110",
        value: "Diretor administrativo e financeiro"
    },
    {
        id: "123115",
        value: "Diretor financeiro"
    },
    {
        id: "123205",
        value: "Diretor de recursos humanos"
    },
    {
        id: "123210",
        value: "Diretor de rela\u00e7\u00f5es de trabalho"
    },
    {
        id: "123305",
        value: "Diretor comercial"
    },
    {
        id: "123310",
        value: "Diretor de marketing"
    },
    {
        id: "123405",
        value: "Diretor de suprimentos"
    },
    {
        id: "123410",
        value: "Diretor de suprimentos no servi\u00e7o p\u00fablico"
    },
    {
        id: "123605",
        value: "Diretor de servi\u00e7os de inform\u00e1tica"
    },
    {
        id: "123705",
        value: "Diretor de pesquisa e desenvolvimento (p&d)"
    },
    {
        id: "123805",
        value: "Diretor de manuten\u00e7\u00e3o"
    },
    {
        id: "131105",
        value: "Diretor de servi\u00e7os culturais"
    },
    {
        id: "131120",
        value: "Gerente de servi\u00e7os sociais"
    },
    {
        id: "131115",
        value: "Gerente de servi\u00e7os culturais"
    },
    {
        id: "131110",
        value: "Diretor de servi\u00e7os sociais"
    },
    {
        id: "131205",
        value: "Diretor de servi\u00e7os de sa\u00fade"
    },
    {
        id: "131210",
        value: "Gerente de servi\u00e7os de sa\u00fade"
    },
    {
        id: "131215",
        value: "Tecn\u00f3logo em gest\u00e3o hospitalar"
    },
    {
        id: "131225",
        value: "Sanitarista"
    },
    {
        id: "131220",
        value: "Geront\u00f3logo"
    },
    {
        id: "131320",
        value: "Gerente de servi\u00e7os educacionais da \u00e1rea p\u00fablica"
    },
    {
        id: "131310",
        value: "Diretor de institui\u00e7\u00e3o educacional p\u00fablica"
    },
    {
        id: "131315",
        value: "Gerente de institui\u00e7\u00e3o educacional da \u00e1rea privada"
    },
    {
        id: "131305",
        value: "Diretor de institui\u00e7\u00e3o educacional da \u00e1rea privada"
    },
    {
        id: "141105",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es  aq\u00fc\u00edcolas"
    },
    {
        id: "141120",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es pesqueiras"
    },
    {
        id: "141115",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es agropecu\u00e1rias"
    },
    {
        id: "141110",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es  florestais"
    },
    {
        id: "141205",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es"
    },
    {
        id: "141305",
        value: "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es da constru\u00e7\u00e3o civil e obras p\u00fablicas"
    },
    {
        id: "141405",
        value: "Comerciante atacadista"
    },
    {
        id: "141410",
        value: "Comerciante varejista"
    },
    {
        id: "141415",
        value: "Gerente de loja e supermercado"
    },
    {
        id: "141420",
        value: "Gerente de opera\u00e7\u00f5es de servi\u00e7os de assist\u00eancia t\u00e9cnica"
    },
    {
        id: "141505",
        value: "Gerente de hotel"
    },
    {
        id: "141525",
        value: "Gerente de turismo"
    },
    {
        id: "141510",
        value: "Gerente de restaurante"
    },
    {
        id: "141520",
        value: "Gerente de pens\u00e3o"
    },
    {
        id: "141515",
        value: "Gerente de bar"
    },
    {
        id: "141615",
        value: "Gerente de log\u00edstica (armazenagem e distribui\u00e7\u00e3o)"
    },
    {
        id: "141605",
        value: "Gerente de opera\u00e7\u00f5es de transportes"
    },
    {
        id: "141610",
        value: "Gerente de opera\u00e7\u00f5es de correios e telecomunica\u00e7\u00f5es"
    },
    {
        id: "141720",
        value: "Gerente de cr\u00e9dito e cobran\u00e7a"
    },
    {
        id: "141705",
        value: "Gerente de produtos banc\u00e1rios"
    },
    {
        id: "141710",
        value: "Gerente de ag\u00eancia"
    },
    {
        id: "141735",
        value: "Gerente de recupera\u00e7\u00e3o de cr\u00e9dito"
    },
    {
        id: "141730",
        value: "Gerente de cr\u00e9dito rural"
    },
    {
        id: "141725",
        value: "Gerente de cr\u00e9dito imobili\u00e1rio"
    },
    {
        id: "141715",
        value: "Gerente de c\u00e2mbio e com\u00e9rcio exterior"
    },
    {
        id: "142110",
        value: "Gerente de riscos"
    },
    {
        id: "142120",
        value: "Tecn\u00f3logo em gest\u00e3o administrativo- financeira"
    },
    {
        id: "142105",
        value: "Gerente administrativo"
    },
    {
        id: "142115",
        value: "Gerente financeiro"
    },
    {
        id: "142205",
        value: "Gerente de recursos humanos"
    },
    {
        id: "142210",
        value: "Gerente de departamento pessoal"
    },
    {
        id: "142330",
        value: "Analista de neg\u00f3cios"
    },
    {
        id: "142325",
        value: "Rela\u00e7\u00f5es p\u00fablicas"
    },
    {
        id: "142340",
        value: "Ouvidor"
    },
    {
        id: "142335",
        value: "Analista de pesquisa de mercado"
    },
    {
        id: "142320",
        value: "Gerente de vendas"
    },
    {
        id: "142315",
        value: "Gerente de marketing"
    },
    {
        id: "142310",
        value: "Gerente de comunica\u00e7\u00e3o"
    },
    {
        id: "142305",
        value: "Gerente comercial"
    },
    {
        id: "142415",
        value: "Gerente de almoxarifado"
    },
    {
        id: "142405",
        value: "Gerente de compras"
    },
    {
        id: "142410",
        value: "Gerente de suprimentos"
    },
    {
        id: "142530",
        value: "Gerente de suporte t\u00e9cnico de tecnologia da informa\u00e7\u00e3o"
    },
    {
        id: "142505",
        value: "Gerente de rede"
    },
    {
        id: "142520",
        value: "Gerente de projetos de tecnologia da informa\u00e7\u00e3o"
    },
    {
        id: "142515",
        value: "Gerente de produ\u00e7\u00e3o de tecnologia da informa\u00e7\u00e3o"
    },
    {
        id: "142535",
        value: "Tecn\u00f3logo em gest\u00e3o da tecnologia da informa\u00e7\u00e3o"
    },
    {
        id: "142525",
        value: "Gerente de seguran\u00e7a de tecnologia da informa\u00e7\u00e3o"
    },
    {
        id: "142510",
        value: "Gerente de desenvolvimento de sistemas"
    },
    {
        id: "142605",
        value: "Gerente de pesquisa e desenvolvimento (p&d)"
    },
    {
        id: "142610",
        value: "Especialista em desenvolvimento de cigarros"
    },
    {
        id: "142710",
        value: "Tecn\u00f3logo em sistemas biom\u00e9dicos"
    },
    {
        id: "142705",
        value: "Gerente de projetos e servi\u00e7os de manuten\u00e7\u00e3o"
    },
    {
        id: "201105",
        value: "Bioengenheiro"
    },
    {
        id: "201110",
        value: "Biotecnologista"
    },
    {
        id: "201115",
        value: "Geneticista"
    },
    {
        id: "201220",
        value: "Especialista em instrumenta\u00e7\u00e3o metrol\u00f3gica"
    },
    {
        id: "201215",
        value: "Especialista em ensaios metrol\u00f3gicos"
    },
    {
        id: "201210",
        value: "Especialista em calibra\u00e7\u00f5es metrol\u00f3gicas"
    },
    {
        id: "201225",
        value: "Especialista em materiais de refer\u00eancia metrol\u00f3gica"
    },
    {
        id: "201205",
        value: "Pesquisador em metrologia"
    },
    {
        id: "202115",
        value: "Tecn\u00f3logo em mecatr\u00f4nica"
    },
    {
        id: "202120",
        value: "Tecn\u00f3logo em automa\u00e7\u00e3o industrial"
    },
    {
        id: "202110",
        value: "Engenheiro de controle e automa\u00e7\u00e3o"
    },
    {
        id: "202105",
        value: "Engenheiro mecatr\u00f4nico"
    },
    {
        id: "203005",
        value: "Pesquisador em biologia ambiental"
    },
    {
        id: "203010",
        value: "Pesquisador em biologia animal"
    },
    {
        id: "203015",
        value: "Pesquisador em biologia de microorganismos e parasitas"
    },
    {
        id: "203020",
        value: "Pesquisador em biologia humana"
    },
    {
        id: "203025",
        value: "Pesquisador em biologia vegetal"
    },
    {
        id: "203115",
        value: "Pesquisador em f\u00edsica"
    },
    {
        id: "203110",
        value: "Pesquisador em ci\u00eancias da terra e meio ambiente"
    },
    {
        id: "203105",
        value: "Pesquisador em ci\u00eancias da computa\u00e7\u00e3o e inform\u00e1tica"
    },
    {
        id: "203120",
        value: "Pesquisador em matem\u00e1tica"
    },
    {
        id: "203125",
        value: "Pesquisador em qu\u00edmica"
    },
    {
        id: "203215",
        value: "Pesquisador de engenharia el\u00e9trica e eletr\u00f4nica"
    },
    {
        id: "203210",
        value: "Pesquisador de engenharia e tecnologia (outras \u00e1reas da engenharia)"
    },
    {
        id: "203205",
        value: "Pesquisador de engenharia civil"
    },
    {
        id: "203220",
        value: "Pesquisador de engenharia mec\u00e2nica"
    },
    {
        id: "203225",
        value: "Pesquisador de engenharia metal\u00fargica, de minas e de materiais"
    },
    {
        id: "203230",
        value: "Pesquisador de engenharia qu\u00edmica"
    },
    {
        id: "203315",
        value: "Pesquisador em medicina veterin\u00e1ria"
    },
    {
        id: "203310",
        value: "Pesquisador de medicina b\u00e1sica"
    },
    {
        id: "203305",
        value: "Pesquisador de cl\u00ednica m\u00e9dica"
    },
    {
        id: "203320",
        value: "Pesquisador em sa\u00fade coletiva"
    },
    {
        id: "203405",
        value: "Pesquisador em ci\u00eancias agron\u00f4micas"
    },
    {
        id: "203410",
        value: "Pesquisador em ci\u00eancias da pesca e aq\u00fcicultura"
    },
    {
        id: "203415",
        value: "Pesquisador em ci\u00eancias da zootecnia"
    },
    {
        id: "203420",
        value: "Pesquisador em ci\u00eancias florestais"
    },
    {
        id: "203505",
        value: "Pesquisador em ci\u00eancias sociais e humanas"
    },
    {
        id: "203510",
        value: "Pesquisador em economia"
    },
    {
        id: "203515",
        value: "Pesquisador em ci\u00eancias da educa\u00e7\u00e3o"
    },
    {
        id: "203520",
        value: "Pesquisador em hist\u00f3ria"
    },
    {
        id: "203525",
        value: "Pesquisador em psicologia"
    },
    {
        id: "204105",
        value: "Perito criminal"
    },
    {
        id: "211120",
        value: "Matem\u00e1tico aplicado"
    },
    {
        id: "211105",
        value: "Atu\u00e1rio"
    },
    {
        id: "211110",
        value: "Especialista em pesquisa operacional"
    },
    {
        id: "211115",
        value: "Matem\u00e1tico"
    },
    {
        id: "211215",
        value: "Estat\u00edstico te\u00f3rico"
    },
    {
        id: "211205",
        value: "Estat\u00edstico"
    },
    {
        id: "211210",
        value: "Estat\u00edstico (estat\u00edstica aplicada)"
    },
    {
        id: "212210",
        value: "Engenheiro de equipamentos em computa\u00e7\u00e3o"
    },
    {
        id: "212205",
        value: "Engenheiro de aplicativos em computa\u00e7\u00e3o"
    },
    {
        id: "212215",
        value: "Engenheiros de sistemas operacionais em computa\u00e7\u00e3o"
    },
    {
        id: "212320",
        value: "Administrador em seguran\u00e7a da informa\u00e7\u00e3o"
    },
    {
        id: "212310",
        value: "Administrador de redes"
    },
    {
        id: "212305",
        value: "Administrador de banco de dados"
    },
    {
        id: "212315",
        value: "Administrador de sistemas operacionais"
    },
    {
        id: "212415",
        value: "Analista de sistemas de automa\u00e7\u00e3o"
    },
    {
        id: "212420",
        value: "Analista de suporte computacional"
    },
    {
        id: "212410",
        value: "Analista de redes e de comunica\u00e7\u00e3o de dados"
    },
    {
        id: "212405",
        value: "Analista de desenvolvimento de sistemas"
    },
    {
        id: "213110",
        value: "F\u00edsico (ac\u00fastica)"
    },
    {
        id: "213170",
        value: "F\u00edsico (plasma)"
    },
    {
        id: "213175",
        value: "F\u00edsico (t\u00e9rmica)"
    },
    {
        id: "213165",
        value: "F\u00edsico (part\u00edculas e campos)"
    },
    {
        id: "213160",
        value: "F\u00edsico (\u00f3ptica)"
    },
    {
        id: "213155",
        value: "F\u00edsico (nuclear e reatores)"
    },
    {
        id: "213150",
        value: "F\u00edsico (medicina)"
    },
    {
        id: "213145",
        value: "F\u00edsico (materiais)"
    },
    {
        id: "213125",
        value: "F\u00edsico (estat\u00edstica e matem\u00e1tica)"
    },
    {
        id: "213140",
        value: "F\u00edsico (mat\u00e9ria condensada)"
    },
    {
        id: "213105",
        value: "F\u00edsico"
    },
    {
        id: "213115",
        value: "F\u00edsico (at\u00f4mica e molecular)"
    },
    {
        id: "213120",
        value: "F\u00edsico (cosmologia)"
    },
    {
        id: "213130",
        value: "F\u00edsico (fluidos)"
    },
    {
        id: "213135",
        value: "F\u00edsico (instrumenta\u00e7\u00e3o)"
    },
    {
        id: "213215",
        value: "Tecn\u00f3logo em processos qu\u00edmicos"
    },
    {
        id: "213210",
        value: "Qu\u00edmico industrial"
    },
    {
        id: "213205",
        value: "Qu\u00edmico"
    },
    {
        id: "213305",
        value: "Astr\u00f4nomo"
    },
    {
        id: "213315",
        value: "Meteorologista"
    },
    {
        id: "213310",
        value: "Geof\u00edsico espacial"
    },
    {
        id: "213440",
        value: "Ocean\u00f3grafo"
    },
    {
        id: "213425",
        value: "Hidroge\u00f3logo"
    },
    {
        id: "213420",
        value: "Geoqu\u00edmico"
    },
    {
        id: "213415",
        value: "Geof\u00edsico"
    },
    {
        id: "213410",
        value: "Ge\u00f3logo de engenharia"
    },
    {
        id: "213435",
        value: "Petr\u00f3grafo"
    },
    {
        id: "213430",
        value: "Paleont\u00f3logo"
    },
    {
        id: "213405",
        value: "Ge\u00f3logo"
    },
    {
        id: "214010",
        value: "Tecn\u00f3logo em meio ambiente"
    },
    {
        id: "214005",
        value: "Engenheiro ambiental"
    },
    {
        id: "214105",
        value: "Arquiteto de edifica\u00e7\u00f5es"
    },
    {
        id: "214120",
        value: "Arquiteto paisagista"
    },
    {
        id: "214115",
        value: "Arquiteto de patrim\u00f4nio"
    },
    {
        id: "214110",
        value: "Arquiteto de interiores"
    },
    {
        id: "214130",
        value: "Urbanista"
    },
    {
        id: "214125",
        value: "Arquiteto urbanista"
    },
    {
        id: "214205",
        value: "Engenheiro civil"
    },
    {
        id: "214210",
        value: "Engenheiro civil (aeroportos)"
    },
    {
        id: "214215",
        value: "Engenheiro civil (edifica\u00e7\u00f5es)"
    },
    {
        id: "214220",
        value: "Engenheiro civil (estruturas met\u00e1licas)"
    },
    {
        id: "214225",
        value: "Engenheiro civil (ferrovias e metrovias)"
    },
    {
        id: "214230",
        value: "Engenheiro civil (geot\u00e9cnia)"
    },
    {
        id: "214235",
        value: "Engenheiro civil (hidrologia)"
    },
    {
        id: "214240",
        value: "Engenheiro civil (hidr\u00e1ulica)"
    },
    {
        id: "214245",
        value: "Engenheiro civil (pontes e viadutos)"
    },
    {
        id: "214250",
        value: "Engenheiro civil (portos e vias naveg\u00e1veis)"
    },
    {
        id: "214255",
        value: "Engenheiro civil (rodovias)"
    },
    {
        id: "214260",
        value: "Engenheiro civil (saneamento)"
    },
    {
        id: "214265",
        value: "Engenheiro civil (t\u00faneis)"
    },
    {
        id: "214270",
        value: "Engenheiro civil (transportes e tr\u00e2nsito)"
    },
    {
        id: "214280",
        value: "Tecn\u00f3logo em constru\u00e7\u00e3o civil"
    },
    {
        id: "214330",
        value: "Engenheiro eletr\u00f4nico de projetos"
    },
    {
        id: "214315",
        value: "Engenheiro eletricista de manuten\u00e7\u00e3o"
    },
    {
        id: "214320",
        value: "Engenheiro eletricista de projetos"
    },
    {
        id: "214325",
        value: "Engenheiro eletr\u00f4nico de manuten\u00e7\u00e3o"
    },
    {
        id: "214335",
        value: "Engenheiro de manuten\u00e7\u00e3o de telecomunica\u00e7\u00f5es"
    },
    {
        id: "214340",
        value: "Engenheiro de telecomunica\u00e7\u00f5es"
    },
    {
        id: "214345",
        value: "Engenheiro projetista de telecomunica\u00e7\u00f5es"
    },
    {
        id: "214350",
        value: "Engenheiro de redes de comunica\u00e7\u00e3o"
    },
    {
        id: "214360",
        value: "Tecn\u00f3logo em eletricidade"
    },
    {
        id: "214365",
        value: "Tecn\u00f3logo em eletr\u00f4nica"
    },
    {
        id: "214310",
        value: "Engenheiro eletr\u00f4nico"
    },
    {
        id: "214305",
        value: "Engenheiro eletricista"
    },
    {
        id: "214370",
        value: "Tecn\u00f3logo em telecomunica\u00e7\u00f5es"
    },
    {
        id: "214425",
        value: "Engenheiro aeron\u00e1utico"
    },
    {
        id: "214420",
        value: "Engenheiro mec\u00e2nico industrial"
    },
    {
        id: "214415",
        value: "Engenheiro mec\u00e2nico (energia nuclear)"
    },
    {
        id: "214410",
        value: "Engenheiro mec\u00e2nico automotivo"
    },
    {
        id: "214405",
        value: "Engenheiro mec\u00e2nico"
    },
    {
        id: "214430",
        value: "Engenheiro naval"
    },
    {
        id: "214435",
        value: "Tecn\u00f3logo em fabrica\u00e7\u00e3o mec\u00e2nica"
    },
    {
        id: "214535",
        value: "Tecn\u00f3logo em produ\u00e7\u00e3o sulcroalcooleira"
    },
    {
        id: "214520",
        value: "Engenheiro qu\u00edmico (papel e celulose)"
    },
    {
        id: "214525",
        value: "Engenheiro qu\u00edmico (petr\u00f3leo e borracha)"
    },
    {
        id: "214530",
        value: "Engenheiro qu\u00edmico (utilidades e meio ambiente)"
    },
    {
        id: "214515",
        value: "Engenheiro qu\u00edmico (minera\u00e7\u00e3o, metalurgia, siderurgia, cimenteira e cer\u00e2mica)"
    },
    {
        id: "214510",
        value: "Engenheiro qu\u00edmico (ind\u00fastria qu\u00edmica)"
    },
    {
        id: "214505",
        value: "Engenheiro qu\u00edmico"
    },
    {
        id: "214605",
        value: "Engenheiro de materiais"
    },
    {
        id: "214615",
        value: "Tecn\u00f3logo em metalurgia"
    },
    {
        id: "214610",
        value: "Engenheiro metalurgista"
    },
    {
        id: "214730",
        value: "Engenheiro de minas (planejamento)"
    },
    {
        id: "214735",
        value: "Engenheiro de minas (processo)"
    },
    {
        id: "214750",
        value: "Tecn\u00f3logo em rochas ornamentais"
    },
    {
        id: "214745",
        value: "Tecn\u00f3logo em petr\u00f3leo e g\u00e1s"
    },
    {
        id: "214740",
        value: "Engenheiro de minas (projeto)"
    },
    {
        id: "214705",
        value: "Engenheiro de minas"
    },
    {
        id: "214710",
        value: "Engenheiro de minas (beneficiamento)"
    },
    {
        id: "214715",
        value: "Engenheiro de minas (lavra a c\u00e9u aberto)"
    },
    {
        id: "214720",
        value: "Engenheiro de minas (lavra subterr\u00e2nea)"
    },
    {
        id: "214725",
        value: "Engenheiro de minas (pesquisa mineral)"
    },
    {
        id: "214810",
        value: "Engenheiro cart\u00f3grafo"
    },
    {
        id: "214805",
        value: "Engenheiro agrimensor"
    },
    {
        id: "214935",
        value: "Tecn\u00f3logo em seguran\u00e7a do trabalho"
    },
    {
        id: "214930",
        value: "Tecn\u00f3logo em produ\u00e7\u00e3o industrial"
    },
    {
        id: "214925",
        value: "Engenheiro de tempos e movimentos"
    },
    {
        id: "214905",
        value: "Engenheiro de produ\u00e7\u00e3o"
    },
    {
        id: "214910",
        value: "Engenheiro de controle de qualidade"
    },
    {
        id: "214940",
        value: "Higienista ocupacional"
    },
    {
        id: "214920",
        value: "Engenheiro de riscos"
    },
    {
        id: "214915",
        value: "Engenheiro de seguran\u00e7a do trabalho"
    },
    {
        id: "215105",
        value: "Agente de manobra e docagem"
    },
    {
        id: "215110",
        value: "Capit\u00e3o de manobra da marinha mercante"
    },
    {
        id: "215150",
        value: "Vistoriador naval"
    },
    {
        id: "215145",
        value: "Pr\u00e1tico de portos da marinha mercante"
    },
    {
        id: "215140",
        value: "Oficial de quarto de navega\u00e7\u00e3o da marinha mercante"
    },
    {
        id: "215135",
        value: "Inspetor naval"
    },
    {
        id: "215130",
        value: "Inspetor de terminal"
    },
    {
        id: "215125",
        value: "Imediato da marinha mercante"
    },
    {
        id: "215115",
        value: "Comandante da marinha mercante"
    },
    {
        id: "215120",
        value: "Coordenador de opera\u00e7\u00f5es de combate \u00e0 polui\u00e7\u00e3o no meio aquavi\u00e1rio"
    },
    {
        id: "215220",
        value: "Superintendente t\u00e9cnico no transporte aquavi\u00e1rio"
    },
    {
        id: "215215",
        value: "Segundo oficial de m\u00e1quinas da marinha mercante"
    },
    {
        id: "215210",
        value: "Primeiro oficial de m\u00e1quinas da marinha mercante"
    },
    {
        id: "215205",
        value: "Oficial superior de m\u00e1quinas da marinha mercante"
    },
    {
        id: "215310",
        value: "Piloto de ensaios em v\u00f4o"
    },
    {
        id: "215305",
        value: "Piloto de aeronaves"
    },
    {
        id: "215315",
        value: "Instrutor de v\u00f4o"
    },
    {
        id: "221105",
        value: "Bi\u00f3logo"
    },
    {
        id: "221205",
        value: "Biom\u00e9dico"
    },
    {
        id: "222105",
        value: "Engenheiro agr\u00edcola"
    },
    {
        id: "222110",
        value: "Engenheiro agr\u00f4nomo"
    },
    {
        id: "222115",
        value: "Engenheiro de pesca"
    },
    {
        id: "222120",
        value: "Engenheiro florestal"
    },
    {
        id: "222205",
        value: "Engenheiro de alimentos"
    },
    {
        id: "222215",
        value: "Tecn\u00f3logo em alimentos"
    },
    {
        id: "223264",
        value: "Cirurgi\u00e3o dentista - reabilitador oral"
    },
    {
        id: "223268",
        value: "Cirurgi\u00e3o dentista - traumatologista bucomaxilofacial"
    },
    {
        id: "223272",
        value: "Cirurgi\u00e3o dentista de sa\u00fade coletiva"
    },
    {
        id: "223276",
        value: "Cirurgi\u00e3o dentista - odontologia do trabalho"
    },
    {
        id: "223280",
        value: "Cirurgi\u00e3o dentista - dent\u00edstica"
    },
    {
        id: "223284",
        value: "Cirurgi\u00e3o dentista - disfun\u00e7\u00e3o temporomandibular e dor orofacial"
    },
    {
        id: "223288",
        value: "Cirurgi\u00e3o dentista - odontologia para pacientes com necessidades especiais"
    },
    {
        id: "223293",
        value: "Cirurgi\u00e3o-dentista da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "223260",
        value: "Cirurgi\u00e3o dentista - radiologista"
    },
    {
        id: "223256",
        value: "Cirurgi\u00e3o dentista - protesista"
    },
    {
        id: "223252",
        value: "Cirurgi\u00e3o dentista - protesi\u00f3logo bucomaxilofacial"
    },
    {
        id: "223248",
        value: "Cirurgi\u00e3o dentista - periodontista"
    },
    {
        id: "223244",
        value: "Cirurgi\u00e3o dentista - patologista bucal"
    },
    {
        id: "223240",
        value: "Cirurgi\u00e3o dentista - ortopedista e ortodontista"
    },
    {
        id: "223236",
        value: "Cirurgi\u00e3o dentista - odontopediatra"
    },
    {
        id: "223228",
        value: "Cirurgi\u00e3o dentista - odontogeriatra"
    },
    {
        id: "223232",
        value: "Cirurgi\u00e3o dentista - odontologista legal"
    },
    {
        id: "223224",
        value: "Cirurgi\u00e3o dentista - implantodontista"
    },
    {
        id: "223220",
        value: "Cirurgi\u00e3o dentista - estomatologista"
    },
    {
        id: "223216",
        value: "Cirurgi\u00e3o dentista - epidemiologista"
    },
    {
        id: "223212",
        value: "Cirurgi\u00e3o dentista - endodontista"
    },
    {
        id: "223208",
        value: "Cirurgi\u00e3o dentista - cl\u00ednico geral"
    },
    {
        id: "223204",
        value: "Cirurgi\u00e3o dentista - auditor"
    },
    {
        id: "223305",
        value: "M\u00e9dico veterin\u00e1rio"
    },
    {
        id: "223310",
        value: "Zootecnista"
    },
    {
        id: "223415",
        value: "Farmac\u00eautico analista cl\u00ednico"
    },
    {
        id: "223405",
        value: "Farmac\u00eautico"
    },
    {
        id: "223440",
        value: "Farmac\u00eautico toxicologista"
    },
    {
        id: "223435",
        value: "Farmac\u00eautico industrial"
    },
    {
        id: "223445",
        value: "Farmac\u00eautico hospitalar e cl\u00ednico"
    },
    {
        id: "223425",
        value: "Farmac\u00eautico pr\u00e1ticas integrativas e complementares"
    },
    {
        id: "223430",
        value: "Farmac\u00eautico em sa\u00fade p\u00fablica"
    },
    {
        id: "223420",
        value: "Farmac\u00eautico de alimentos"
    },
    {
        id: "223555",
        value: "Enfermeiro puericultor e pedi\u00e1trico"
    },
    {
        id: "223560",
        value: "Enfermeiro sanitarista"
    },
    {
        id: "223565",
        value: "Enfermeiro da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "223550",
        value: "Enfermeiro psiqui\u00e1trico"
    },
    {
        id: "223545",
        value: "Enfermeiro obst\u00e9trico"
    },
    {
        id: "223540",
        value: "Enfermeiro neonatologista"
    },
    {
        id: "223535",
        value: "Enfermeiro nefrologista"
    },
    {
        id: "223530",
        value: "Enfermeiro do trabalho"
    },
    {
        id: "223525",
        value: "Enfermeiro de terapia intensiva"
    },
    {
        id: "223520",
        value: "Enfermeiro de centro cir\u00fargico"
    },
    {
        id: "223570",
        value: "Perfusionista"
    },
    {
        id: "223505",
        value: "Enfermeiro"
    },
    {
        id: "223515",
        value: "Enfermeiro de bordo"
    },
    {
        id: "223510",
        value: "Enfermeiro auditor"
    },
    {
        id: "223655",
        value: "Fisioterapeuta esportivo"
    },
    {
        id: "223660",
        value: "Fisioterapeuta  do trabalho"
    },
    {
        id: "223645",
        value: "Fisioterapeuta quiropraxista"
    },
    {
        id: "223640",
        value: "Fisioterapeuta osteopata"
    },
    {
        id: "223635",
        value: "Fisioterapeuta traumato-ortop\u00e9dica funcional"
    },
    {
        id: "223630",
        value: "Fisioterapeuta neurofuncional"
    },
    {
        id: "223650",
        value: "Fisioterapeuta acupunturista"
    },
    {
        id: "223625",
        value: "Fisioterapeuta respirat\u00f3ria"
    },
    {
        id: "223605",
        value: "Fisioterapeuta geral"
    },
    {
        id: "223705",
        value: "Dietista"
    },
    {
        id: "223710",
        value: "Nutricionista"
    },
    {
        id: "223810",
        value: "Fonoaudi\u00f3logo geral"
    },
    {
        id: "223825",
        value: "Fonoaudi\u00f3logo em disfagia"
    },
    {
        id: "223830",
        value: "Fonoaudi\u00f3logo em linguagem"
    },
    {
        id: "223835",
        value: "Fonoaudi\u00f3logo em motricidade orofacial"
    },
    {
        id: "223820",
        value: "Fonoaudi\u00f3logo em audiologia"
    },
    {
        id: "223845",
        value: "Fonoaudi\u00f3logo em voz"
    },
    {
        id: "223840",
        value: "Fonoaudi\u00f3logo em sa\u00fade coletiva"
    },
    {
        id: "223815",
        value: "Fonoaudi\u00f3logo educacional"
    },
    {
        id: "223910",
        value: "Ortoptista"
    },
    {
        id: "223905",
        value: "Terapeuta ocupacional"
    },
    {
        id: "224110",
        value: "Ludomotricista"
    },
    {
        id: "224115",
        value: "Preparador de atleta"
    },
    {
        id: "224120",
        value: "Preparador f\u00edsico"
    },
    {
        id: "224105",
        value: "Avaliador f\u00edsico"
    },
    {
        id: "224130",
        value: "T\u00e9cnico de laborat\u00f3rio e fiscaliza\u00e7\u00e3o desportiva"
    },
    {
        id: "224135",
        value: "Treinador profissional de futebol"
    },
    {
        id: "224125",
        value: "T\u00e9cnico de desporto individual e coletivo (exceto futebol)"
    },
    {
        id: "225118",
        value: "M\u00e9dico nutrologista"
    },
    {
        id: "225185",
        value: "M\u00e9dico hematologista"
    },
    {
        id: "225180",
        value: "M\u00e9dico geriatra"
    },
    {
        id: "225175",
        value: "M\u00e9dico geneticista"
    },
    {
        id: "225170",
        value: "M\u00e9dico generalista"
    },
    {
        id: "225165",
        value: "M\u00e9dico gastroenterologista"
    },
    {
        id: "225160",
        value: "M\u00e9dico fisiatra"
    },
    {
        id: "225155",
        value: "M\u00e9dico endocrinologista e metabologista"
    },
    {
        id: "225154",
        value: "M\u00e9dico antropos\u00f3fico"
    },
    {
        id: "225151",
        value: "M\u00e9dico anestesiologista"
    },
    {
        id: "225150",
        value: "M\u00e9dico em medicina intensiva"
    },
    {
        id: "225148",
        value: "M\u00e9dico anatomopatologista"
    },
    {
        id: "225145",
        value: "M\u00e9dico em medicina de tr\u00e1fego"
    },
    {
        id: "225142",
        value: "M\u00e9dico da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "225140",
        value: "M\u00e9dico do trabalho"
    },
    {
        id: "225139",
        value: "M\u00e9dico sanitarista"
    },
    {
        id: "225136",
        value: "M\u00e9dico reumatologista"
    },
    {
        id: "225135",
        value: "M\u00e9dico dermatologista"
    },
    {
        id: "225103",
        value: "M\u00e9dico infectologista"
    },
    {
        id: "225105",
        value: "M\u00e9dico acupunturista"
    },
    {
        id: "225106",
        value: "M\u00e9dico legista"
    },
    {
        id: "225109",
        value: "M\u00e9dico nefrologista"
    },
    {
        id: "225110",
        value: "M\u00e9dico alergista e imunologista"
    },
    {
        id: "225112",
        value: "M\u00e9dico neurologista"
    },
    {
        id: "225115",
        value: "M\u00e9dico angiologista"
    },
    {
        id: "225195",
        value: "M\u00e9dico homeopata"
    },
    {
        id: "225120",
        value: "M\u00e9dico cardiologista"
    },
    {
        id: "225121",
        value: "M\u00e9dico oncologista cl\u00ednico"
    },
    {
        id: "225122",
        value: "M\u00e9dico cancerologista pedi\u00e1trico"
    },
    {
        id: "225124",
        value: "M\u00e9dico pediatra"
    },
    {
        id: "225125",
        value: "M\u00e9dico cl\u00ednico"
    },
    {
        id: "225127",
        value: "M\u00e9dico pneumologista"
    },
    {
        id: "225130",
        value: "M\u00e9dico de fam\u00edlia e comunidade"
    },
    {
        id: "225133",
        value: "M\u00e9dico psiquiatra"
    },
    {
        id: "225220",
        value: "M\u00e9dico cirurgi\u00e3o do aparelho digestivo"
    },
    {
        id: "225225",
        value: "M\u00e9dico cirurgi\u00e3o geral"
    },
    {
        id: "225210",
        value: "M\u00e9dico cirurgi\u00e3o cardiovascular"
    },
    {
        id: "225203",
        value: "M\u00e9dico em cirurgia vascular"
    },
    {
        id: "225295",
        value: "M\u00e9dico cirurgi\u00e3o da m\u00e3o"
    },
    {
        id: "225290",
        value: "M\u00e9dico cancerologista cirurg\u00edco"
    },
    {
        id: "225285",
        value: "M\u00e9dico urologista"
    },
    {
        id: "225280",
        value: "M\u00e9dico coloproctologista"
    },
    {
        id: "225275",
        value: "M\u00e9dico otorrinolaringologista"
    },
    {
        id: "225270",
        value: "M\u00e9dico ortopedista e traumatologista"
    },
    {
        id: "225265",
        value: "M\u00e9dico oftalmologista"
    },
    {
        id: "225260",
        value: "M\u00e9dico neurocirurgi\u00e3o"
    },
    {
        id: "225255",
        value: "M\u00e9dico mastologista"
    },
    {
        id: "225250",
        value: "M\u00e9dico ginecologista e obstetra"
    },
    {
        id: "225240",
        value: "M\u00e9dico cirurgi\u00e3o tor\u00e1cico"
    },
    {
        id: "225235",
        value: "M\u00e9dico cirurgi\u00e3o pl\u00e1stico"
    },
    {
        id: "225230",
        value: "M\u00e9dico cirurgi\u00e3o pedi\u00e1trico"
    },
    {
        id: "225215",
        value: "M\u00e9dico cirurgi\u00e3o de cabe\u00e7a e pesco\u00e7o"
    },
    {
        id: "225305",
        value: "M\u00e9dico citopatologista"
    },
    {
        id: "225310",
        value: "M\u00e9dico em endoscopia"
    },
    {
        id: "225315",
        value: "M\u00e9dico em medicina nuclear"
    },
    {
        id: "225320",
        value: "M\u00e9dico em radiologia e diagn\u00f3stico por imagem"
    },
    {
        id: "225325",
        value: "M\u00e9dico patologista"
    },
    {
        id: "225330",
        value: "M\u00e9dico radioterapeuta"
    },
    {
        id: "225335",
        value: "M\u00e9dico patologista cl\u00ednico \/ medicina laboratorial"
    },
    {
        id: "225340",
        value: "M\u00e9dico hemoterapeuta"
    },
    {
        id: "225345",
        value: "M\u00e9dico hiperbarista"
    },
    {
        id: "225350",
        value: "M\u00e9dico neurofisiologista cl\u00ednico"
    },
    {
        id: "226105",
        value: "Quiropraxista"
    },
    {
        id: "226110",
        value: "Osteopata"
    },
    {
        id: "226315",
        value: "Equoterapeuta"
    },
    {
        id: "226305",
        value: "Musicoterapeuta"
    },
    {
        id: "226320",
        value: "Natur\u00f3logo"
    },
    {
        id: "226310",
        value: "Arteterapeuta"
    },
    {
        id: "231110",
        value: "Professor de n\u00edvel superior na educa\u00e7\u00e3o infantil (zero a tr\u00eas anos)"
    },
    {
        id: "231105",
        value: "Professor de n\u00edvel superior na educa\u00e7\u00e3o infantil (quatro a seis anos)"
    },
    {
        id: "231205",
        value: "Professor da  educa\u00e7\u00e3o de jovens e adultos do ensino fundamental (primeira a quarta s\u00e9rie)"
    },
    {
        id: "231210",
        value: "Professor de n\u00edvel superior do ensino fundamental (primeira a quarta s\u00e9rie)"
    },
    {
        id: "231320",
        value: "Professor de geografia do ensino fundamental"
    },
    {
        id: "231325",
        value: "Professor de hist\u00f3ria do ensino fundamental"
    },
    {
        id: "231330",
        value: "Professor de l\u00edngua estrangeira moderna do ensino fundamental"
    },
    {
        id: "231315",
        value: "Professor de educa\u00e7\u00e3o f\u00edsica do ensino fundamental"
    },
    {
        id: "231310",
        value: "Professor de educa\u00e7\u00e3o art\u00edstica do ensino fundamental"
    },
    {
        id: "231335",
        value: "Professor de l\u00edngua portuguesa do ensino fundamental"
    },
    {
        id: "231340",
        value: "Professor de matem\u00e1tica do ensino fundamental"
    },
    {
        id: "231305",
        value: "Professor de ci\u00eancias exatas e naturais do ensino fundamental"
    },
    {
        id: "232105",
        value: "Professor de artes no ensino m\u00e9dio"
    },
    {
        id: "232120",
        value: "Professor de educa\u00e7\u00e3o f\u00edsica no ensino m\u00e9dio"
    },
    {
        id: "232125",
        value: "Professor de filosofia no ensino m\u00e9dio"
    },
    {
        id: "232130",
        value: "Professor de f\u00edsica no ensino m\u00e9dio"
    },
    {
        id: "232135",
        value: "Professor de geografia no ensino m\u00e9dio"
    },
    {
        id: "232145",
        value: "Professor de l\u00edngua e literatura brasileira no ensino m\u00e9dio"
    },
    {
        id: "232165",
        value: "Professor de qu\u00edmica no ensino m\u00e9dio"
    },
    {
        id: "232170",
        value: "Professor de sociologia no ensino m\u00e9dio"
    },
    {
        id: "232110",
        value: "Professor de biologia no ensino m\u00e9dio"
    },
    {
        id: "232115",
        value: "Professor de disciplinas pedag\u00f3gicas no ensino m\u00e9dio"
    },
    {
        id: "232140",
        value: "Professor de hist\u00f3ria no ensino m\u00e9dio"
    },
    {
        id: "232150",
        value: "Professor de l\u00edngua estrangeira moderna no ensino m\u00e9dio"
    },
    {
        id: "232160",
        value: "Professor de psicologia no ensino m\u00e9dio"
    },
    {
        id: "232155",
        value: "Professor de matem\u00e1tica no ensino m\u00e9dio"
    },
    {
        id: "233105",
        value: "Professor da \u00e1rea de meio ambiente"
    },
    {
        id: "233110",
        value: "Professor de desenho t\u00e9cnico"
    },
    {
        id: "233115",
        value: "Professor de t\u00e9cnicas agr\u00edcolas"
    },
    {
        id: "233120",
        value: "Professor de t\u00e9cnicas comerciais e secretariais"
    },
    {
        id: "233125",
        value: "Professor de t\u00e9cnicas de enfermagem"
    },
    {
        id: "233130",
        value: "Professor de t\u00e9cnicas industriais"
    },
    {
        id: "233135",
        value: "Professor de tecnologia e c\u00e1lculo t\u00e9cnico"
    },
    {
        id: "233205",
        value: "Instrutor de aprendizagem e treinamento agropecu\u00e1rio"
    },
    {
        id: "233210",
        value: "Instrutor de aprendizagem e treinamento industrial"
    },
    {
        id: "233215",
        value: "Instrutor de aprendizagem e treinamento comercial"
    },
    {
        id: "233220",
        value: "Professor instrutor de ensino e aprendizagem agroflorestal"
    },
    {
        id: "233225",
        value: "Professor instrutor de ensino e aprendizagem em servi\u00e7os"
    },
    {
        id: "234105",
        value: "Professor de matem\u00e1tica aplicada (no ensino superior)"
    },
    {
        id: "234110",
        value: "Professor de matem\u00e1tica pura (no ensino superior)"
    },
    {
        id: "234115",
        value: "Professor de estat\u00edstica (no ensino superior)"
    },
    {
        id: "234120",
        value: "Professor de computa\u00e7\u00e3o (no ensino superior)"
    },
    {
        id: "234125",
        value: "Professor de pesquisa operacional (no ensino superior)"
    },
    {
        id: "234205",
        value: "Professor de f\u00edsica (ensino superior)"
    },
    {
        id: "234215",
        value: "Professor de astronomia (ensino superior)"
    },
    {
        id: "234210",
        value: "Professor de qu\u00edmica (ensino superior)"
    },
    {
        id: "234305",
        value: "Professor de arquitetura"
    },
    {
        id: "234315",
        value: "Professor de geof\u00edsica"
    },
    {
        id: "234310",
        value: "Professor de engenharia"
    },
    {
        id: "234320",
        value: "Professor de geologia"
    },
    {
        id: "234405",
        value: "Professor de ci\u00eancias biol\u00f3gicas do ensino superior"
    },
    {
        id: "234415",
        value: "Professor de enfermagem do ensino superior"
    },
    {
        id: "234450",
        value: "Professor de odontologia"
    },
    {
        id: "234445",
        value: "Professor de nutri\u00e7\u00e3o"
    },
    {
        id: "234440",
        value: "Professor de medicina veterin\u00e1ria"
    },
    {
        id: "234410",
        value: "Professor de educa\u00e7\u00e3o f\u00edsica no ensino superior"
    },
    {
        id: "234455",
        value: "Professor de terapia ocupacional"
    },
    {
        id: "234460",
        value: "Professor de zootecnia do ensino superior"
    },
    {
        id: "234420",
        value: "Professor de farm\u00e1cia e bioqu\u00edmica"
    },
    {
        id: "234425",
        value: "Professor de fisioterapia"
    },
    {
        id: "234430",
        value: "Professor de fonoaudiologia"
    },
    {
        id: "234435",
        value: "Professor de medicina"
    },
    {
        id: "234510",
        value: "Professor de ensino superior na \u00e1rea de orienta\u00e7\u00e3o educacional"
    },
    {
        id: "234505",
        value: "Professor de ensino superior na \u00e1rea de did\u00e1tica"
    },
    {
        id: "234515",
        value: "Professor de ensino superior na \u00e1rea de pesquisa educacional"
    },
    {
        id: "234520",
        value: "Professor de ensino superior na \u00e1rea de pr\u00e1tica de ensino"
    },
    {
        id: "234628",
        value: "Professor de literatura brasileira"
    },
    {
        id: "234632",
        value: "Professor de literatura portuguesa"
    },
    {
        id: "234640",
        value: "Professor de literatura comparada"
    },
    {
        id: "234660",
        value: "Professor de literatura de l\u00ednguas estrangeiras modernas"
    },
    {
        id: "234668",
        value: "Professor de l\u00ednguas estrangeiras modernas"
    },
    {
        id: "234672",
        value: "Professor de ling\u00fc\u00edstica e ling\u00fc\u00edstica aplicada"
    },
    {
        id: "234676",
        value: "Professor de filologia e cr\u00edtica textual"
    },
    {
        id: "234680",
        value: "Professor de semi\u00f3tica"
    },
    {
        id: "234684",
        value: "Professor de teoria da literatura"
    },
    {
        id: "234604",
        value: "Professor de l\u00edngua alem\u00e3"
    },
    {
        id: "234608",
        value: "Professor de l\u00edngua italiana"
    },
    {
        id: "234612",
        value: "Professor de l\u00edngua francesa"
    },
    {
        id: "234616",
        value: "Professor de l\u00edngua inglesa"
    },
    {
        id: "234620",
        value: "Professor de l\u00edngua espanhola"
    },
    {
        id: "234636",
        value: "Professor de literatura alem\u00e3"
    },
    {
        id: "234644",
        value: "Professor de literatura espanhola"
    },
    {
        id: "234648",
        value: "Professor de literatura francesa"
    },
    {
        id: "234652",
        value: "Professor de literatura inglesa"
    },
    {
        id: "234656",
        value: "Professor de literatura italiana"
    },
    {
        id: "234664",
        value: "Professor de outras l\u00ednguas e literaturas"
    },
    {
        id: "234624",
        value: "Professor de l\u00edngua portuguesa"
    },
    {
        id: "234705",
        value: "Professor de antropologia do ensino superior"
    },
    {
        id: "234710",
        value: "Professor de arquivologia do ensino superior"
    },
    {
        id: "234770",
        value: "Professor de sociologia do ensino superior"
    },
    {
        id: "234765",
        value: "Professor de servi\u00e7o social do ensino superior"
    },
    {
        id: "234760",
        value: "Professor de psicologia do ensino superior"
    },
    {
        id: "234755",
        value: "Professor de museologia do ensino superior"
    },
    {
        id: "234715",
        value: "Professor de biblioteconomia do ensino superior"
    },
    {
        id: "234745",
        value: "Professor de hist\u00f3ria do ensino superior"
    },
    {
        id: "234740",
        value: "Professor de geografia do ensino superior"
    },
    {
        id: "234735",
        value: "Professor de filosofia do ensino superior"
    },
    {
        id: "234730",
        value: "Professor de direito do ensino superior"
    },
    {
        id: "234725",
        value: "Professor de comunica\u00e7\u00e3o social do ensino superior"
    },
    {
        id: "234720",
        value: "Professor de ci\u00eancia pol\u00edtica do ensino superior"
    },
    {
        id: "234750",
        value: "Professor de jornalismo"
    },
    {
        id: "234815",
        value: "Professor de contabilidade"
    },
    {
        id: "234805",
        value: "Professor de economia"
    },
    {
        id: "234810",
        value: "Professor de administra\u00e7\u00e3o"
    },
    {
        id: "234915",
        value: "Professor de m\u00fasica no ensino superior"
    },
    {
        id: "234910",
        value: "Professor de artes visuais no ensino superior (artes pl\u00e1sticas e multim\u00eddia)"
    },
    {
        id: "234905",
        value: "Professor de artes do espet\u00e1culo no ensino superior"
    },
    {
        id: "239205",
        value: "Professor de alunos com defici\u00eancia auditiva e surdos"
    },
    {
        id: "239210",
        value: "Professor de alunos com defici\u00eancia f\u00edsica"
    },
    {
        id: "239220",
        value: "Professor de alunos com defici\u00eancia m\u00faltipla"
    },
    {
        id: "239225",
        value: "Professor de alunos com defici\u00eancia visual"
    },
    {
        id: "239215",
        value: "Professor de alunos com defici\u00eancia mental"
    },
    {
        id: "239415",
        value: "Pedagogo"
    },
    {
        id: "239410",
        value: "Orientador educacional"
    },
    {
        id: "239405",
        value: "Coordenador pedag\u00f3gico"
    },
    {
        id: "239425",
        value: "Psicopedagogo"
    },
    {
        id: "239430",
        value: "Supervisor de ensino"
    },
    {
        id: "239435",
        value: "Designer educacional"
    },
    {
        id: "239420",
        value: "Professor de t\u00e9cnicas e recursos audiovisuais"
    },
    {
        id: "241040",
        value: "Consultor jur\u00eddico"
    },
    {
        id: "241035",
        value: "Advogado (direito do trabalho)"
    },
    {
        id: "241030",
        value: "Advogado (\u00e1reas especiais)"
    },
    {
        id: "241025",
        value: "Advogado (direito penal)"
    },
    {
        id: "241020",
        value: "Advogado (direito p\u00fablico)"
    },
    {
        id: "241015",
        value: "Advogado (direito civil)"
    },
    {
        id: "241010",
        value: "Advogado de empresa"
    },
    {
        id: "241005",
        value: "Advogado"
    },
    {
        id: "241225",
        value: "Procurador do munic\u00edpio"
    },
    {
        id: "241205",
        value: "Advogado da uni\u00e3o"
    },
    {
        id: "241235",
        value: "Procurador fundacional"
    },
    {
        id: "241230",
        value: "Procurador federal"
    },
    {
        id: "241210",
        value: "Procurador aut\u00e1rquico"
    },
    {
        id: "241220",
        value: "Procurador do estado"
    },
    {
        id: "241215",
        value: "Procurador da fazenda nacional"
    },
    {
        id: "241315",
        value: "Oficial do registro civil de pessoas naturais"
    },
    {
        id: "241340",
        value: "Tabeli\u00e3o de protestos"
    },
    {
        id: "241320",
        value: "Oficial do registro de distribui\u00e7\u00f5es"
    },
    {
        id: "241325",
        value: "Oficial do registro de im\u00f3veis"
    },
    {
        id: "241330",
        value: "Oficial do registro de t\u00edtulos e documentos"
    },
    {
        id: "241305",
        value: "Oficial de registro de contratos mar\u00edtimos"
    },
    {
        id: "241310",
        value: "Oficial do registro civil de pessoas jur\u00eddicas"
    },
    {
        id: "241335",
        value: "Tabeli\u00e3o de notas"
    },
    {
        id: "242220",
        value: "Procurador do trabalho"
    },
    {
        id: "242250",
        value: "Subprocurador-geral do trabalho"
    },
    {
        id: "242235",
        value: "Promotor de justi\u00e7a"
    },
    {
        id: "242210",
        value: "Procurador de justi\u00e7a"
    },
    {
        id: "242245",
        value: "Subprocurador-geral da rep\u00fablica"
    },
    {
        id: "242240",
        value: "Subprocurador de justi\u00e7a militar"
    },
    {
        id: "242205",
        value: "Procurador da rep\u00fablica"
    },
    {
        id: "242230",
        value: "Procurador regional do trabalho"
    },
    {
        id: "242225",
        value: "Procurador regional da rep\u00fablica"
    },
    {
        id: "242215",
        value: "Procurador de justi\u00e7a militar"
    },
    {
        id: "242305",
        value: "Delegado de pol\u00edcia"
    },
    {
        id: "242410",
        value: "Procurador da assist\u00eancia judici\u00e1ria"
    },
    {
        id: "242405",
        value: "Defensor p\u00fablico"
    },
    {
        id: "242910",
        value: "Oficial t\u00e9cnico de intelig\u00eancia"
    },
    {
        id: "242905",
        value: "Oficial de intelig\u00eancia"
    },
    {
        id: "251120",
        value: "Soci\u00f3logo"
    },
    {
        id: "251115",
        value: "Cientista pol\u00edtico"
    },
    {
        id: "251105",
        value: "Antrop\u00f3logo"
    },
    {
        id: "251110",
        value: "Arque\u00f3logo"
    },
    {
        id: "251210",
        value: "Economista agroindustrial"
    },
    {
        id: "251205",
        value: "Economista"
    },
    {
        id: "251215",
        value: "Economista financeiro"
    },
    {
        id: "251225",
        value: "Economista do setor p\u00fablico"
    },
    {
        id: "251230",
        value: "Economista ambiental"
    },
    {
        id: "251235",
        value: "Economista regional e urbano"
    },
    {
        id: "251220",
        value: "Economista industrial"
    },
    {
        id: "251305",
        value: "Ge\u00f3grafo"
    },
    {
        id: "251405",
        value: "Fil\u00f3sofo"
    },
    {
        id: "251505",
        value: "Psic\u00f3logo educacional"
    },
    {
        id: "251515",
        value: "Psic\u00f3logo do esporte"
    },
    {
        id: "251510",
        value: "Psic\u00f3logo cl\u00ednico"
    },
    {
        id: "251520",
        value: "Psic\u00f3logo hospitalar"
    },
    {
        id: "251525",
        value: "Psic\u00f3logo jur\u00eddico"
    },
    {
        id: "251530",
        value: "Psic\u00f3logo social"
    },
    {
        id: "251535",
        value: "Psic\u00f3logo do tr\u00e2nsito"
    },
    {
        id: "251540",
        value: "Psic\u00f3logo do trabalho"
    },
    {
        id: "251555",
        value: "Psic\u00f3logo acupunturista"
    },
    {
        id: "251550",
        value: "Psicanalista"
    },
    {
        id: "251545",
        value: "Neuropsic\u00f3logo"
    },
    {
        id: "251610",
        value: "Economista dom\u00e9stico"
    },
    {
        id: "251605",
        value: "Assistente social"
    },
    {
        id: "252105",
        value: "Administrador"
    },
    {
        id: "252205",
        value: "Auditor (contadores e afins)"
    },
    {
        id: "252210",
        value: "Contador"
    },
    {
        id: "252215",
        value: "Perito cont\u00e1bil"
    },
    {
        id: "252320",
        value: "Tecn\u00f3logo em secretariado escolar"
    },
    {
        id: "252310",
        value: "Secret\u00e1rio  bil\u00edng\u00fce"
    },
    {
        id: "252305",
        value: "Secret\u00e1ria(o) executiva(o)"
    },
    {
        id: "252315",
        value: "Secret\u00e1ria tril\u00edng\u00fce"
    },
    {
        id: "252405",
        value: "Analista de recursos humanos"
    },
    {
        id: "252530",
        value: "Analista de cr\u00e9dito rural"
    },
    {
        id: "252525",
        value: "Analista de cr\u00e9dito (institui\u00e7\u00f5es financeiras)"
    },
    {
        id: "252535",
        value: "Analista de leasing"
    },
    {
        id: "252515",
        value: "Analista de cobran\u00e7a (institui\u00e7\u00f5es financeiras)"
    },
    {
        id: "252545",
        value: "Analista financeiro (institui\u00e7\u00f5es financeiras)"
    },
    {
        id: "252550",
        value: "Profissional de rela\u00e7\u00f5es com investidores"
    },
    {
        id: "252540",
        value: "Analista de produtos banc\u00e1rios"
    },
    {
        id: "252505",
        value: "Administrador de fundos e carteiras de investimento"
    },
    {
        id: "252510",
        value: "Analista de c\u00e2mbio"
    },
    {
        id: "252605",
        value: "Gestor em seguran\u00e7a"
    },
    {
        id: "252705",
        value: "Analista de pcp (programa\u00e7\u00e3o e controle da produ\u00e7\u00e3o)"
    },
    {
        id: "252710",
        value: "Analista de planejamento de materias"
    },
    {
        id: "252720",
        value: "Analista de projetos logisticos"
    },
    {
        id: "252725",
        value: "Analista de gest\u00e3o de estoque"
    },
    {
        id: "252715",
        value: "Analista de logistica"
    },
    {
        id: "253115",
        value: "Publicit\u00e1rio"
    },
    {
        id: "253120",
        value: "Diretor de m\u00eddia (publicidade)"
    },
    {
        id: "253125",
        value: "Diretor de arte (publicidade)"
    },
    {
        id: "253130",
        value: "Diretor de cria\u00e7\u00e3o"
    },
    {
        id: "253135",
        value: "Diretor de contas (publicidade)"
    },
    {
        id: "253140",
        value: "Agenciador de propaganda"
    },
    {
        id: "253110",
        value: "Redator de publicidade"
    },
    {
        id: "253215",
        value: "Gerente de contas - pessoa f\u00edsica e jur\u00eddica"
    },
    {
        id: "253220",
        value: "Gerente de grandes contas (corporate)"
    },
    {
        id: "253225",
        value: "Operador de neg\u00f3cios"
    },
    {
        id: "253205",
        value: "Gerente de capta\u00e7\u00e3o (fundos e investimentos institucionais)"
    },
    {
        id: "253210",
        value: "Gerente de clientes especiais (private)"
    },
    {
        id: "253305",
        value: "Corretor de valores, ativos financeiros, mercadorias e derivativos"
    },
    {
        id: "254105",
        value: "Auditor-fiscal da receita federal"
    },
    {
        id: "254110",
        value: "T\u00e9cnico da receita federal"
    },
    {
        id: "254205",
        value: "Auditor-fiscal da previd\u00eancia social"
    },
    {
        id: "254305",
        value: "Auditor-fiscal do trabalho"
    },
    {
        id: "254310",
        value: "Agente de higiene e seguran\u00e7a"
    },
    {
        id: "254405",
        value: "Fiscal de tributos estadual"
    },
    {
        id: "254410",
        value: "Fiscal de tributos municipal"
    },
    {
        id: "254415",
        value: "T\u00e9cnico de tributos estadual"
    },
    {
        id: "254420",
        value: "T\u00e9cnico de tributos municipal"
    },
    {
        id: "254505",
        value: "Fiscal de atividades urbanas"
    },
    {
        id: "261125",
        value: "Jornalista"
    },
    {
        id: "261110",
        value: "Assessor de imprensa"
    },
    {
        id: "261115",
        value: "Diretor de reda\u00e7\u00e3o"
    },
    {
        id: "261120",
        value: "Editor"
    },
    {
        id: "261105",
        value: "Arquivista pesquisador (jornalismo)"
    },
    {
        id: "261130",
        value: "Produtor de texto"
    },
    {
        id: "261135",
        value: "Rep\u00f3rter (exclusive r\u00e1dio e televis\u00e3o)"
    },
    {
        id: "261140",
        value: "Revisor de texto"
    },
    {
        id: "261215",
        value: "Analista de informa\u00e7\u00f5es (pesquisador de informa\u00e7\u00f5es de rede)"
    },
    {
        id: "261210",
        value: "Documentalista"
    },
    {
        id: "261205",
        value: "Bibliotec\u00e1rio"
    },
    {
        id: "261305",
        value: "Arquivista"
    },
    {
        id: "261310",
        value: "Muse\u00f3logo"
    },
    {
        id: "261405",
        value: "Fil\u00f3logo"
    },
    {
        id: "261430",
        value: "Audiodescritor"
    },
    {
        id: "261425",
        value: "Int\u00e9rprete de l\u00edngua de sinais"
    },
    {
        id: "261420",
        value: "Tradutor"
    },
    {
        id: "261415",
        value: "Ling\u00fcista"
    },
    {
        id: "261410",
        value: "Int\u00e9rprete"
    },
    {
        id: "261520",
        value: "Escritor de n\u00e3o fic\u00e7\u00e3o"
    },
    {
        id: "261515",
        value: "Escritor de fic\u00e7\u00e3o"
    },
    {
        id: "261530",
        value: "Redator de textos t\u00e9cnicos"
    },
    {
        id: "261525",
        value: "Poeta"
    },
    {
        id: "261510",
        value: "Cr\u00edtico"
    },
    {
        id: "261505",
        value: "Autor-roteirista"
    },
    {
        id: "261610",
        value: "Editor de livro"
    },
    {
        id: "261615",
        value: "Editor de m\u00eddia eletr\u00f4nica"
    },
    {
        id: "261625",
        value: "Editor de revista cient\u00edfica"
    },
    {
        id: "261620",
        value: "Editor de revista"
    },
    {
        id: "261605",
        value: "Editor de jornal"
    },
    {
        id: "261715",
        value: "Locutor de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261710",
        value: "Comentarista de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261730",
        value: "Rep\u00f3rter de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261725",
        value: "Narrador em programas de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261720",
        value: "Locutor publicit\u00e1rio de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261705",
        value: "\u00c2ncora de r\u00e1dio e televis\u00e3o"
    },
    {
        id: "261820",
        value: "Rep\u00f3rter fotogr\u00e1fico"
    },
    {
        id: "261815",
        value: "Fot\u00f3grafo retratista"
    },
    {
        id: "261805",
        value: "Fot\u00f3grafo"
    },
    {
        id: "261810",
        value: "Fot\u00f3grafo publicit\u00e1rio"
    },
    {
        id: "262130",
        value: "Tecn\u00f3logo em produ\u00e7\u00e3o fonogr\u00e1fica"
    },
    {
        id: "262125",
        value: "Produtor de televis\u00e3o"
    },
    {
        id: "262120",
        value: "Produtor de teatro"
    },
    {
        id: "262115",
        value: "Produtor de r\u00e1dio"
    },
    {
        id: "262110",
        value: "Produtor cinematogr\u00e1fico"
    },
    {
        id: "262135",
        value: "Tecn\u00f3logo em produ\u00e7\u00e3o audiovisual"
    },
    {
        id: "262105",
        value: "Produtor cultural"
    },
    {
        id: "262205",
        value: "Diretor de cinema"
    },
    {
        id: "262210",
        value: "Diretor de programas de r\u00e1dio"
    },
    {
        id: "262215",
        value: "Diretor de programas de televis\u00e3o"
    },
    {
        id: "262220",
        value: "Diretor teatral"
    },
    {
        id: "262305",
        value: "Cen\u00f3grafo carnavalesco e festas populares"
    },
    {
        id: "262310",
        value: "Cen\u00f3grafo de cinema"
    },
    {
        id: "262315",
        value: "Cen\u00f3grafo de eventos"
    },
    {
        id: "262320",
        value: "Cen\u00f3grafo de teatro"
    },
    {
        id: "262325",
        value: "Cen\u00f3grafo de tv"
    },
    {
        id: "262330",
        value: "Diretor de arte"
    },
    {
        id: "262420",
        value: "Desenhista industrial de produto (designer de produto)"
    },
    {
        id: "262425",
        value: "Desenhista industrial de produto de moda (designer de moda)"
    },
    {
        id: "262405",
        value: "Artista (artes visuais)"
    },
    {
        id: "262415",
        value: "Conservador-restaurador de bens  culturais"
    },
    {
        id: "262410",
        value: "Desenhista industrial gr\u00e1fico (designer gr\u00e1fico)"
    },
    {
        id: "262505",
        value: "Ator"
    },
    {
        id: "262620",
        value: "Music\u00f3logo"
    },
    {
        id: "262615",
        value: "M\u00fasico regente"
    },
    {
        id: "262610",
        value: "M\u00fasico arranjador"
    },
    {
        id: "262605",
        value: "Compositor"
    },
    {
        id: "262705",
        value: "M\u00fasico int\u00e9rprete cantor"
    },
    {
        id: "262710",
        value: "M\u00fasico int\u00e9rprete instrumentista"
    },
    {
        id: "262805",
        value: "Assistente de coreografia"
    },
    {
        id: "262810",
        value: "Bailarino (exceto dan\u00e7as populares)"
    },
    {
        id: "262815",
        value: "Core\u00f3grafo"
    },
    {
        id: "262820",
        value: "Dramaturgo de dan\u00e7a"
    },
    {
        id: "262825",
        value: "Ensaiador de dan\u00e7a"
    },
    {
        id: "262830",
        value: "Professor de dan\u00e7a"
    },
    {
        id: "262905",
        value: "Decorador de interiores de n\u00edvel superior"
    },
    {
        id: "263115",
        value: "Te\u00f3logo"
    },
    {
        id: "263110",
        value: "Mission\u00e1rio"
    },
    {
        id: "263105",
        value: "Ministro de culto religioso"
    },
    {
        id: "271110",
        value: "Tecn\u00f3logo em gastronomia"
    },
    {
        id: "271105",
        value: "Chefe de cozinha"
    },
    {
        id: "300105",
        value: "T\u00e9cnico em mecatr\u00f4nica - automa\u00e7\u00e3o da manufatura"
    },
    {
        id: "300110",
        value: "T\u00e9cnico em mecatr\u00f4nica - rob\u00f3tica"
    },
    {
        id: "300305",
        value: "T\u00e9cnico em eletromec\u00e2nica"
    },
    {
        id: "301105",
        value: "T\u00e9cnico de laborat\u00f3rio industrial"
    },
    {
        id: "301110",
        value: "T\u00e9cnico de laborat\u00f3rio de an\u00e1lises f\u00edsico-qu\u00edmicas (materiais de constru\u00e7\u00e3o)"
    },
    {
        id: "301115",
        value: "T\u00e9cnico qu\u00edmico de petr\u00f3leo"
    },
    {
        id: "301205",
        value: "T\u00e9cnico de apoio \u00e0 bioengenharia"
    },
    {
        id: "311115",
        value: "T\u00e9cnico em curtimento"
    },
    {
        id: "311110",
        value: "T\u00e9cnico de celulose e papel"
    },
    {
        id: "311105",
        value: "T\u00e9cnico qu\u00edmico"
    },
    {
        id: "311205",
        value: "T\u00e9cnico em petroqu\u00edmica"
    },
    {
        id: "311305",
        value: "T\u00e9cnico em materiais, produtos cer\u00e2micos e vidros"
    },
    {
        id: "311405",
        value: "T\u00e9cnico em borracha"
    },
    {
        id: "311410",
        value: "T\u00e9cnico em pl\u00e1stico"
    },
    {
        id: "311515",
        value: "T\u00e9cnico de utilidade (produ\u00e7\u00e3o e distribui\u00e7\u00e3o de vapor, gases, \u00f3leos, combust\u00edveis, energia)"
    },
    {
        id: "311510",
        value: "T\u00e9cnico de meteorologia"
    },
    {
        id: "311505",
        value: "T\u00e9cnico de controle de meio ambiente"
    },
    {
        id: "311520",
        value: "T\u00e9cnico em tratamento de efluentes"
    },
    {
        id: "311605",
        value: "T\u00e9cnico t\u00eaxtil"
    },
    {
        id: "311610",
        value: "T\u00e9cnico t\u00eaxtil (tratamentos qu\u00edmicos)"
    },
    {
        id: "311615",
        value: "T\u00e9cnico t\u00eaxtil de fia\u00e7\u00e3o"
    },
    {
        id: "311620",
        value: "T\u00e9cnico t\u00eaxtil de malharia"
    },
    {
        id: "311625",
        value: "T\u00e9cnico t\u00eaxtil de tecelagem"
    },
    {
        id: "311705",
        value: "Colorista de papel"
    },
    {
        id: "311710",
        value: "Colorista t\u00eaxtil"
    },
    {
        id: "311715",
        value: "Preparador de tintas"
    },
    {
        id: "311720",
        value: "Preparador de tintas (f\u00e1brica de tecidos)"
    },
    {
        id: "311725",
        value: "Tingidor de couros e peles"
    },
    {
        id: "312105",
        value: "T\u00e9cnico de obras civis"
    },
    {
        id: "312210",
        value: "T\u00e9cnico de saneamento"
    },
    {
        id: "312205",
        value: "T\u00e9cnico de estradas"
    },
    {
        id: "312315",
        value: "T\u00e9cnico em hidrografia"
    },
    {
        id: "312310",
        value: "T\u00e9cnico em geod\u00e9sia e cartografia"
    },
    {
        id: "312320",
        value: "Top\u00f3grafo"
    },
    {
        id: "312305",
        value: "T\u00e9cnico em agrimensura"
    },
    {
        id: "313130",
        value: "T\u00e9cnico eletricista"
    },
    {
        id: "313125",
        value: "T\u00e9cnico de manuten\u00e7\u00e3o el\u00e9trica de m\u00e1quina"
    },
    {
        id: "313120",
        value: "T\u00e9cnico de manuten\u00e7\u00e3o el\u00e9trica"
    },
    {
        id: "313115",
        value: "Eletrot\u00e9cnico na fabrica\u00e7\u00e3o, montagem e instala\u00e7\u00e3o de m\u00e1quinas e equipamentos"
    },
    {
        id: "313110",
        value: "Eletrot\u00e9cnico (produ\u00e7\u00e3o de energia)"
    },
    {
        id: "313105",
        value: "Eletrot\u00e9cnico"
    },
    {
        id: "313215",
        value: "T\u00e9cnico eletr\u00f4nico"
    },
    {
        id: "313220",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de equipamentos de inform\u00e1tica"
    },
    {
        id: "313210",
        value: "T\u00e9cnico de manuten\u00e7\u00e3o eletr\u00f4nica (circuitos de m\u00e1quinas com comando num\u00e9rico)"
    },
    {
        id: "313205",
        value: "T\u00e9cnico de manuten\u00e7\u00e3o eletr\u00f4nica"
    },
    {
        id: "313320",
        value: "T\u00e9cnico de transmiss\u00e3o (telecomunica\u00e7\u00f5es)"
    },
    {
        id: "313315",
        value: "T\u00e9cnico de telecomunica\u00e7\u00f5es (telefonia)"
    },
    {
        id: "313310",
        value: "T\u00e9cnico de rede (telecomunica\u00e7\u00f5es)"
    },
    {
        id: "313305",
        value: "T\u00e9cnico de comunica\u00e7\u00e3o de dados"
    },
    {
        id: "313405",
        value: "T\u00e9cnico em calibra\u00e7\u00e3o"
    },
    {
        id: "313410",
        value: "T\u00e9cnico em instrumenta\u00e7\u00e3o"
    },
    {
        id: "313415",
        value: "Encarregado de manuten\u00e7\u00e3o de instrumentos de controle, medi\u00e7\u00e3o e similares"
    },
    {
        id: "313505",
        value: "T\u00e9cnico em fot\u00f4nica"
    },
    {
        id: "314105",
        value: "T\u00e9cnico em mec\u00e2nica de precis\u00e3o"
    },
    {
        id: "314110",
        value: "T\u00e9cnico mec\u00e2nico"
    },
    {
        id: "314115",
        value: "T\u00e9cnico mec\u00e2nico (calefa\u00e7\u00e3o, ventila\u00e7\u00e3o e refrigera\u00e7\u00e3o)"
    },
    {
        id: "314120",
        value: "T\u00e9cnico mec\u00e2nico (m\u00e1quinas)"
    },
    {
        id: "314125",
        value: "T\u00e9cnico mec\u00e2nico (motores)"
    },
    {
        id: "314205",
        value: "T\u00e9cnico mec\u00e2nico na fabrica\u00e7\u00e3o de ferramentas"
    },
    {
        id: "314210",
        value: "T\u00e9cnico mec\u00e2nico na manuten\u00e7\u00e3o de ferramentas"
    },
    {
        id: "314305",
        value: "T\u00e9cnico em automobil\u00edstica"
    },
    {
        id: "314310",
        value: "T\u00e9cnico mec\u00e2nico (aeronaves)"
    },
    {
        id: "314315",
        value: "T\u00e9cnico mec\u00e2nico (embarca\u00e7\u00f5es)"
    },
    {
        id: "314405",
        value: "T\u00e9cnico de manuten\u00e7\u00e3o de sistemas e instrumentos"
    },
    {
        id: "314410",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de m\u00e1quinas"
    },
    {
        id: "314620",
        value: "T\u00e9cnico em soldagem"
    },
    {
        id: "314615",
        value: "T\u00e9cnico em estruturas met\u00e1licas"
    },
    {
        id: "314610",
        value: "T\u00e9cnico em caldeiraria"
    },
    {
        id: "314605",
        value: "Inspetor de soldagem"
    },
    {
        id: "314625",
        value: "Tecn\u00f3logo em soldagem"
    },
    {
        id: "314725",
        value: "T\u00e9cnico de redu\u00e7\u00e3o na siderurgia (primeira fus\u00e3o)"
    },
    {
        id: "314720",
        value: "T\u00e9cnico de lamina\u00e7\u00e3o em siderurgia"
    },
    {
        id: "314715",
        value: "T\u00e9cnico de fundi\u00e7\u00e3o em siderurgia"
    },
    {
        id: "314710",
        value: "T\u00e9cnico de aciaria em siderurgia"
    },
    {
        id: "314705",
        value: "T\u00e9cnico de acabamento em siderurgia"
    },
    {
        id: "314730",
        value: "T\u00e9cnico de refrat\u00e1rio em siderurgia"
    },
    {
        id: "316115",
        value: "T\u00e9cnico em geoqu\u00edmica"
    },
    {
        id: "316110",
        value: "T\u00e9cnico em geologia"
    },
    {
        id: "316105",
        value: "T\u00e9cnico em geof\u00edsica"
    },
    {
        id: "316120",
        value: "T\u00e9cnico em geotecnia"
    },
    {
        id: "316325",
        value: "T\u00e9cnico de produ\u00e7\u00e3o em refino de petr\u00f3leo"
    },
    {
        id: "316330",
        value: "T\u00e9cnico em planejamento de lavra de minas"
    },
    {
        id: "316335",
        value: "Desincrustador (po\u00e7os de petr\u00f3leo)"
    },
    {
        id: "316320",
        value: "T\u00e9cnico em pesquisa mineral"
    },
    {
        id: "316315",
        value: "T\u00e9cnico em processamento mineral (exceto petr\u00f3leo)"
    },
    {
        id: "316340",
        value: "Cimentador (po\u00e7os de petr\u00f3leo)"
    },
    {
        id: "316305",
        value: "T\u00e9cnico de minera\u00e7\u00e3o"
    },
    {
        id: "316310",
        value: "T\u00e9cnico de minera\u00e7\u00e3o (\u00f3leo e petr\u00f3leo)"
    },
    {
        id: "317105",
        value: "Programador de internet"
    },
    {
        id: "317110",
        value: "Programador de sistemas de informa\u00e7\u00e3o"
    },
    {
        id: "317115",
        value: "Programador de m\u00e1quinas - ferramenta com comando num\u00e9rico"
    },
    {
        id: "317120",
        value: "Programador de multim\u00eddia"
    },
    {
        id: "317205",
        value: "Operador de computador (inclusive microcomputador)"
    },
    {
        id: "317210",
        value: "T\u00e9cnico de apoio ao usu\u00e1rio de inform\u00e1tica (helpdesk)"
    },
    {
        id: "318005",
        value: "Desenhista t\u00e9cnico"
    },
    {
        id: "318015",
        value: "Desenhista detalhista"
    },
    {
        id: "318010",
        value: "Desenhista copista"
    },
    {
        id: "318105",
        value: "Desenhista t\u00e9cnico (arquitetura)"
    },
    {
        id: "318110",
        value: "Desenhista t\u00e9cnico (cartografia)"
    },
    {
        id: "318115",
        value: "Desenhista t\u00e9cnico (constru\u00e7\u00e3o civil)"
    },
    {
        id: "318120",
        value: "Desenhista t\u00e9cnico (instala\u00e7\u00f5es hidrossanit\u00e1rias)"
    },
    {
        id: "318215",
        value: "Desenhista t\u00e9cnico naval"
    },
    {
        id: "318210",
        value: "Desenhista t\u00e9cnico aeron\u00e1utico"
    },
    {
        id: "318205",
        value: "Desenhista t\u00e9cnico mec\u00e2nico"
    },
    {
        id: "318310",
        value: "Desenhista t\u00e9cnico (calefa\u00e7\u00e3o, ventila\u00e7\u00e3o e refrigera\u00e7\u00e3o)"
    },
    {
        id: "318305",
        value: "Desenhista t\u00e9cnico (eletricidade e eletr\u00f4nica)"
    },
    {
        id: "318425",
        value: "Desenhista t\u00e9cnico (mobili\u00e1rio)"
    },
    {
        id: "318420",
        value: "Desenhista t\u00e9cnico (ind\u00fastria t\u00eaxtil)"
    },
    {
        id: "318415",
        value: "Desenhista t\u00e9cnico (ilustra\u00e7\u00f5es t\u00e9cnicas)"
    },
    {
        id: "318410",
        value: "Desenhista t\u00e9cnico (ilustra\u00e7\u00f5es art\u00edsticas)"
    },
    {
        id: "318430",
        value: "Desenhista t\u00e9cnico de embalagens, maquetes e leiautes"
    },
    {
        id: "318405",
        value: "Desenhista t\u00e9cnico (artes gr\u00e1ficas)"
    },
    {
        id: "318505",
        value: "Desenhista projetista de arquitetura"
    },
    {
        id: "318510",
        value: "Desenhista projetista de constru\u00e7\u00e3o civil"
    },
    {
        id: "318610",
        value: "Desenhista projetista mec\u00e2nico"
    },
    {
        id: "318605",
        value: "Desenhista projetista de m\u00e1quinas"
    },
    {
        id: "318705",
        value: "Desenhista projetista de eletricidade"
    },
    {
        id: "318710",
        value: "Desenhista projetista eletr\u00f4nico"
    },
    {
        id: "318810",
        value: "Modelista de roupas"
    },
    {
        id: "318805",
        value: "Projetista de m\u00f3veis"
    },
    {
        id: "318815",
        value: "Modelista de cal\u00e7ados"
    },
    {
        id: "319105",
        value: "T\u00e9cnico em cal\u00e7ados e artefatos de couro"
    },
    {
        id: "319110",
        value: "T\u00e9cnico em confec\u00e7\u00f5es do vestu\u00e1rio"
    },
    {
        id: "319205",
        value: "T\u00e9cnico do mobili\u00e1rio"
    },
    {
        id: "320110",
        value: "T\u00e9cnico em histologia"
    },
    {
        id: "320105",
        value: "T\u00e9cnico em bioterismo"
    },
    {
        id: "321105",
        value: "T\u00e9cnico agr\u00edcola"
    },
    {
        id: "321110",
        value: "T\u00e9cnico agropecu\u00e1rio"
    },
    {
        id: "321205",
        value: "T\u00e9cnico em madeira"
    },
    {
        id: "321210",
        value: "T\u00e9cnico florestal"
    },
    {
        id: "321320",
        value: "T\u00e9cnico em ranicultura"
    },
    {
        id: "321315",
        value: "T\u00e9cnico em mitilicultura"
    },
    {
        id: "321310",
        value: "T\u00e9cnico em carcinicultura"
    },
    {
        id: "321305",
        value: "T\u00e9cnico em piscicultura"
    },
    {
        id: "322130",
        value: "Esteticista"
    },
    {
        id: "322135",
        value: "Doula"
    },
    {
        id: "322125",
        value: "Terapeuta hol\u00edstico"
    },
    {
        id: "322120",
        value: "Massoterapeuta"
    },
    {
        id: "322115",
        value: "T\u00e9cnico em quiropraxia"
    },
    {
        id: "322105",
        value: "T\u00e9cnico em acupuntura"
    },
    {
        id: "322110",
        value: "Pod\u00f3logo"
    },
    {
        id: "322220",
        value: "T\u00e9cnico de enfermagem psiqui\u00e1trica"
    },
    {
        id: "322250",
        value: "Auxiliar de enfermagem da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "322205",
        value: "T\u00e9cnico de enfermagem"
    },
    {
        id: "322210",
        value: "T\u00e9cnico de enfermagem de terapia intensiva"
    },
    {
        id: "322215",
        value: "T\u00e9cnico de enfermagem do trabalho"
    },
    {
        id: "322245",
        value: "T\u00e9cnico de enfermagem da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "322225",
        value: "Instrumentador cir\u00fargico"
    },
    {
        id: "322230",
        value: "Auxiliar de enfermagem"
    },
    {
        id: "322235",
        value: "Auxiliar de enfermagem do trabalho"
    },
    {
        id: "322240",
        value: "Auxiliar de sa\u00fade (navega\u00e7\u00e3o mar\u00edtima)"
    },
    {
        id: "322305",
        value: "T\u00e9cnico em \u00f3ptica e optometria"
    },
    {
        id: "322420",
        value: "Auxiliar de pr\u00f3tese dent\u00e1ria"
    },
    {
        id: "322425",
        value: "T\u00e9cnico em sa\u00fade bucal da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "322430",
        value: "Auxiliar em sa\u00fade bucal da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        id: "322405",
        value: "T\u00e9cnico em sa\u00fade bucal"
    },
    {
        id: "322410",
        value: "Prot\u00e9tico dent\u00e1rio"
    },
    {
        id: "322415",
        value: "Auxiliar em sa\u00fade bucal"
    },
    {
        id: "322505",
        value: "T\u00e9cnico de ortopedia"
    },
    {
        id: "322605",
        value: "T\u00e9cnico de imobiliza\u00e7\u00e3o ortop\u00e9dica"
    },
    {
        id: "323105",
        value: "T\u00e9cnico em pecu\u00e1ria"
    },
    {
        id: "324130",
        value: "T\u00e9cnico em espirometria"
    },
    {
        id: "324125",
        value: "Tecn\u00f3logo oft\u00e1lmico"
    },
    {
        id: "324120",
        value: "Tecn\u00f3logo em radiologia"
    },
    {
        id: "324115",
        value: "T\u00e9cnico em radiologia e imagenologia"
    },
    {
        id: "324105",
        value: "T\u00e9cnico em m\u00e9todos eletrogr\u00e1ficos em encefalografia"
    },
    {
        id: "324110",
        value: "T\u00e9cnico em m\u00e9todos gr\u00e1ficos em cardiologia"
    },
    {
        id: "324205",
        value: "T\u00e9cnico em patologia cl\u00ednica"
    },
    {
        id: "324220",
        value: "T\u00e9cnico em hemoterapia"
    },
    {
        id: "324215",
        value: "Citot\u00e9cnico"
    },
    {
        id: "325015",
        value: "Perfumista"
    },
    {
        id: "325010",
        value: "Aromista"
    },
    {
        id: "325005",
        value: "En\u00f3logo"
    },
    {
        id: "325115",
        value: "T\u00e9cnico em farm\u00e1cia"
    },
    {
        id: "325110",
        value: "T\u00e9cnico em laborat\u00f3rio de farm\u00e1cia"
    },
    {
        id: "325105",
        value: "Auxiliar t\u00e9cnico em laborat\u00f3rio de farm\u00e1cia"
    },
    {
        id: "325205",
        value: "T\u00e9cnico de alimentos"
    },
    {
        id: "325210",
        value: "T\u00e9cnico em nutri\u00e7\u00e3o e diet\u00e9tica"
    },
    {
        id: "325310",
        value: "T\u00e9cnico em imunobiol\u00f3gicos"
    },
    {
        id: "325305",
        value: "T\u00e9cnico em biotecnologia"
    },
    {
        id: "328105",
        value: "Embalsamador"
    },
    {
        id: "328110",
        value: "Taxidermista"
    },
    {
        id: "331110",
        value: "Auxiliar de desenvolvimento infantil"
    },
    {
        id: "331105",
        value: "Professor de n\u00edvel m\u00e9dio na educa\u00e7\u00e3o infantil"
    },
    {
        id: "331205",
        value: "Professor de n\u00edvel m\u00e9dio no ensino fundamental"
    },
    {
        id: "331305",
        value: "Professor de n\u00edvel m\u00e9dio no ensino profissionalizante"
    },
    {
        id: "332105",
        value: "Professor leigo no ensino fundamental"
    },
    {
        id: "332205",
        value: "Professor pr\u00e1tico no ensino profissionalizante"
    },
    {
        id: "333105",
        value: "Instrutor de auto-escola"
    },
    {
        id: "333110",
        value: "Instrutor de cursos livres"
    },
    {
        id: "333115",
        value: "Professores de cursos livres"
    },
    {
        id: "334110",
        value: "Inspetor de alunos de escola p\u00fablica"
    },
    {
        id: "334105",
        value: "Inspetor de alunos de escola privada"
    },
    {
        id: "334115",
        value: "Monitor de transporte escolar"
    },
    {
        id: "341120",
        value: "Piloto agr\u00edcola"
    },
    {
        id: "341115",
        value: "Mec\u00e2nico de v\u00f4o"
    },
    {
        id: "341110",
        value: "Piloto comercial de helic\u00f3ptero (exceto linhas a\u00e9reas)"
    },
    {
        id: "341105",
        value: "Piloto comercial (exceto linhas a\u00e9reas)"
    },
    {
        id: "341250",
        value: "Auxiliar t\u00e9cnico de sinaliza\u00e7\u00e3o nautica"
    },
    {
        id: "341230",
        value: "Piloto fluvial"
    },
    {
        id: "341225",
        value: "Patr\u00e3o de pesca na navega\u00e7\u00e3o interior"
    },
    {
        id: "341220",
        value: "Patr\u00e3o de pesca de alto-mar"
    },
    {
        id: "341215",
        value: "Mestre fluvial"
    },
    {
        id: "341210",
        value: "Mestre de cabotagem"
    },
    {
        id: "341205",
        value: "Contramestre de cabotagem"
    },
    {
        id: "341235",
        value: "T\u00e9nico em sinaliza\u00e7\u00e3o nautica"
    },
    {
        id: "341245",
        value: "T\u00e9cnico em sinais navais"
    },
    {
        id: "341240",
        value: "T\u00e9cnicos em manobras em equipamentos de conv\u00e9s"
    },
    {
        id: "341305",
        value: "Condutor maquinista motorista fluvial"
    },
    {
        id: "341320",
        value: "Condutor de m\u00e1quinas (bombeador)"
    },
    {
        id: "341310",
        value: "Condutor de m\u00e1quinas"
    },
    {
        id: "341315",
        value: "Eletricista de bordo"
    },
    {
        id: "341325",
        value: "Condutor de m\u00e1quinas (mec\u00e2nico)"
    },
    {
        id: "342105",
        value: "Analista de transporte em com\u00e9rcio exterior"
    },
    {
        id: "342110",
        value: "Operador de transporte multimodal"
    },
    {
        id: "342115",
        value: "Controlador de servi\u00e7os de m\u00e1quinas e ve\u00edculos"
    },
    {
        id: "342120",
        value: "Afretador"
    },
    {
        id: "342125",
        value: "Tecn\u00f3logo em log\u00edstica de transporte"
    },
    {
        id: "342215",
        value: "Analista de desembara\u00e7o aduaneiro"
    },
    {
        id: "342205",
        value: "Ajudante de despachante aduaneiro"
    },
    {
        id: "342210",
        value: "Despachante aduaneiro"
    },
    {
        id: "342315",
        value: "Supervisor de carga e descarga"
    },
    {
        id: "342305",
        value: "Chefe de servi\u00e7o de transporte rodovi\u00e1rio (passageiros e cargas)"
    },
    {
        id: "342310",
        value: "Inspetor de servi\u00e7os de transportes rodovi\u00e1rios (passageiros e cargas)"
    },
    {
        id: "342405",
        value: "Agente de esta\u00e7\u00e3o (ferrovia e metr\u00f4)"
    },
    {
        id: "342410",
        value: "Operador de centro de controle (ferrovia e metr\u00f4)"
    },
    {
        id: "342515",
        value: "Fiscal de avia\u00e7\u00e3o civil (fac)"
    },
    {
        id: "342510",
        value: "Despachante operacional de v\u00f4o"
    },
    {
        id: "342505",
        value: "Controlador de tr\u00e1fego a\u00e9reo"
    },
    {
        id: "342550",
        value: "Agente de prote\u00e7\u00e3o de avia\u00e7\u00e3o civil"
    },
    {
        id: "342545",
        value: "Supervisor de empresa a\u00e9rea em aeroportos"
    },
    {
        id: "342540",
        value: "Supervisor da administra\u00e7\u00e3o de aeroportos"
    },
    {
        id: "342535",
        value: "Operador de atendimento aerovi\u00e1rio"
    },
    {
        id: "342520",
        value: "Gerente da administra\u00e7\u00e3o de aeroportos"
    },
    {
        id: "342525",
        value: "Gerente de empresa a\u00e9rea em aeroportos"
    },
    {
        id: "342530",
        value: "Inspetor de avia\u00e7\u00e3o civil"
    },
    {
        id: "342605",
        value: "Chefe de esta\u00e7\u00e3o portu\u00e1ria"
    },
    {
        id: "342610",
        value: "Supervisor de opera\u00e7\u00f5es portu\u00e1rias"
    },
    {
        id: "351105",
        value: "T\u00e9cnico de contabilidade"
    },
    {
        id: "351110",
        value: "Chefe de contabilidade (t\u00e9cnico)"
    },
    {
        id: "351115",
        value: "Consultor cont\u00e1bil (t\u00e9cnico)"
    },
    {
        id: "351305",
        value: "T\u00e9cnico em administra\u00e7\u00e3o"
    },
    {
        id: "351310",
        value: "T\u00e9cnico em administra\u00e7\u00e3o de com\u00e9rcio exterior"
    },
    {
        id: "351315",
        value: "Agente de recrutamento e sele\u00e7\u00e3o"
    },
    {
        id: "351405",
        value: "Escrevente"
    },
    {
        id: "351410",
        value: "Escriv\u00e3o judicial"
    },
    {
        id: "351430",
        value: "Auxiliar de servi\u00e7os jur\u00eddicos"
    },
    {
        id: "351425",
        value: "Oficial de justi\u00e7a"
    },
    {
        id: "351415",
        value: "Escriv\u00e3o extra - judicial"
    },
    {
        id: "351420",
        value: "Escriv\u00e3o de pol\u00edcia"
    },
    {
        id: "351510",
        value: "Taqu\u00edgrafo"
    },
    {
        id: "351505",
        value: "T\u00e9cnico em secretariado"
    },
    {
        id: "351515",
        value: "Estenotipista"
    },
    {
        id: "351610",
        value: "T\u00e9cnico em higiene ocupacional"
    },
    {
        id: "351605",
        value: "T\u00e9cnico em seguran\u00e7a do trabalho"
    },
    {
        id: "351705",
        value: "Analista de seguros (t\u00e9cnico)"
    },
    {
        id: "351725",
        value: "Inspetor de risco"
    },
    {
        id: "351740",
        value: "T\u00e9cnico de seguros"
    },
    {
        id: "351735",
        value: "T\u00e9cnico de resseguros"
    },
    {
        id: "351730",
        value: "Inspetor de sinistros"
    },
    {
        id: "351720",
        value: "Assistente t\u00e9cnico de seguros"
    },
    {
        id: "351715",
        value: "Assistente comercial de seguros"
    },
    {
        id: "351710",
        value: "Analista de sinistros"
    },
    {
        id: "351810",
        value: "Investigador de pol\u00edcia"
    },
    {
        id: "351805",
        value: "Detetive profissional"
    },
    {
        id: "351815",
        value: "Papiloscopista policial"
    },
    {
        id: "351910",
        value: "Agente t\u00e9cnico de intelig\u00eancia"
    },
    {
        id: "351905",
        value: "Agente de intelig\u00eancia"
    },
    {
        id: "352205",
        value: "Agente de defesa ambiental"
    },
    {
        id: "352210",
        value: "Agente de sa\u00fade p\u00fablica"
    },
    {
        id: "352305",
        value: "Metrologista"
    },
    {
        id: "352315",
        value: "Agente fiscal metrol\u00f3gico"
    },
    {
        id: "352310",
        value: "Agente fiscal de qualidade"
    },
    {
        id: "352320",
        value: "Agente fiscal t\u00eaxtil"
    },
    {
        id: "352410",
        value: "Avaliador de produtos do meio de comunica\u00e7\u00e3o"
    },
    {
        id: "352405",
        value: "Agente de direitos autorais"
    },
    {
        id: "352420",
        value: "T\u00e9cnico em direitos autorais"
    },
    {
        id: "353215",
        value: "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - cr\u00e9dito rural"
    },
    {
        id: "353220",
        value: "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - leasing"
    },
    {
        id: "353225",
        value: "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - renda fixa e vari\u00e1vel"
    },
    {
        id: "353210",
        value: "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - cr\u00e9dito imobili\u00e1rio"
    },
    {
        id: "353235",
        value: "Chefe de servi\u00e7os banc\u00e1rios"
    },
    {
        id: "353230",
        value: "Tesoureiro de banco"
    },
    {
        id: "353205",
        value: "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - c\u00e2mbio"
    },
    {
        id: "354140",
        value: "T\u00e9cnico em atendimento e vendas"
    },
    {
        id: "354135",
        value: "T\u00e9cnico de vendas"
    },
    {
        id: "354130",
        value: "Promotor de vendas especializado"
    },
    {
        id: "354125",
        value: "Assistente de vendas"
    },
    {
        id: "354120",
        value: "Agente de vendas de servi\u00e7os"
    },
    {
        id: "354145",
        value: "Vendedor pracista"
    },
    {
        id: "354150",
        value: "Propagandista de produtos famac\u00eauticos"
    },
    {
        id: "354205",
        value: "Comprador"
    },
    {
        id: "354210",
        value: "Supervisor de compras"
    },
    {
        id: "354305",
        value: "Analista de exporta\u00e7\u00e3o e importa\u00e7\u00e3o"
    },
    {
        id: "354410",
        value: "Avaliador de im\u00f3veis"
    },
    {
        id: "354415",
        value: "Avaliador de bens m\u00f3veis"
    },
    {
        id: "354405",
        value: "Leiloeiro"
    },
    {
        id: "354505",
        value: "Corretor de seguros"
    },
    {
        id: "354605",
        value: "Corretor de im\u00f3veis"
    },
    {
        id: "354705",
        value: "Representante comercial aut\u00f4nomo"
    },
    {
        id: "354820",
        value: "Organizador de evento"
    },
    {
        id: "354815",
        value: "Agente de viagem"
    },
    {
        id: "354810",
        value: "Operador de turismo"
    },
    {
        id: "354805",
        value: "T\u00e9cnico em turismo"
    },
    {
        id: "354825",
        value: "Cerimonialista"
    },
    {
        id: "371105",
        value: "Auxiliar de biblioteca"
    },
    {
        id: "371110",
        value: "T\u00e9cnico em biblioteconomia"
    },
    {
        id: "371210",
        value: "T\u00e9cnico em museologia"
    },
    {
        id: "371205",
        value: "Colecionador de selos e moedas"
    },
    {
        id: "371305",
        value: "T\u00e9cnico em programa\u00e7\u00e3o visual"
    },
    {
        id: "371310",
        value: "T\u00e9cnico gr\u00e1fico"
    },
    {
        id: "371405",
        value: "Recreador de acantonamento"
    },
    {
        id: "371410",
        value: "Recreador"
    },
    {
        id: "372105",
        value: "Diretor de fotografia"
    },
    {
        id: "372110",
        value: "Iluminador (televis\u00e3o)"
    },
    {
        id: "372115",
        value: "Operador de c\u00e2mera de televis\u00e3o"
    },
    {
        id: "372205",
        value: "Operador de rede de teleprocessamento"
    },
    {
        id: "372210",
        value: "Radiotelegrafista"
    },
    {
        id: "373105",
        value: "Operador de \u00e1udio de continuidade (r\u00e1dio)"
    },
    {
        id: "373110",
        value: "Operador de central de r\u00e1dio"
    },
    {
        id: "373115",
        value: "Operador de externa (r\u00e1dio)"
    },
    {
        id: "373120",
        value: "Operador de grava\u00e7\u00e3o de r\u00e1dio"
    },
    {
        id: "373125",
        value: "Operador de transmissor de r\u00e1dio"
    },
    {
        id: "373205",
        value: "T\u00e9cnico em opera\u00e7\u00e3o de equipamentos de produ\u00e7\u00e3o para televis\u00e3o  e produtoras de v\u00eddeo"
    },
    {
        id: "373210",
        value: "T\u00e9cnico em opera\u00e7\u00e3o de equipamento de exibi\u00e7\u00e3o de televis\u00e3o"
    },
    {
        id: "373215",
        value: "T\u00e9cnico em opera\u00e7\u00e3o de equipamentos de transmiss\u00e3o\/recep\u00e7\u00e3o de televis\u00e3o"
    },
    {
        id: "373220",
        value: "Supervisor t\u00e9cnico operacional de sistemas de televis\u00e3o e produtoras de v\u00eddeo"
    },
    {
        id: "374120",
        value: "Projetista de som"
    },
    {
        id: "374125",
        value: "T\u00e9cnico em sonoriza\u00e7\u00e3o"
    },
    {
        id: "374115",
        value: "T\u00e9cnico em masteriza\u00e7\u00e3o de \u00e1udio"
    },
    {
        id: "374110",
        value: "T\u00e9cnico em instala\u00e7\u00e3o de equipamentos de \u00e1udio"
    },
    {
        id: "374105",
        value: "T\u00e9cnico em grava\u00e7\u00e3o de \u00e1udio"
    },
    {
        id: "374145",
        value: "Dj (disc jockey)"
    },
    {
        id: "374140",
        value: "Microfonista"
    },
    {
        id: "374135",
        value: "Projetista de sistemas de \u00e1udio"
    },
    {
        id: "374130",
        value: "T\u00e9cnico em mixagem de \u00e1udio"
    },
    {
        id: "374205",
        value: "Cenot\u00e9cnico (cinema, v\u00eddeo, televis\u00e3o, teatro e espet\u00e1culos)"
    },
    {
        id: "374210",
        value: "Maquinista de cinema e v\u00eddeo"
    },
    {
        id: "374215",
        value: "Maquinista de teatro e espet\u00e1culos"
    },
    {
        id: "374310",
        value: "Operador-mantenedor de projetor cinematogr\u00e1fico"
    },
    {
        id: "374305",
        value: "Operador de projetor cinematogr\u00e1fico"
    },
    {
        id: "374415",
        value: "Finalizador de v\u00eddeo"
    },
    {
        id: "374410",
        value: "Finalizador de filmes"
    },
    {
        id: "374420",
        value: "Montador de filmes"
    },
    {
        id: "374405",
        value: "Editor de tv  e v\u00eddeo"
    },
    {
        id: "375105",
        value: "Designer de interiores"
    },
    {
        id: "375120",
        value: "Decorador de eventos"
    },
    {
        id: "375115",
        value: "Visual merchandiser"
    },
    {
        id: "375110",
        value: "Designer de vitrines"
    },
    {
        id: "376105",
        value: "Dan\u00e7arino tradicional"
    },
    {
        id: "376110",
        value: "Dan\u00e7arino popular"
    },
    {
        id: "376250",
        value: "Titeriteiro"
    },
    {
        id: "376255",
        value: "Trapezista"
    },
    {
        id: "376245",
        value: "Palha\u00e7o"
    },
    {
        id: "376240",
        value: "Malabarista"
    },
    {
        id: "376235",
        value: "M\u00e1gico"
    },
    {
        id: "376230",
        value: "Equilibrista"
    },
    {
        id: "376225",
        value: "Domador de animais (circense)"
    },
    {
        id: "376220",
        value: "Contorcionista"
    },
    {
        id: "376215",
        value: "Artista de circo (outros)"
    },
    {
        id: "376210",
        value: "Artista a\u00e9reo"
    },
    {
        id: "376205",
        value: "Acrobata"
    },
    {
        id: "376330",
        value: "Mestre de cerimonias"
    },
    {
        id: "376315",
        value: "Apresentador de programas de r\u00e1dio"
    },
    {
        id: "376320",
        value: "Apresentador de programas de televis\u00e3o"
    },
    {
        id: "376305",
        value: "Apresentador de eventos"
    },
    {
        id: "376310",
        value: "Apresentador de festas populares"
    },
    {
        id: "376325",
        value: "Apresentador de circo"
    },
    {
        id: "376410",
        value: "Modelo de modas"
    },
    {
        id: "376415",
        value: "Modelo publicit\u00e1rio"
    },
    {
        id: "376405",
        value: "Modelo art\u00edstico"
    },
    {
        id: "377135",
        value: "Piloto de competi\u00e7\u00e3o automobil\u00edstica"
    },
    {
        id: "377140",
        value: "Profissional de atletismo"
    },
    {
        id: "377145",
        value: "Pugilista"
    },
    {
        id: "377105",
        value: "Atleta profissional (outras modalidades)"
    },
    {
        id: "377110",
        value: "Atleta profissional de futebol"
    },
    {
        id: "377115",
        value: "Atleta profissional de golfe"
    },
    {
        id: "377120",
        value: "Atleta profissional de luta"
    },
    {
        id: "377125",
        value: "Atleta profissional de t\u00eanis"
    },
    {
        id: "377130",
        value: "J\u00f3quei"
    },
    {
        id: "377205",
        value: "\u00c1rbitro desportivo"
    },
    {
        id: "377210",
        value: "\u00c1rbitro de atletismo"
    },
    {
        id: "377215",
        value: "\u00c1rbitro de basquete"
    },
    {
        id: "377220",
        value: "\u00c1rbitro de futebol"
    },
    {
        id: "377245",
        value: "\u00c1rbitro de v\u00f4lei"
    },
    {
        id: "377230",
        value: "\u00c1rbitro de jud\u00f4"
    },
    {
        id: "377235",
        value: "\u00c1rbitro de karat\u00ea"
    },
    {
        id: "377240",
        value: "\u00c1rbitro de pol\u00f3 aqu\u00e1tico"
    },
    {
        id: "377225",
        value: "\u00c1rbitro de futebol de sal\u00e3o"
    },
    {
        id: "391105",
        value: "Cronoanalista"
    },
    {
        id: "391110",
        value: "Cronometrista"
    },
    {
        id: "391115",
        value: "Controlador de entrada e sa\u00edda"
    },
    {
        id: "391120",
        value: "Planejista"
    },
    {
        id: "391125",
        value: "T\u00e9cnico de planejamento de produ\u00e7\u00e3o"
    },
    {
        id: "391130",
        value: "T\u00e9cnico de planejamento e programa\u00e7\u00e3o da manuten\u00e7\u00e3o"
    },
    {
        id: "391135",
        value: "T\u00e9cnico de mat\u00e9ria-prima e material"
    },
    {
        id: "391225",
        value: "Escolhedor de papel"
    },
    {
        id: "391230",
        value: "T\u00e9cnico operacional de servi\u00e7os de correios"
    },
    {
        id: "391205",
        value: "Inspetor de qualidade"
    },
    {
        id: "391210",
        value: "T\u00e9cnico de garantia da qualidade"
    },
    {
        id: "391215",
        value: "Operador de inspe\u00e7\u00e3o de qualidade"
    },
    {
        id: "391220",
        value: "T\u00e9cnico de painel de controle"
    },
    {
        id: "395110",
        value: "T\u00e9cnico de apoio em pesquisa e desenvolvimento agropecu\u00e1rio florestal"
    },
    {
        id: "395105",
        value: "T\u00e9cnico de apoio em pesquisa e desenvolvimento (exceto agropecu\u00e1rio e florestal)"
    },
    {
        id: "410105",
        value: "Supervisor administrativo"
    },
    {
        id: "410225",
        value: "Supervisor de cr\u00e9dito e cobran\u00e7a"
    },
    {
        id: "410220",
        value: "Supervisor de controle patrimonial"
    },
    {
        id: "410215",
        value: "Supervisor de contas a pagar"
    },
    {
        id: "410235",
        value: "Supervisor de tesouraria"
    },
    {
        id: "410205",
        value: "Supervisor de almoxarifado"
    },
    {
        id: "410240",
        value: "Supervisor de log\u00edstica"
    },
    {
        id: "410230",
        value: "Supervisor de or\u00e7amento"
    },
    {
        id: "410210",
        value: "Supervisor de c\u00e2mbio"
    },
    {
        id: "411050",
        value: "Agente de microcr\u00e9dito"
    },
    {
        id: "411005",
        value: "Auxiliar de escrit\u00f3rio"
    },
    {
        id: "411010",
        value: "Assistente administrativo"
    },
    {
        id: "411015",
        value: "Atendente de judici\u00e1rio"
    },
    {
        id: "411020",
        value: "Auxiliar de judici\u00e1rio"
    },
    {
        id: "411025",
        value: "Auxiliar de cart\u00f3rio"
    },
    {
        id: "411030",
        value: "Auxiliar de pessoal"
    },
    {
        id: "411035",
        value: "Auxiliar de estat\u00edstica"
    },
    {
        id: "411040",
        value: "Auxiliar de seguros"
    },
    {
        id: "411045",
        value: "Auxiliar de servi\u00e7os de importa\u00e7\u00e3o e exporta\u00e7\u00e3o"
    },
    {
        id: "412105",
        value: "Datil\u00f3grafo"
    },
    {
        id: "412110",
        value: "Digitador"
    },
    {
        id: "412115",
        value: "Operador de mensagens de telecomunica\u00e7\u00f5es (correios)"
    },
    {
        id: "412120",
        value: "Supervisor de digita\u00e7\u00e3o e opera\u00e7\u00e3o"
    },
    {
        id: "412205",
        value: "Cont\u00ednuo"
    },
    {
        id: "413105",
        value: "Analista de folha de pagamento"
    },
    {
        id: "413110",
        value: "Auxiliar de contabilidade"
    },
    {
        id: "413115",
        value: "Auxiliar de faturamento"
    },
    {
        id: "413205",
        value: "Atendente de ag\u00eancia"
    },
    {
        id: "413210",
        value: "Caixa de banco"
    },
    {
        id: "413215",
        value: "Compensador de banco"
    },
    {
        id: "413220",
        value: "Conferente de servi\u00e7os banc\u00e1rios"
    },
    {
        id: "413225",
        value: "Escritur\u00e1rio de banco"
    },
    {
        id: "413230",
        value: "Operador de cobran\u00e7a banc\u00e1ria"
    },
    {
        id: "414125",
        value: "Estoquista"
    },
    {
        id: "414135",
        value: "Expedidor de mercadorias"
    },
    {
        id: "414140",
        value: "Auxiliar de logistica"
    },
    {
        id: "414105",
        value: "Almoxarife"
    },
    {
        id: "414110",
        value: "Armazenista"
    },
    {
        id: "414115",
        value: "Balanceiro"
    },
    {
        id: "414120",
        value: "Conferente mercadoria (exceto carga e descarga)"
    },
    {
        id: "414210",
        value: "Apontador de produ\u00e7\u00e3o"
    },
    {
        id: "414205",
        value: "Apontador de m\u00e3o-de-obra"
    },
    {
        id: "414215",
        value: "Conferente de carga e descarga"
    },
    {
        id: "415125",
        value: "Kardexista"
    },
    {
        id: "415130",
        value: "Operador de m\u00e1quina copiadora (exceto operador de gr\u00e1fica r\u00e1pida)"
    },
    {
        id: "415120",
        value: "Fitotec\u00e1rio"
    },
    {
        id: "415105",
        value: "Arquivista de documentos"
    },
    {
        id: "415115",
        value: "Codificador de dados"
    },
    {
        id: "415205",
        value: "Carteiro"
    },
    {
        id: "415215",
        value: "Entregador de publica\u00e7\u00f5es"
    },
    {
        id: "415210",
        value: "Operador de triagem e transbordo"
    },
    {
        id: "420135",
        value: "Supervisor de telemarketing e atendimento"
    },
    {
        id: "420130",
        value: "Supervisor de telefonistas"
    },
    {
        id: "420125",
        value: "Supervisor de recepcionistas"
    },
    {
        id: "420120",
        value: "Supervisor de entrevistadores e recenseadores"
    },
    {
        id: "420115",
        value: "Supervisor de coletadores de apostas e de jogos"
    },
    {
        id: "420105",
        value: "Supervisor de caixas e bilheteiros (exceto caixa de banco)"
    },
    {
        id: "420110",
        value: "Supervisor de cobran\u00e7a"
    },
    {
        id: "421120",
        value: "Emissor de passagens"
    },
    {
        id: "421125",
        value: "Operador de caixa"
    },
    {
        id: "421115",
        value: "Bilheteiro no servi\u00e7o de divers\u00f5es"
    },
    {
        id: "421110",
        value: "Bilheteiro de transportes coletivos"
    },
    {
        id: "421105",
        value: "Atendente comercial (ag\u00eancia postal)"
    },
    {
        id: "421210",
        value: "Recebedor de apostas (turfe)"
    },
    {
        id: "421205",
        value: "Recebedor de apostas (loteria)"
    },
    {
        id: "421315",
        value: "Localizador (cobrador)"
    },
    {
        id: "421310",
        value: "Cobrador interno"
    },
    {
        id: "421305",
        value: "Cobrador externo"
    },
    {
        id: "422125",
        value: "Recepcionista de banco"
    },
    {
        id: "422120",
        value: "Recepcionista de hotel"
    },
    {
        id: "422115",
        value: "Recepcionista de seguro sa\u00fade"
    },
    {
        id: "422130",
        value: "Concierge"
    },
    {
        id: "422105",
        value: "Recepcionista, em geral"
    },
    {
        id: "422110",
        value: "Recepcionista de consult\u00f3rio m\u00e9dico ou dent\u00e1rio"
    },
    {
        id: "422220",
        value: "Operador de r\u00e1dio-chamada"
    },
    {
        id: "422205",
        value: "Telefonista"
    },
    {
        id: "422210",
        value: "Teleoperador"
    },
    {
        id: "422215",
        value: "Monitor de teleatendimento"
    },
    {
        id: "422315",
        value: "Operador de telemarketing receptivo"
    },
    {
        id: "422320",
        value: "Operador de telemarketing t\u00e9cnico"
    },
    {
        id: "422310",
        value: "Operador de telemarketing ativo e receptivo"
    },
    {
        id: "422305",
        value: "Operador de telemarketing ativo"
    },
    {
        id: "423105",
        value: "Despachante documentalista"
    },
    {
        id: "423110",
        value: "Despachante de tr\u00e2nsito"
    },
    {
        id: "424120",
        value: "Entrevistador de pre\u00e7os"
    },
    {
        id: "424125",
        value: "Escritur\u00e1rio  em  estat\u00edstica"
    },
    {
        id: "424130",
        value: "Entrevistador social"
    },
    {
        id: "424105",
        value: "Entrevistador censit\u00e1rio e de pesquisas amostrais"
    },
    {
        id: "424110",
        value: "Entrevistador de pesquisa de opini\u00e3o e m\u00eddia"
    },
    {
        id: "424115",
        value: "Entrevistador de pesquisas de mercado"
    },
    {
        id: "424210",
        value: "Aplicador de provas (concurso, avalia\u00e7\u00e3o,exame)"
    },
    {
        id: "424205",
        value: "Coordenador de provas (concurso, avalia\u00e7\u00e3o, exame)"
    },
    {
        id: "510105",
        value: "Supervisor de transportes"
    },
    {
        id: "510110",
        value: "Administrador de edif\u00edcios"
    },
    {
        id: "510115",
        value: "Supervisor de andar"
    },
    {
        id: "510120",
        value: "Chefe de portaria de hotel"
    },
    {
        id: "510130",
        value: "Chefe de bar"
    },
    {
        id: "510135",
        value: "Ma\u00eetre"
    },
    {
        id: "510205",
        value: "Supervisor de lavanderia"
    },
    {
        id: "510305",
        value: "Supervisor de bombeiros"
    },
    {
        id: "510310",
        value: "Supervisor de vigilantes"
    },
    {
        id: "511115",
        value: "Taifeiro (exceto militares)"
    },
    {
        id: "511110",
        value: "Comiss\u00e1rio de trem"
    },
    {
        id: "511105",
        value: "Comiss\u00e1rio de v\u00f4o"
    },
    {
        id: "511220",
        value: "Bilheteiro (esta\u00e7\u00f5es de metr\u00f4, ferrovi\u00e1rias e assemelhadas)"
    },
    {
        id: "511205",
        value: "Fiscal de transportes coletivos (exceto trem)"
    },
    {
        id: "511210",
        value: "Despachante de transportes coletivos (exceto trem)"
    },
    {
        id: "511215",
        value: "Cobrador de transportes coletivos (exceto trem)"
    },
    {
        id: "511405",
        value: "Guia de turismo"
    },
    {
        id: "511510",
        value: "Condutor de turismo de pesca"
    },
    {
        id: "511505",
        value: "Condutor de turismo de aventura"
    },
    {
        id: "512105",
        value: "Empregado  dom\u00e9stico  nos servi\u00e7os gerais"
    },
    {
        id: "512120",
        value: "Empregado dom\u00e9stico diarista"
    },
    {
        id: "512115",
        value: "Empregado dom\u00e9stico  faxineiro"
    },
    {
        id: "512110",
        value: "Empregado dom\u00e9stico  arrumador"
    },
    {
        id: "513105",
        value: "Mordomo de resid\u00eancia"
    },
    {
        id: "513110",
        value: "Mordomo de hotelaria"
    },
    {
        id: "513115",
        value: "Governanta de hotelaria"
    },
    {
        id: "513205",
        value: "Cozinheiro geral"
    },
    {
        id: "513225",
        value: "Cozinheiro de embarca\u00e7\u00f5es"
    },
    {
        id: "513220",
        value: "Cozinheiro de hospital"
    },
    {
        id: "513215",
        value: "Cozinheiro industrial"
    },
    {
        id: "513210",
        value: "Cozinheiro do servi\u00e7o dom\u00e9stico"
    },
    {
        id: "513325",
        value: "Guarda-roupeira de cinema"
    },
    {
        id: "513320",
        value: "Camareiro de embarca\u00e7\u00f5es"
    },
    {
        id: "513315",
        value: "Camareiro  de hotel"
    },
    {
        id: "513310",
        value: "Camareira de televis\u00e3o"
    },
    {
        id: "513305",
        value: "Camareira de teatro"
    },
    {
        id: "513440",
        value: "Barista"
    },
    {
        id: "513430",
        value: "Copeiro de hospital"
    },
    {
        id: "513425",
        value: "Copeiro"
    },
    {
        id: "513420",
        value: "Barman"
    },
    {
        id: "513415",
        value: "Cumim"
    },
    {
        id: "513410",
        value: "Gar\u00e7om (servi\u00e7os de vinhos)"
    },
    {
        id: "513405",
        value: "Gar\u00e7om"
    },
    {
        id: "513435",
        value: "Atendente de lanchonete"
    },
    {
        id: "513505",
        value: "Auxiliar nos servi\u00e7os de alimenta\u00e7\u00e3o"
    },
    {
        id: "513605",
        value: "Churrasqueiro"
    },
    {
        id: "513610",
        value: "Pizzaiolo"
    },
    {
        id: "513615",
        value: "Sushiman"
    },
    {
        id: "514105",
        value: "Ascensorista"
    },
    {
        id: "514120",
        value: "Zelador de edif\u00edcio"
    },
    {
        id: "514115",
        value: "Sacrist\u00e3o"
    },
    {
        id: "514110",
        value: "Garagista"
    },
    {
        id: "514215",
        value: "Varredor de rua"
    },
    {
        id: "514225",
        value: "Trabalhador de servi\u00e7os de limpeza e conserva\u00e7\u00e3o de \u00e1reas p\u00fablicas"
    },
    {
        id: "514205",
        value: "Coletor de lixo domiciliar"
    },
    {
        id: "514230",
        value: "Coletor de res\u00edduos s\u00f3lidos de servi\u00e7os de sa\u00fade"
    },
    {
        id: "514305",
        value: "Limpador de vidros"
    },
    {
        id: "514310",
        value: "Auxiliar de manuten\u00e7\u00e3o predial"
    },
    {
        id: "514315",
        value: "Limpador de fachadas"
    },
    {
        id: "514320",
        value: "Faxineiro"
    },
    {
        id: "514330",
        value: "Limpador de piscinas"
    },
    {
        id: "514325",
        value: "Trabalhador da manuten\u00e7\u00e3o de edifica\u00e7\u00f5es"
    },
    {
        id: "515140",
        value: "Agente de combate \u00e0s endemias"
    },
    {
        id: "515105",
        value: "Agente comunit\u00e1rio de sa\u00fade"
    },
    {
        id: "515110",
        value: "Atendente de enfermagem"
    },
    {
        id: "515135",
        value: "Socorrista (exceto m\u00e9dicos e enfermeiros)"
    },
    {
        id: "515120",
        value: "Visitador sanit\u00e1rio"
    },
    {
        id: "515125",
        value: "Agente ind\u00edgena de sa\u00fade"
    },
    {
        id: "515130",
        value: "Agente ind\u00edgena de saneamento"
    },
    {
        id: "515115",
        value: "Parteira leiga"
    },
    {
        id: "515205",
        value: "Auxiliar de banco de sangue"
    },
    {
        id: "515210",
        value: "Auxiliar de farm\u00e1cia de manipula\u00e7\u00e3o"
    },
    {
        id: "515215",
        value: "Auxiliar de laborat\u00f3rio de an\u00e1lises cl\u00ednicas"
    },
    {
        id: "515220",
        value: "Auxiliar de laborat\u00f3rio de imunobiol\u00f3gicos"
    },
    {
        id: "515225",
        value: "Auxiliar de produ\u00e7\u00e3o farmac\u00eautica"
    },
    {
        id: "515310",
        value: "Agente de a\u00e7\u00e3o social"
    },
    {
        id: "515325",
        value: "S\u00f3cioeducador"
    },
    {
        id: "515320",
        value: "Conselheiro tutelar"
    },
    {
        id: "515315",
        value: "Monitor de dependente qu\u00edmico"
    },
    {
        id: "515305",
        value: "Educador social"
    },
    {
        id: "515330",
        value: "Monitor de ressocializa\u00e7\u00e3o prisional"
    },
    {
        id: "516110",
        value: "Cabeleireiro"
    },
    {
        id: "516140",
        value: "Pedicure"
    },
    {
        id: "516105",
        value: "Barbeiro"
    },
    {
        id: "516120",
        value: "Manicure"
    },
    {
        id: "516125",
        value: "Maquiador"
    },
    {
        id: "516130",
        value: "Maquiador de caracteriza\u00e7\u00e3o"
    },
    {
        id: "516220",
        value: "Cuidador em sa\u00fade"
    },
    {
        id: "516215",
        value: "M\u00e3e social"
    },
    {
        id: "516205",
        value: "Bab\u00e1"
    },
    {
        id: "516210",
        value: "Cuidador de pessoas idosas"
    },
    {
        id: "516305",
        value: "Lavadeiro, em geral"
    },
    {
        id: "516310",
        value: "Lavador de roupas  a maquina"
    },
    {
        id: "516345",
        value: "Auxiliar de lavanderia"
    },
    {
        id: "516340",
        value: "Atendente de lavanderia"
    },
    {
        id: "516335",
        value: "Conferente-expedidor de roupas (lavanderias)"
    },
    {
        id: "516330",
        value: "Tingidor de roupas"
    },
    {
        id: "516325",
        value: "Passador de roupas em geral"
    },
    {
        id: "516315",
        value: "Lavador de artefatos de tape\u00e7aria"
    },
    {
        id: "516320",
        value: "Limpador a seco, \u00e0 m\u00e1quina"
    },
    {
        id: "516415",
        value: "Passador de roupas, \u00e0 m\u00e3o"
    },
    {
        id: "516410",
        value: "Limpador de roupas a seco, \u00e0 m\u00e3o"
    },
    {
        id: "516405",
        value: "Lavador de roupas"
    },
    {
        id: "516505",
        value: "Agente funer\u00e1rio"
    },
    {
        id: "516605",
        value: "Operador de forno (servi\u00e7os funer\u00e1rios)"
    },
    {
        id: "516610",
        value: "Sepultador"
    },
    {
        id: "516705",
        value: "Astr\u00f3logo"
    },
    {
        id: "516710",
        value: "Numer\u00f3logo"
    },
    {
        id: "516805",
        value: "Esot\u00e9rico"
    },
    {
        id: "516810",
        value: "Paranormal"
    },
    {
        id: "517110",
        value: "Bombeiro civil"
    },
    {
        id: "517115",
        value: "Salva-vidas"
    },
    {
        id: "517105",
        value: "Bombeiro de aer\u00f3dromo"
    },
    {
        id: "517220",
        value: "Agente de tr\u00e2nsito"
    },
    {
        id: "517210",
        value: "Policial rodovi\u00e1rio federal"
    },
    {
        id: "517205",
        value: "Agente de pol\u00edcia federal"
    },
    {
        id: "517215",
        value: "Guarda-civil municipal"
    },
    {
        id: "517325",
        value: "Vigia portu\u00e1rio"
    },
    {
        id: "517335",
        value: "Guarda portu\u00e1rio"
    },
    {
        id: "517330",
        value: "Vigilante"
    },
    {
        id: "517320",
        value: "Vigia florestal"
    },
    {
        id: "517315",
        value: "Agente de seguran\u00e7a penitenci\u00e1ria"
    },
    {
        id: "517310",
        value: "Agente de seguran\u00e7a"
    },
    {
        id: "517305",
        value: "Agente de prote\u00e7\u00e3o de aeroporto"
    },
    {
        id: "517420",
        value: "Vigia"
    },
    {
        id: "517425",
        value: "Fiscal de loja"
    },
    {
        id: "517405",
        value: "Porteiro (hotel)"
    },
    {
        id: "517410",
        value: "Porteiro de edif\u00edcios"
    },
    {
        id: "517415",
        value: "Porteiro de locais de divers\u00e3o"
    },
    {
        id: "519115",
        value: "Mototaxista"
    },
    {
        id: "519105",
        value: "Ciclista mensageiro"
    },
    {
        id: "519110",
        value: "Motofretista"
    },
    {
        id: "519210",
        value: "Selecionador de material recicl\u00e1vel"
    },
    {
        id: "519215",
        value: "Operador de prensa de material recicl\u00e1vel"
    },
    {
        id: "519205",
        value: "Catador de material recicl\u00e1vel"
    },
    {
        id: "519305",
        value: "Auxiliar de veterin\u00e1rio"
    },
    {
        id: "519315",
        value: "Banhista de animais dom\u00e9sticos"
    },
    {
        id: "519320",
        value: "Tosador de animais dom\u00e9sticos"
    },
    {
        id: "519310",
        value: "Esteticista de animais dom\u00e9sticos"
    },
    {
        id: "519805",
        value: "Profissional do sexo"
    },
    {
        id: "519945",
        value: "Recepcionista de casas de espet\u00e1culos"
    },
    {
        id: "519940",
        value: "Leiturista"
    },
    {
        id: "519930",
        value: "Lavador de garrafas, vidros e outros utens\u00edlios"
    },
    {
        id: "519925",
        value: "Guardador de ve\u00edculos"
    },
    {
        id: "519920",
        value: "Gandula"
    },
    {
        id: "519915",
        value: "Engraxate"
    },
    {
        id: "519910",
        value: "Controlador de pragas"
    },
    {
        id: "519905",
        value: "Cartazeiro"
    },
    {
        id: "519935",
        value: "Lavador de ve\u00edculos"
    },
    {
        id: "520110",
        value: "Supervisor de vendas comercial"
    },
    {
        id: "520105",
        value: "Supervisor de vendas de servi\u00e7os"
    },
    {
        id: "521120",
        value: "Demonstrador de mercadorias"
    },
    {
        id: "521125",
        value: "Repositor de mercadorias"
    },
    {
        id: "521140",
        value: "Atendente de lojas e mercados"
    },
    {
        id: "521135",
        value: "Frentista"
    },
    {
        id: "521105",
        value: "Vendedor em com\u00e9rcio atacadista"
    },
    {
        id: "521115",
        value: "Promotor de vendas"
    },
    {
        id: "521110",
        value: "Vendedor de com\u00e9rcio varejista"
    },
    {
        id: "521130",
        value: "Atendente de farm\u00e1cia - balconista"
    },
    {
        id: "523115",
        value: "Chaveiro"
    },
    {
        id: "523110",
        value: "Instalador de som e acess\u00f3rios de ve\u00edculos"
    },
    {
        id: "523105",
        value: "Instalador de cortinas e persianas, portas sanfonadas e boxe"
    },
    {
        id: "524105",
        value: "Vendedor em domic\u00edlio"
    },
    {
        id: "524205",
        value: "Feirante"
    },
    {
        id: "524210",
        value: "Jornaleiro (em banca de jornal)"
    },
    {
        id: "524215",
        value: "Vendedor  permission\u00e1rio"
    },
    {
        id: "524315",
        value: "Baiana de acaraj\u00e9"
    },
    {
        id: "524305",
        value: "Vendedor ambulante"
    },
    {
        id: "524310",
        value: "Pipoqueiro ambulante"
    },
    {
        id: "611005",
        value: "Produtor agropecu\u00e1rio, em geral"
    },
    {
        id: "612005",
        value: "Produtor agr\u00edcola polivalente"
    },
    {
        id: "612120",
        value: "Produtor de gram\u00edneas forrageiras"
    },
    {
        id: "612115",
        value: "Produtor de cereais de inverno"
    },
    {
        id: "612105",
        value: "Produtor de arroz"
    },
    {
        id: "612110",
        value: "Produtor de cana-de-a\u00e7\u00facar"
    },
    {
        id: "612125",
        value: "Produtor de milho e sorgo"
    },
    {
        id: "612210",
        value: "Produtor de curau\u00e1"
    },
    {
        id: "612215",
        value: "Produtor de juta"
    },
    {
        id: "612220",
        value: "Produtor de rami"
    },
    {
        id: "612225",
        value: "Produtor de sisal"
    },
    {
        id: "612205",
        value: "Produtor de algod\u00e3o"
    },
    {
        id: "612315",
        value: "Produtor na olericultura de talos, folhas e flores"
    },
    {
        id: "612320",
        value: "Produtor na olericultura de frutos e sementes"
    },
    {
        id: "612310",
        value: "Produtor na olericultura de ra\u00edzes, bulbos e tub\u00e9rculos"
    },
    {
        id: "612305",
        value: "Produtor na olericultura de legumes"
    },
    {
        id: "612415",
        value: "Produtor de forra\u00e7\u00f5es"
    },
    {
        id: "612405",
        value: "Produtor de flores de corte"
    },
    {
        id: "612410",
        value: "Produtor de flores em vaso"
    },
    {
        id: "612420",
        value: "Produtor de plantas ornamentais"
    },
    {
        id: "612510",
        value: "Produtor de esp\u00e9cies frut\u00edferas rasteiras"
    },
    {
        id: "612505",
        value: "Produtor de \u00e1rvores frut\u00edferas"
    },
    {
        id: "612515",
        value: "Produtor de esp\u00e9cies frut\u00edferas trepadeiras"
    },
    {
        id: "612620",
        value: "Produtor de fumo"
    },
    {
        id: "612625",
        value: "Produtor de guaran\u00e1"
    },
    {
        id: "612610",
        value: "Produtor de cacau"
    },
    {
        id: "612615",
        value: "Produtor de erva-mate"
    },
    {
        id: "612605",
        value: "Cafeicultor"
    },
    {
        id: "612730",
        value: "Produtor da cultura de linho"
    },
    {
        id: "612725",
        value: "Produtor da cultura de girassol"
    },
    {
        id: "612705",
        value: "Produtor da cultura de amendoim"
    },
    {
        id: "612710",
        value: "Produtor da cultura de canola"
    },
    {
        id: "612715",
        value: "Produtor da cultura de coco-da-baia"
    },
    {
        id: "612720",
        value: "Produtor da cultura de dend\u00ea"
    },
    {
        id: "612735",
        value: "Produtor da cultura de mamona"
    },
    {
        id: "612740",
        value: "Produtor da cultura de soja"
    },
    {
        id: "612810",
        value: "Produtor de plantas arom\u00e1ticas e medicinais"
    },
    {
        id: "612805",
        value: "Produtor de especiarias"
    },
    {
        id: "613010",
        value: "Criador de animais dom\u00e9sticos"
    },
    {
        id: "613005",
        value: "Criador em pecu\u00e1ria polivalente"
    },
    {
        id: "613105",
        value: "Criador de asininos e muares"
    },
    {
        id: "613130",
        value: "Criador de eq\u00fc\u00ednos"
    },
    {
        id: "613125",
        value: "Criador de bubalinos (leite)"
    },
    {
        id: "613120",
        value: "Criador de bubalinos (corte)"
    },
    {
        id: "613115",
        value: "Criador de bovinos (leite)"
    },
    {
        id: "613110",
        value: "Criador de bovinos (corte)"
    },
    {
        id: "613205",
        value: "Criador de caprinos"
    },
    {
        id: "613215",
        value: "Criador de su\u00ednos"
    },
    {
        id: "613210",
        value: "Criador de ovinos"
    },
    {
        id: "613310",
        value: "Cunicultor"
    },
    {
        id: "613305",
        value: "Avicultor"
    },
    {
        id: "613415",
        value: "Minhocultor"
    },
    {
        id: "613410",
        value: "Criador de animais produtores de veneno"
    },
    {
        id: "613405",
        value: "Apicultor"
    },
    {
        id: "613420",
        value: "Sericultor"
    },
    {
        id: "620105",
        value: "Supervisor de explora\u00e7\u00e3o agr\u00edcola"
    },
    {
        id: "620110",
        value: "Supervisor de explora\u00e7\u00e3o agropecu\u00e1ria"
    },
    {
        id: "620115",
        value: "Supervisor de explora\u00e7\u00e3o pecu\u00e1ria"
    },
    {
        id: "621005",
        value: "Trabalhador agropecu\u00e1rio em geral"
    },
    {
        id: "622015",
        value: "Trabalhador na produ\u00e7\u00e3o de mudas e sementes"
    },
    {
        id: "622010",
        value: "Jardineiro"
    },
    {
        id: "622005",
        value: "Caseiro (agricultura)"
    },
    {
        id: "622020",
        value: "Trabalhador volante da agricultura"
    },
    {
        id: "622120",
        value: "Trabalhador da cultura de trigo, aveia, cevada e triticale"
    },
    {
        id: "622115",
        value: "Trabalhador da cultura de milho e sorgo"
    },
    {
        id: "622105",
        value: "Trabalhador da cultura de arroz"
    },
    {
        id: "622110",
        value: "Trabalhador da cultura de cana-de-a\u00e7\u00facar"
    },
    {
        id: "622210",
        value: "Trabalhador da cultura de sisal"
    },
    {
        id: "622205",
        value: "Trabalhador da cultura de algod\u00e3o"
    },
    {
        id: "622215",
        value: "Trabalhador da cultura do rami"
    },
    {
        id: "622310",
        value: "Trabalhador na olericultura (legumes)"
    },
    {
        id: "622305",
        value: "Trabalhador na olericultura (frutos e sementes)"
    },
    {
        id: "622315",
        value: "Trabalhador na olericultura (ra\u00edzes, bulbos e tub\u00e9rculos)"
    },
    {
        id: "622320",
        value: "Trabalhador na olericultura (talos, folhas e flores)"
    },
    {
        id: "622405",
        value: "Trabalhador no cultivo de flores e folhagens de corte"
    },
    {
        id: "622410",
        value: "Trabalhador no cultivo de flores em vaso"
    },
    {
        id: "622415",
        value: "Trabalhador no cultivo de forra\u00e7\u00f5es"
    },
    {
        id: "622420",
        value: "Trabalhador no cultivo de mudas"
    },
    {
        id: "622425",
        value: "Trabalhador no cultivo de plantas ornamentais"
    },
    {
        id: "622505",
        value: "Trabalhador no cultivo de \u00e1rvores frut\u00edferas"
    },
    {
        id: "622510",
        value: "Trabalhador no cultivo de esp\u00e9cies frut\u00edferas rasteiras"
    },
    {
        id: "622515",
        value: "Trabalhador no cultivo de trepadeiras frut\u00edferas"
    },
    {
        id: "622615",
        value: "Trabalhador da cultura de erva-mate"
    },
    {
        id: "622620",
        value: "Trabalhador da cultura de fumo"
    },
    {
        id: "622625",
        value: "Trabalhador da cultura de guaran\u00e1"
    },
    {
        id: "622610",
        value: "Trabalhador da cultura de caf\u00e9"
    },
    {
        id: "622605",
        value: "Trabalhador da cultura de cacau"
    },
    {
        id: "622715",
        value: "Trabalhador na cultura de coco-da-ba\u00eda"
    },
    {
        id: "622710",
        value: "Trabalhador na cultura de canola"
    },
    {
        id: "622725",
        value: "Trabalhador na cultura de mamona"
    },
    {
        id: "622730",
        value: "Trabalhador na cultura de soja"
    },
    {
        id: "622735",
        value: "Trabalhador na cultura do girassol"
    },
    {
        id: "622740",
        value: "Trabalhador na cultura do linho"
    },
    {
        id: "622705",
        value: "Trabalhador na cultura de amendoim"
    },
    {
        id: "622720",
        value: "Trabalhador na cultura de dend\u00ea"
    },
    {
        id: "622810",
        value: "Trabalhador da cultura de plantas arom\u00e1ticas e medicinais"
    },
    {
        id: "622805",
        value: "Trabalhador da cultura de especiarias"
    },
    {
        id: "623025",
        value: "Casqueador de animais"
    },
    {
        id: "623030",
        value: "Ferrador de animais"
    },
    {
        id: "623015",
        value: "Trabalhador de pecu\u00e1ria polivalente"
    },
    {
        id: "623010",
        value: "Inseminador"
    },
    {
        id: "623020",
        value: "Tratador de animais"
    },
    {
        id: "623005",
        value: "Adestrador de animais"
    },
    {
        id: "623105",
        value: "Trabalhador da pecu\u00e1ria (asininos e muares)"
    },
    {
        id: "623110",
        value: "Trabalhador da pecu\u00e1ria (bovinos corte)"
    },
    {
        id: "623120",
        value: "Trabalhador da pecu\u00e1ria (bubalinos)"
    },
    {
        id: "623125",
        value: "Trabalhador da pecu\u00e1ria (eq\u00fcinos)"
    },
    {
        id: "623115",
        value: "Trabalhador da pecu\u00e1ria (bovinos leite)"
    },
    {
        id: "623210",
        value: "Trabalhador da ovinocultura"
    },
    {
        id: "623215",
        value: "Trabalhador da suinocultura"
    },
    {
        id: "623205",
        value: "Trabalhador da caprinocultura"
    },
    {
        id: "623320",
        value: "Trabalhador da cunicultura"
    },
    {
        id: "623315",
        value: "Operador de incubadora"
    },
    {
        id: "623310",
        value: "Trabalhador da avicultura de postura"
    },
    {
        id: "623305",
        value: "Trabalhador da avicultura de corte"
    },
    {
        id: "623325",
        value: "Sexador"
    },
    {
        id: "623405",
        value: "Trabalhador em criat\u00f3rios de animais produtores de veneno"
    },
    {
        id: "623415",
        value: "Trabalhador na minhocultura"
    },
    {
        id: "623420",
        value: "Trabalhador na sericicultura"
    },
    {
        id: "623410",
        value: "Trabalhador na apicultura"
    },
    {
        id: "630110",
        value: "Supervisor da \u00e1rea florestal"
    },
    {
        id: "630105",
        value: "Supervisor da aq\u00fcicultura"
    },
    {
        id: "631015",
        value: "Pescador artesanal de lagostas"
    },
    {
        id: "631005",
        value: "Catador de caranguejos e siris"
    },
    {
        id: "631010",
        value: "Catador de mariscos"
    },
    {
        id: "631020",
        value: "Pescador artesanal de peixes e camar\u00f5es"
    },
    {
        id: "631105",
        value: "Pescador artesanal de \u00e1gua doce"
    },
    {
        id: "631205",
        value: "Pescador industrial"
    },
    {
        id: "631210",
        value: "Pescador profissional"
    },
    {
        id: "631335",
        value: "Criador de r\u00e3s"
    },
    {
        id: "631330",
        value: "Criador de quel\u00f4nios"
    },
    {
        id: "631325",
        value: "Criador de peixes"
    },
    {
        id: "631320",
        value: "Criador de ostras"
    },
    {
        id: "631315",
        value: "Criador de mexilh\u00f5es"
    },
    {
        id: "631310",
        value: "Criador de jacar\u00e9s"
    },
    {
        id: "631305",
        value: "Criador de camar\u00f5es"
    },
    {
        id: "631405",
        value: "Gelador industrial"
    },
    {
        id: "631420",
        value: "Redeiro (pesca)"
    },
    {
        id: "631415",
        value: "Proeiro"
    },
    {
        id: "631410",
        value: "Gelador profissional"
    },
    {
        id: "632010",
        value: "Raizeiro"
    },
    {
        id: "632015",
        value: "Viveirista florestal"
    },
    {
        id: "632005",
        value: "Guia florestal"
    },
    {
        id: "632115",
        value: "Identificador florestal"
    },
    {
        id: "632110",
        value: "Cubador de madeira"
    },
    {
        id: "632105",
        value: "Classificador de toras"
    },
    {
        id: "632120",
        value: "Operador de motosserra"
    },
    {
        id: "632125",
        value: "Trabalhador de extra\u00e7\u00e3o florestal, em geral"
    },
    {
        id: "632215",
        value: "Trabalhador da explora\u00e7\u00e3o de resinas"
    },
    {
        id: "632210",
        value: "Trabalhador da explora\u00e7\u00e3o de esp\u00e9cies produtoras de gomas n\u00e3o el\u00e1sticas"
    },
    {
        id: "632205",
        value: "Seringueiro"
    },
    {
        id: "632370",
        value: "Trabalhador da explora\u00e7\u00e3o de tucum"
    },
    {
        id: "632365",
        value: "Trabalhador da explora\u00e7\u00e3o de pia\u00e7ava"
    },
    {
        id: "632360",
        value: "Trabalhador da explora\u00e7\u00e3o de pequi"
    },
    {
        id: "632355",
        value: "Trabalhador da explora\u00e7\u00e3o de ouricuri"
    },
    {
        id: "632350",
        value: "Trabalhador da explora\u00e7\u00e3o de oiticica"
    },
    {
        id: "632345",
        value: "Trabalhador da explora\u00e7\u00e3o de murumuru"
    },
    {
        id: "632340",
        value: "Trabalhador da explora\u00e7\u00e3o de malva (p\u00e3ina)"
    },
    {
        id: "632335",
        value: "Trabalhador da explora\u00e7\u00e3o de copa\u00edba"
    },
    {
        id: "632330",
        value: "Trabalhador da explora\u00e7\u00e3o de coco-da-praia"
    },
    {
        id: "632325",
        value: "Trabalhador da explora\u00e7\u00e3o de carna\u00faba"
    },
    {
        id: "632320",
        value: "Trabalhador da explora\u00e7\u00e3o de buriti"
    },
    {
        id: "632315",
        value: "Trabalhador da explora\u00e7\u00e3o de bacaba"
    },
    {
        id: "632305",
        value: "Trabalhador da explora\u00e7\u00e3o de andiroba"
    },
    {
        id: "632310",
        value: "Trabalhador da explora\u00e7\u00e3o de baba\u00e7u"
    },
    {
        id: "632405",
        value: "Trabalhador da explora\u00e7\u00e3o de a\u00e7a\u00ed"
    },
    {
        id: "632410",
        value: "Trabalhador da explora\u00e7\u00e3o de castanha"
    },
    {
        id: "632415",
        value: "Trabalhador da explora\u00e7\u00e3o de pinh\u00e3o"
    },
    {
        id: "632420",
        value: "Trabalhador da explora\u00e7\u00e3o de pupunha"
    },
    {
        id: "632505",
        value: "Trabalhador da explora\u00e7\u00e3o de \u00e1rvores e arbustos produtores de subst\u00e2ncias arom\u00e1t., Medic. E t\u00f3xicas"
    },
    {
        id: "632510",
        value: "Trabalhador da explora\u00e7\u00e3o de cip\u00f3s produtores de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas"
    },
    {
        id: "632525",
        value: "Trabalhador da extra\u00e7\u00e3o de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas, em geral"
    },
    {
        id: "632520",
        value: "Trabalhador da explora\u00e7\u00e3o de ra\u00edzes produtoras de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas"
    },
    {
        id: "632515",
        value: "Trabalhador da explora\u00e7\u00e3o de madeiras tanantes"
    },
    {
        id: "632605",
        value: "Carvoeiro"
    },
    {
        id: "632610",
        value: "Carbonizador"
    },
    {
        id: "632615",
        value: "Ajudante de carvoaria"
    },
    {
        id: "641010",
        value: "Operador de m\u00e1quinas de beneficiamento de produtos agr\u00edcolas"
    },
    {
        id: "641005",
        value: "Operador de colheitadeira"
    },
    {
        id: "641015",
        value: "Tratorista agr\u00edcola"
    },
    {
        id: "642010",
        value: "Operador de m\u00e1quinas florestais est\u00e1ticas"
    },
    {
        id: "642005",
        value: "Operador de colhedor florestal"
    },
    {
        id: "642015",
        value: "Operador de trator florestal"
    },
    {
        id: "643005",
        value: "Trabalhador na opera\u00e7\u00e3o de sistema de irriga\u00e7\u00e3o localizada (microaspers\u00e3o e gotejamento)"
    },
    {
        id: "643010",
        value: "Trabalhador na opera\u00e7\u00e3o de sistema de irriga\u00e7\u00e3o por aspers\u00e3o (piv\u00f4 central)"
    },
    {
        id: "643015",
        value: "Trabalhador na opera\u00e7\u00e3o de sistemas convencionais de irriga\u00e7\u00e3o por aspers\u00e3o"
    },
    {
        id: "643020",
        value: "Trabalhador na opera\u00e7\u00e3o de sistemas de irriga\u00e7\u00e3o e aspers\u00e3o (alto propelido)"
    },
    {
        id: "643025",
        value: "Trabalhador na opera\u00e7\u00e3o de sistemas de irriga\u00e7\u00e3o por superf\u00edcie e drenagem"
    },
    {
        id: "710125",
        value: "Supervisor de transporte na minera\u00e7\u00e3o"
    },
    {
        id: "710105",
        value: "Supervisor de apoio operacional na minera\u00e7\u00e3o"
    },
    {
        id: "710110",
        value: "Supervisor de extra\u00e7\u00e3o de sal"
    },
    {
        id: "710115",
        value: "Supervisor de perfura\u00e7\u00e3o e desmonte"
    },
    {
        id: "710120",
        value: "Supervisor de produ\u00e7\u00e3o na minera\u00e7\u00e3o"
    },
    {
        id: "710205",
        value: "Mestre (constru\u00e7\u00e3o civil)"
    },
    {
        id: "710210",
        value: "Mestre de linhas (ferrovias)"
    },
    {
        id: "710225",
        value: "Fiscal de p\u00e1tio de usina de concreto"
    },
    {
        id: "710220",
        value: "Supervisor de usina de concreto"
    },
    {
        id: "710215",
        value: "Inspetor de terraplenagem"
    },
    {
        id: "711125",
        value: "Escorador de minas"
    },
    {
        id: "711120",
        value: "Detonador"
    },
    {
        id: "711115",
        value: "Destro\u00e7ador de pedra"
    },
    {
        id: "711110",
        value: "Canteiro"
    },
    {
        id: "711105",
        value: "Amostrador de min\u00e9rios"
    },
    {
        id: "711130",
        value: "Mineiro"
    },
    {
        id: "711225",
        value: "Operador de m\u00e1quina perfuradora (minas e pedreiras)"
    },
    {
        id: "711220",
        value: "Operador de m\u00e1quina de extra\u00e7\u00e3o cont\u00ednua (minas de carv\u00e3o)"
    },
    {
        id: "711215",
        value: "Operador de m\u00e1quina cortadora (minas e pedreiras)"
    },
    {
        id: "711210",
        value: "Operador de carregadeira"
    },
    {
        id: "711205",
        value: "Operador de caminh\u00e3o (minas e pedreiras)"
    },
    {
        id: "711230",
        value: "Operador de m\u00e1quina perfuratriz"
    },
    {
        id: "711245",
        value: "Operador de trator (minas e pedreiras)"
    },
    {
        id: "711240",
        value: "Operador de schutthecar"
    },
    {
        id: "711235",
        value: "Operador de motoniveladora (extra\u00e7\u00e3o de minerais s\u00f3lidos)"
    },
    {
        id: "711305",
        value: "Operador de sonda de percuss\u00e3o"
    },
    {
        id: "711310",
        value: "Operador de sonda rotativa"
    },
    {
        id: "711315",
        value: "Sondador (po\u00e7os de petr\u00f3leo e g\u00e1s)"
    },
    {
        id: "711320",
        value: "Sondador de po\u00e7os (exceto de petr\u00f3leo e g\u00e1s)"
    },
    {
        id: "711330",
        value: "Torrista (petr\u00f3leo)"
    },
    {
        id: "711325",
        value: "Plataformista (petr\u00f3leo)"
    },
    {
        id: "711405",
        value: "Garimpeiro"
    },
    {
        id: "711410",
        value: "Operador de salina (sal marinho)"
    },
    {
        id: "712105",
        value: "Moleiro de min\u00e9rios"
    },
    {
        id: "712110",
        value: "Operador de aparelho de flota\u00e7\u00e3o"
    },
    {
        id: "712115",
        value: "Operador de aparelho de precipita\u00e7\u00e3o (minas de ouro ou prata)"
    },
    {
        id: "712120",
        value: "Operador de britador de mand\u00edbulas"
    },
    {
        id: "712125",
        value: "Operador de espessador"
    },
    {
        id: "712130",
        value: "Operador de jig (minas)"
    },
    {
        id: "712135",
        value: "Operador de peneiras hidr\u00e1ulicas"
    },
    {
        id: "712205",
        value: "Cortador de pedras"
    },
    {
        id: "712210",
        value: "Gravador de inscri\u00e7\u00f5es em pedra"
    },
    {
        id: "712215",
        value: "Gravador de relevos em pedra"
    },
    {
        id: "712220",
        value: "Polidor de pedras"
    },
    {
        id: "712225",
        value: "Torneiro (lavra de pedra)"
    },
    {
        id: "712230",
        value: "Tra\u00e7ador de pedras"
    },
    {
        id: "715115",
        value: "Operador de escavadeira"
    },
    {
        id: "715110",
        value: "Operador de compactadora de solos"
    },
    {
        id: "715105",
        value: "Operador de bate-estacas"
    },
    {
        id: "715145",
        value: "Operador de trator de l\u00e2mina"
    },
    {
        id: "715120",
        value: "Operador de m\u00e1quina de abrir valas"
    },
    {
        id: "715135",
        value: "Operador de p\u00e1 carregadeira"
    },
    {
        id: "715130",
        value: "Operador de motoniveladora"
    },
    {
        id: "715125",
        value: "Operador de m\u00e1quinas de constru\u00e7\u00e3o civil e minera\u00e7\u00e3o"
    },
    {
        id: "715140",
        value: "Operador de pavimentadora (asfalto, concreto e materiais similares)"
    },
    {
        id: "715230",
        value: "Pedreiro de edifica\u00e7\u00f5es"
    },
    {
        id: "715225",
        value: "Pedreiro (minera\u00e7\u00e3o)"
    },
    {
        id: "715220",
        value: "Pedreiro (material refrat\u00e1rio)"
    },
    {
        id: "715215",
        value: "Pedreiro (chamin\u00e9s industriais)"
    },
    {
        id: "715205",
        value: "Calceteiro"
    },
    {
        id: "715210",
        value: "Pedreiro"
    },
    {
        id: "715310",
        value: "Moldador de corpos de prova em usinas de concreto"
    },
    {
        id: "715305",
        value: "Armador de estrutura de concreto"
    },
    {
        id: "715315",
        value: "Armador de estrutura de concreto armado"
    },
    {
        id: "715405",
        value: "Operador de betoneira"
    },
    {
        id: "715410",
        value: "Operador de bomba de concreto"
    },
    {
        id: "715415",
        value: "Operador de central de concreto"
    },
    {
        id: "715505",
        value: "Carpinteiro"
    },
    {
        id: "715510",
        value: "Carpinteiro (esquadrias)"
    },
    {
        id: "715545",
        value: "Montador de andaimes (edifica\u00e7\u00f5es)"
    },
    {
        id: "715540",
        value: "Carpinteiro de obras civis de arte (pontes, t\u00faneis, barragens)"
    },
    {
        id: "715535",
        value: "Carpinteiro de f\u00f4rmas para concreto"
    },
    {
        id: "715530",
        value: "Carpinteiro (telhados)"
    },
    {
        id: "715525",
        value: "Carpinteiro de obras"
    },
    {
        id: "715520",
        value: "Carpinteiro (minera\u00e7\u00e3o)"
    },
    {
        id: "715515",
        value: "Carpinteiro (cen\u00e1rios)"
    },
    {
        id: "715610",
        value: "Eletricista de instala\u00e7\u00f5es (edif\u00edcios)"
    },
    {
        id: "715615",
        value: "Eletricista de instala\u00e7\u00f5es"
    },
    {
        id: "715605",
        value: "Eletricista de instala\u00e7\u00f5es (cen\u00e1rios)"
    },
    {
        id: "715730",
        value: "Instalador de material isolante, a m\u00e1quina (edifica\u00e7\u00f5es)"
    },
    {
        id: "715705",
        value: "Aplicador de asfalto impermeabilizante (coberturas)"
    },
    {
        id: "715715",
        value: "Instalador de isolantes t\u00e9rmicos (refrigera\u00e7\u00e3o e climatiza\u00e7\u00e3o)"
    },
    {
        id: "715720",
        value: "Instalador de isolantes t\u00e9rmicos de caldeira e tubula\u00e7\u00f5es"
    },
    {
        id: "715725",
        value: "Instalador de material isolante, a m\u00e3o (edifica\u00e7\u00f5es)"
    },
    {
        id: "715710",
        value: "Instalador de isolantes ac\u00fasticos"
    },
    {
        id: "716105",
        value: "Acabador de superf\u00edcies de concreto"
    },
    {
        id: "716110",
        value: "Revestidor de superf\u00edcies de concreto"
    },
    {
        id: "716205",
        value: "Telhador (telhas de argila e materiais similares)"
    },
    {
        id: "716210",
        value: "Telhador (telhas de cimento-amianto)"
    },
    {
        id: "716215",
        value: "Telhador (telhas met\u00e1licas)"
    },
    {
        id: "716220",
        value: "Telhador (telhas pl\u00e1sticas)"
    },
    {
        id: "716305",
        value: "Vidraceiro"
    },
    {
        id: "716310",
        value: "Vidraceiro (edifica\u00e7\u00f5es)"
    },
    {
        id: "716315",
        value: "Vidraceiro (vitrais)"
    },
    {
        id: "716405",
        value: "Gesseiro"
    },
    {
        id: "716520",
        value: "Lustrador de piso"
    },
    {
        id: "716515",
        value: "Pastilheiro"
    },
    {
        id: "716510",
        value: "Ladrilheiro"
    },
    {
        id: "716505",
        value: "Assoalhador"
    },
    {
        id: "716535",
        value: "Taqueiro"
    },
    {
        id: "716525",
        value: "Marmorista (constru\u00e7\u00e3o)"
    },
    {
        id: "716530",
        value: "Mosa\u00edsta"
    },
    {
        id: "716605",
        value: "Calafetador"
    },
    {
        id: "716610",
        value: "Pintor de obras"
    },
    {
        id: "716615",
        value: "Revestidor de interiores (papel, material pl\u00e1stico e emborrachados)"
    },
    {
        id: "717005",
        value: "Demolidor de edifica\u00e7\u00f5es"
    },
    {
        id: "717010",
        value: "Operador de martelete"
    },
    {
        id: "717025",
        value: "Vibradorista"
    },
    {
        id: "717020",
        value: "Servente de obras"
    },
    {
        id: "717015",
        value: "Poceiro (edifica\u00e7\u00f5es)"
    },
    {
        id: "720110",
        value: "Mestre de caldeiraria"
    },
    {
        id: "720105",
        value: "Mestre (afiador de ferramentas)"
    },
    {
        id: "720160",
        value: "Supervisor de controle de tratamento t\u00e9rmico"
    },
    {
        id: "720155",
        value: "Mestre serralheiro"
    },
    {
        id: "720150",
        value: "Mestre de usinagem"
    },
    {
        id: "720115",
        value: "Mestre de ferramentaria"
    },
    {
        id: "720120",
        value: "Mestre de forjaria"
    },
    {
        id: "720125",
        value: "Mestre de fundi\u00e7\u00e3o"
    },
    {
        id: "720130",
        value: "Mestre de galvanoplastia"
    },
    {
        id: "720135",
        value: "Mestre de pintura (tratamento de superf\u00edcies)"
    },
    {
        id: "720140",
        value: "Mestre de soldagem"
    },
    {
        id: "720145",
        value: "Mestre de trefila\u00e7\u00e3o de metais"
    },
    {
        id: "720210",
        value: "Mestre (ind\u00fastria de automotores e material de transportes)"
    },
    {
        id: "720205",
        value: "Mestre (constru\u00e7\u00e3o naval)"
    },
    {
        id: "720215",
        value: "Mestre (ind\u00fastria de m\u00e1quinas e outros equipamentos mec\u00e2nicos)"
    },
    {
        id: "720220",
        value: "Mestre de constru\u00e7\u00e3o de fornos"
    },
    {
        id: "721110",
        value: "Ferramenteiro de mandris, calibradores e outros dispositivos"
    },
    {
        id: "721105",
        value: "Ferramenteiro"
    },
    {
        id: "721115",
        value: "Modelador de metais (fundi\u00e7\u00e3o)"
    },
    {
        id: "721220",
        value: "Operador de usinagem convencional por abras\u00e3o"
    },
    {
        id: "721215",
        value: "Operador de m\u00e1quinas-ferramenta convencionais"
    },
    {
        id: "721210",
        value: "Operador de m\u00e1quinas operatrizes"
    },
    {
        id: "721205",
        value: "Operador de m\u00e1quina de eletroeros\u00e3o"
    },
    {
        id: "721225",
        value: "Preparador de m\u00e1quinas-ferramenta"
    },
    {
        id: "721320",
        value: "Afiador de serras"
    },
    {
        id: "721315",
        value: "Afiador de ferramentas"
    },
    {
        id: "721310",
        value: "Afiador de cutelaria"
    },
    {
        id: "721305",
        value: "Afiador de cardas"
    },
    {
        id: "721325",
        value: "Polidor de metais"
    },
    {
        id: "721405",
        value: "Operador de centro de usinagem com comando num\u00e9rico"
    },
    {
        id: "721410",
        value: "Operador de fresadora com comando num\u00e9rico"
    },
    {
        id: "721415",
        value: "Operador de mandriladora com comando num\u00e9rico"
    },
    {
        id: "721420",
        value: "Operador de m\u00e1quina eletroeros\u00e3o, \u00e0 fio, com comando num\u00e9rico"
    },
    {
        id: "721425",
        value: "Operador de retificadora com comando num\u00e9rico"
    },
    {
        id: "721430",
        value: "Operador de torno com comando num\u00e9rico"
    },
    {
        id: "722105",
        value: "Forjador"
    },
    {
        id: "722110",
        value: "Forjador a martelo"
    },
    {
        id: "722115",
        value: "Forjador prensista"
    },
    {
        id: "722215",
        value: "Operador de acabamento de pe\u00e7as fundidas"
    },
    {
        id: "722220",
        value: "Operador de m\u00e1quina centrifugadora de fundi\u00e7\u00e3o"
    },
    {
        id: "722225",
        value: "Operador de m\u00e1quina de fundir sob press\u00e3o"
    },
    {
        id: "722230",
        value: "Operador de vazamento (lingotamento)"
    },
    {
        id: "722235",
        value: "Preparador de panelas (lingotamento)"
    },
    {
        id: "722205",
        value: "Fundidor de metais"
    },
    {
        id: "722210",
        value: "Lingotador"
    },
    {
        id: "722305",
        value: "Macheiro, a m\u00e3o"
    },
    {
        id: "722310",
        value: "Macheiro, a  m\u00e1quina"
    },
    {
        id: "722315",
        value: "Moldador, a  m\u00e3o"
    },
    {
        id: "722320",
        value: "Moldador, a  m\u00e1quina"
    },
    {
        id: "722325",
        value: "Operador de equipamentos de prepara\u00e7\u00e3o de areia"
    },
    {
        id: "722330",
        value: "Operador de m\u00e1quina de moldar automatizada"
    },
    {
        id: "722405",
        value: "Cableador"
    },
    {
        id: "722410",
        value: "Estirador de tubos de metal sem costura"
    },
    {
        id: "722415",
        value: "Trefilador de metais, \u00e0 m\u00e1quina"
    },
    {
        id: "723120",
        value: "Operador de forno de tratamento t\u00e9rmico de metais"
    },
    {
        id: "723115",
        value: "Operador de equipamento para resfriamento"
    },
    {
        id: "723110",
        value: "Normalizador de metais e de comp\u00f3sitos"
    },
    {
        id: "723105",
        value: "Cementador de metais"
    },
    {
        id: "723125",
        value: "Temperador de metais e de comp\u00f3sitos"
    },
    {
        id: "723220",
        value: "Metalizador a pistola"
    },
    {
        id: "723215",
        value: "Galvanizador"
    },
    {
        id: "723210",
        value: "Fosfatizador"
    },
    {
        id: "723205",
        value: "Decapador"
    },
    {
        id: "723225",
        value: "Metalizador (banho quente)"
    },
    {
        id: "723240",
        value: "Oxidador"
    },
    {
        id: "723235",
        value: "Operador de zincagem (processo eletrol\u00edtico)"
    },
    {
        id: "723230",
        value: "Operador de m\u00e1quina recobridora de arame"
    },
    {
        id: "723305",
        value: "Operador de equipamento de secagem de pintura"
    },
    {
        id: "723310",
        value: "Pintor a pincel e rolo (exceto obras e estruturas met\u00e1licas)"
    },
    {
        id: "723325",
        value: "Pintor por imers\u00e3o"
    },
    {
        id: "723320",
        value: "Pintor de ve\u00edculos (fabrica\u00e7\u00e3o)"
    },
    {
        id: "723315",
        value: "Pintor de estruturas met\u00e1licas"
    },
    {
        id: "723330",
        value: "Pintor, a  pistola (exceto obras e estruturas met\u00e1licas)"
    },
    {
        id: "724135",
        value: "Instalador de tubula\u00e7\u00f5es de vapor (produ\u00e7\u00e3o e distribui\u00e7\u00e3o)"
    },
    {
        id: "724105",
        value: "Assentador de canaliza\u00e7\u00e3o (edifica\u00e7\u00f5es)"
    },
    {
        id: "724110",
        value: "Encanador"
    },
    {
        id: "724115",
        value: "Instalador de tubula\u00e7\u00f5es"
    },
    {
        id: "724120",
        value: "Instalador de tubula\u00e7\u00f5es (aeronaves)"
    },
    {
        id: "724130",
        value: "Instalador de tubula\u00e7\u00f5es de g\u00e1s combust\u00edvel (produ\u00e7\u00e3o e distribui\u00e7\u00e3o)"
    },
    {
        id: "724125",
        value: "Instalador de tubula\u00e7\u00f5es (embarca\u00e7\u00f5es)"
    },
    {
        id: "724230",
        value: "Rebitador, a  m\u00e3o"
    },
    {
        id: "724225",
        value: "Riscador de estruturas met\u00e1licas"
    },
    {
        id: "724220",
        value: "Preparador de estruturas met\u00e1licas"
    },
    {
        id: "724215",
        value: "Rebitador a  martelo pneum\u00e1tico"
    },
    {
        id: "724205",
        value: "Montador de estruturas met\u00e1licas"
    },
    {
        id: "724210",
        value: "Montador de estruturas met\u00e1licas de embarca\u00e7\u00f5es"
    },
    {
        id: "724305",
        value: "Brasador"
    },
    {
        id: "724325",
        value: "Soldador el\u00e9trico"
    },
    {
        id: "724320",
        value: "Soldador a  oxig\u00e1s"
    },
    {
        id: "724315",
        value: "Soldador"
    },
    {
        id: "724310",
        value: "Oxicortador a m\u00e3o e a  m\u00e1quina"
    },
    {
        id: "724440",
        value: "Serralheiro"
    },
    {
        id: "724405",
        value: "Caldeireiro (chapas de cobre)"
    },
    {
        id: "724435",
        value: "Funileiro industrial"
    },
    {
        id: "724430",
        value: "Chapeador de aeronaves"
    },
    {
        id: "724425",
        value: "Chapeador naval"
    },
    {
        id: "724410",
        value: "Caldeireiro (chapas de ferro e a\u00e7o)"
    },
    {
        id: "724415",
        value: "Chapeador"
    },
    {
        id: "724420",
        value: "Chapeador de carrocerias met\u00e1licas (fabrica\u00e7\u00e3o)"
    },
    {
        id: "724515",
        value: "Prensista (operador de prensa)"
    },
    {
        id: "724510",
        value: "Operador de m\u00e1quina de dobrar chapas"
    },
    {
        id: "724505",
        value: "Operador de m\u00e1quina de cilindrar chapas"
    },
    {
        id: "724605",
        value: "Operador de la\u00e7os de cabos de a\u00e7o"
    },
    {
        id: "724610",
        value: "Tran\u00e7ador de cabos de a\u00e7o"
    },
    {
        id: "725005",
        value: "Ajustador ferramenteiro"
    },
    {
        id: "725010",
        value: "Ajustador mec\u00e2nico"
    },
    {
        id: "725015",
        value: "Ajustador mec\u00e2nico (usinagem em bancada e em m\u00e1quinas-ferramentas)"
    },
    {
        id: "725020",
        value: "Ajustador mec\u00e2nico em bancada"
    },
    {
        id: "725025",
        value: "Ajustador naval (reparo e constru\u00e7\u00e3o)"
    },
    {
        id: "725105",
        value: "Montador de m\u00e1quinas, motores e acess\u00f3rios (montagem em s\u00e9rie)"
    },
    {
        id: "725205",
        value: "Montador de m\u00e1quinas"
    },
    {
        id: "725210",
        value: "Montador de m\u00e1quinas gr\u00e1ficas"
    },
    {
        id: "725225",
        value: "Montador de m\u00e1quinas-ferramentas (usinagem de metais)"
    },
    {
        id: "725220",
        value: "Montador de m\u00e1quinas t\u00eaxteis"
    },
    {
        id: "725215",
        value: "Montador de m\u00e1quinas operatrizes para madeira"
    },
    {
        id: "725315",
        value: "Montador de m\u00e1quinas de minas e pedreiras"
    },
    {
        id: "725310",
        value: "Montador de m\u00e1quinas agr\u00edcolas"
    },
    {
        id: "725320",
        value: "Montador de m\u00e1quinas de terraplenagem"
    },
    {
        id: "725305",
        value: "Montador de equipamento de levantamento"
    },
    {
        id: "725410",
        value: "Mec\u00e2nico montador de motores de embarca\u00e7\u00f5es"
    },
    {
        id: "725405",
        value: "Mec\u00e2nico montador de motores de aeronaves"
    },
    {
        id: "725415",
        value: "Mec\u00e2nico montador de motores de explos\u00e3o e diesel"
    },
    {
        id: "725420",
        value: "Mec\u00e2nico montador de turboalimentadores"
    },
    {
        id: "725505",
        value: "Montador de ve\u00edculos (linha de montagem)"
    },
    {
        id: "725510",
        value: "Operador de time de montagem"
    },
    {
        id: "725605",
        value: "Montador de estruturas de aeronaves"
    },
    {
        id: "725610",
        value: "Montador de sistemas de combust\u00edvel de aeronaves"
    },
    {
        id: "725705",
        value: "Mec\u00e2nico de refrigera\u00e7\u00e3o"
    },
    {
        id: "730105",
        value: "Supervisor de montagem e instala\u00e7\u00e3o eletroeletr\u00f4nica"
    },
    {
        id: "731115",
        value: "Montador de equipamentos el\u00e9tricos (instrumentos de medi\u00e7\u00e3o)"
    },
    {
        id: "731120",
        value: "Montador de equipamentos el\u00e9tricos (aparelhos eletrodom\u00e9sticos)"
    },
    {
        id: "731125",
        value: "Montador de equipamentos el\u00e9tricos (centrais el\u00e9tricas)"
    },
    {
        id: "731130",
        value: "Montador de equipamentos el\u00e9tricos (motores e d\u00ednamos)"
    },
    {
        id: "731135",
        value: "Montador de equipamentos el\u00e9tricos"
    },
    {
        id: "731140",
        value: "Montador de equipamentos eletr\u00f4nicos (instala\u00e7\u00f5es de sinaliza\u00e7\u00e3o)"
    },
    {
        id: "731145",
        value: "Montador de equipamentos eletr\u00f4nicos (m\u00e1quinas industriais)"
    },
    {
        id: "731150",
        value: "Montador de equipamentos eletr\u00f4nicos"
    },
    {
        id: "731155",
        value: "Montador de equipamentos el\u00e9tricos (elevadores e equipamentos similares)"
    },
    {
        id: "731160",
        value: "Montador de equipamentos el\u00e9tricos (transformadores)"
    },
    {
        id: "731165",
        value: "Bobinador eletricista, \u00e0 m\u00e3o"
    },
    {
        id: "731170",
        value: "Bobinador eletricista, \u00e0 m\u00e1quina"
    },
    {
        id: "731175",
        value: "Operador de linha de montagem (aparelhos el\u00e9tricos)"
    },
    {
        id: "731180",
        value: "Operador de linha de montagem (aparelhos eletr\u00f4nicos)"
    },
    {
        id: "731105",
        value: "Montador de equipamentos eletr\u00f4nicos (aparelhos m\u00e9dicos)"
    },
    {
        id: "731110",
        value: "Montador de equipamentos eletr\u00f4nicos (computadores e equipamentos auxiliares)"
    },
    {
        id: "731205",
        value: "Montador de equipamentos eletr\u00f4nicos (esta\u00e7\u00e3o de r\u00e1dio, tv e equipamentos de radar)"
    },
    {
        id: "731310",
        value: "Instalador-reparador de equipamentos de energia em telefonia"
    },
    {
        id: "731315",
        value: "Instalador-reparador de equipamentos de transmiss\u00e3o em telefonia"
    },
    {
        id: "731320",
        value: "Instalador-reparador de linhas e aparelhos de telecomunica\u00e7\u00f5es"
    },
    {
        id: "731325",
        value: "Instalador-reparador de redes e cabos telef\u00f4nicos"
    },
    {
        id: "731305",
        value: "Instalador-reparador de equipamentos de comuta\u00e7\u00e3o em telefonia"
    },
    {
        id: "731330",
        value: "Reparador de aparelhos de telecomunica\u00e7\u00f5es em laborat\u00f3rio"
    },
    {
        id: "732105",
        value: "Eletricista de manuten\u00e7\u00e3o de linhas el\u00e9tricas, telef\u00f4nicas e de comunica\u00e7\u00e3o de dados"
    },
    {
        id: "732110",
        value: "Emendador de cabos el\u00e9tricos e telef\u00f4nicos (a\u00e9reos e subterr\u00e2neos)"
    },
    {
        id: "732115",
        value: "Examinador de cabos, linhas el\u00e9tricas e telef\u00f4nicas"
    },
    {
        id: "732120",
        value: "Instalador de linhas el\u00e9tricas de alta e baixa - tens\u00e3o (rede a\u00e9rea e subterr\u00e2nea)"
    },
    {
        id: "732125",
        value: "Instalador eletricista (tra\u00e7\u00e3o de ve\u00edculos)"
    },
    {
        id: "732130",
        value: "Instalador-reparador de redes telef\u00f4nicas e de comunica\u00e7\u00e3o de dados"
    },
    {
        id: "732135",
        value: "Ligador de linhas telef\u00f4nicas"
    },
    {
        id: "740110",
        value: "Supervisor de fabrica\u00e7\u00e3o de instrumentos musicais"
    },
    {
        id: "740105",
        value: "Supervisor da mec\u00e2nica de precis\u00e3o"
    },
    {
        id: "741125",
        value: "Relojoeiro (repara\u00e7\u00e3o)"
    },
    {
        id: "741120",
        value: "Relojoeiro (fabrica\u00e7\u00e3o)"
    },
    {
        id: "741115",
        value: "Montador de instrumentos de precis\u00e3o"
    },
    {
        id: "741110",
        value: "Montador de instrumentos de \u00f3ptica"
    },
    {
        id: "741105",
        value: "Ajustador de instrumentos de precis\u00e3o"
    },
    {
        id: "742135",
        value: "Confeccionador de \u00f3rg\u00e3o"
    },
    {
        id: "742130",
        value: "Confeccionador de instrumentos de sopro (metal)"
    },
    {
        id: "742125",
        value: "Confeccionador de instrumentos de sopro (madeira)"
    },
    {
        id: "742120",
        value: "Confeccionador de instrumentos de percuss\u00e3o (pele, couro ou pl\u00e1stico)"
    },
    {
        id: "742115",
        value: "Confeccionador de instrumentos de corda"
    },
    {
        id: "742110",
        value: "Confeccionador de acorde\u00e3o"
    },
    {
        id: "742140",
        value: "Confeccionador de piano"
    },
    {
        id: "742105",
        value: "Afinador de instrumentos musicais"
    },
    {
        id: "750105",
        value: "Supervisor de joalheria"
    },
    {
        id: "750205",
        value: "Supervisor da ind\u00fastria de minerais n\u00e3o met\u00e1licos (exceto os derivados de petr\u00f3leo e carv\u00e3o)"
    },
    {
        id: "751005",
        value: "Engastador (j\u00f3ias)"
    },
    {
        id: "751010",
        value: "Joalheiro"
    },
    {
        id: "751015",
        value: "Joalheiro (repara\u00e7\u00f5es)"
    },
    {
        id: "751020",
        value: "Lapidador (j\u00f3ias)"
    },
    {
        id: "751105",
        value: "Bate-folha a  m\u00e1quina"
    },
    {
        id: "751110",
        value: "Fundidor (joalheria e ourivesaria)"
    },
    {
        id: "751130",
        value: "Trefilador (joalheria e ourivesaria)"
    },
    {
        id: "751125",
        value: "Ourives"
    },
    {
        id: "751120",
        value: "Laminador de metais preciosos a  m\u00e3o"
    },
    {
        id: "751115",
        value: "Gravador (joalheria e ourivesaria)"
    },
    {
        id: "752110",
        value: "Moldador (vidros)"
    },
    {
        id: "752105",
        value: "Artes\u00e3o modelador (vidros)"
    },
    {
        id: "752115",
        value: "Soprador de vidro"
    },
    {
        id: "752120",
        value: "Transformador de tubos de vidro"
    },
    {
        id: "752230",
        value: "Lapidador de vidros e cristais"
    },
    {
        id: "752235",
        value: "Surfassagista"
    },
    {
        id: "752205",
        value: "Aplicador serigr\u00e1fico em vidros"
    },
    {
        id: "752210",
        value: "Cortador de vidro"
    },
    {
        id: "752215",
        value: "Gravador de vidro a  \u00e1gua-forte"
    },
    {
        id: "752220",
        value: "Gravador de vidro a  esmeril"
    },
    {
        id: "752225",
        value: "Gravador de vidro a  jato de areia"
    },
    {
        id: "752305",
        value: "Ceramista"
    },
    {
        id: "752310",
        value: "Ceramista (torno de pedal e motor)"
    },
    {
        id: "752315",
        value: "Ceramista (torno semi-autom\u00e1tico)"
    },
    {
        id: "752320",
        value: "Ceramista modelador"
    },
    {
        id: "752325",
        value: "Ceramista moldador"
    },
    {
        id: "752330",
        value: "Ceramista prensador"
    },
    {
        id: "752405",
        value: "Decorador de cer\u00e2mica"
    },
    {
        id: "752410",
        value: "Decorador de vidro"
    },
    {
        id: "752415",
        value: "Decorador de vidro \u00e0 pincel"
    },
    {
        id: "752420",
        value: "Operador de esmaltadeira"
    },
    {
        id: "752425",
        value: "Operador de espelhamento"
    },
    {
        id: "752430",
        value: "Pintor de cer\u00e2mica, a  pincel"
    },
    {
        id: "760110",
        value: "Contramestre de fia\u00e7\u00e3o (ind\u00fastria t\u00eaxtil)"
    },
    {
        id: "760120",
        value: "Contramestre de tecelagem (ind\u00fastria t\u00eaxtil)"
    },
    {
        id: "760105",
        value: "Contramestre de acabamento (ind\u00fastria t\u00eaxtil)"
    },
    {
        id: "760125",
        value: "Mestre (ind\u00fastria t\u00eaxtil e de confec\u00e7\u00f5es)"
    },
    {
        id: "760115",
        value: "Contramestre de malharia (ind\u00fastria t\u00eaxtil)"
    },
    {
        id: "760205",
        value: "Supervisor de curtimento"
    },
    {
        id: "760310",
        value: "Encarregado de costura na confec\u00e7\u00e3o do vestu\u00e1rio"
    },
    {
        id: "760305",
        value: "Encarregado de corte na confec\u00e7\u00e3o do vestu\u00e1rio"
    },
    {
        id: "760405",
        value: "Supervisor  (ind\u00fastria de cal\u00e7ados e artefatos de couro)"
    },
    {
        id: "760505",
        value: "Supervisor da confec\u00e7\u00e3o de artefatos de tecidos, couros e afins"
    },
    {
        id: "760605",
        value: "Supervisor das artes gr\u00e1ficas  (ind\u00fastria editorial e gr\u00e1fica)"
    },
    {
        id: "761005",
        value: "Operador polivalente da ind\u00fastria t\u00eaxtil"
    },
    {
        id: "761110",
        value: "Lavador de l\u00e3"
    },
    {
        id: "761105",
        value: "Classificador de fibras t\u00eaxteis"
    },
    {
        id: "761210",
        value: "Operador de binadeira"
    },
    {
        id: "761260",
        value: "Operador de retorcedeira"
    },
    {
        id: "761255",
        value: "Operador de penteadeira"
    },
    {
        id: "761250",
        value: "Operador de passador (fia\u00e7\u00e3o)"
    },
    {
        id: "761245",
        value: "Operador de open-end"
    },
    {
        id: "761240",
        value: "Operador de ma\u00e7aroqueira"
    },
    {
        id: "761235",
        value: "Operador de laminadeira e reunideira"
    },
    {
        id: "761230",
        value: "Operador de filat\u00f3rio"
    },
    {
        id: "761225",
        value: "Operador de conicaleira"
    },
    {
        id: "761220",
        value: "Operador de cardas"
    },
    {
        id: "761215",
        value: "Operador de bobinadeira"
    },
    {
        id: "761205",
        value: "Operador de abertura (fia\u00e7\u00e3o)"
    },
    {
        id: "761312",
        value: "Tecel\u00e3o (tear jacquard)"
    },
    {
        id: "761321",
        value: "Tecel\u00e3o (tear mec\u00e2nico liso)"
    },
    {
        id: "761330",
        value: "Tecel\u00e3o de malhas (m\u00e1quina circular)"
    },
    {
        id: "761333",
        value: "Tecel\u00e3o de malhas (m\u00e1quina retil\u00ednea)"
    },
    {
        id: "761348",
        value: "Operador de engomadeira de urdume"
    },
    {
        id: "761351",
        value: "Operador de espuladeira"
    },
    {
        id: "761357",
        value: "Operador de urdideira"
    },
    {
        id: "761360",
        value: "Passamaneiro a  m\u00e1quina"
    },
    {
        id: "761363",
        value: "Remetedor de fios"
    },
    {
        id: "761303",
        value: "Tecel\u00e3o (redes)"
    },
    {
        id: "761306",
        value: "Tecel\u00e3o (rendas e bordados)"
    },
    {
        id: "761315",
        value: "Tecel\u00e3o (tear mec\u00e2nico de maquineta)"
    },
    {
        id: "761318",
        value: "Tecel\u00e3o (tear mec\u00e2nico de xadrez)"
    },
    {
        id: "761324",
        value: "Tecel\u00e3o (tear mec\u00e2nico, exceto jacquard)"
    },
    {
        id: "761327",
        value: "Tecel\u00e3o de malhas, a  m\u00e1quina"
    },
    {
        id: "761336",
        value: "Tecel\u00e3o de meias, a  m\u00e1quina"
    },
    {
        id: "761339",
        value: "Tecel\u00e3o de meias (m\u00e1quina circular)"
    },
    {
        id: "761342",
        value: "Tecel\u00e3o de meias (m\u00e1quina retil\u00ednea)"
    },
    {
        id: "761345",
        value: "Tecel\u00e3o de tapetes, a  m\u00e1quina"
    },
    {
        id: "761354",
        value: "Operador de m\u00e1quina de cordoalha"
    },
    {
        id: "761366",
        value: "Picotador de cart\u00f5es jacquard"
    },
    {
        id: "761309",
        value: "Tecel\u00e3o (tear autom\u00e1tico)"
    },
    {
        id: "761405",
        value: "Alvejador (tecidos)"
    },
    {
        id: "761410",
        value: "Estampador de tecido"
    },
    {
        id: "761415",
        value: "Operador de calandras (tecidos)"
    },
    {
        id: "761420",
        value: "Operador de chamuscadeira de tecidos"
    },
    {
        id: "761425",
        value: "Operador de impermeabilizador de tecidos"
    },
    {
        id: "761430",
        value: "Operador de m\u00e1quina de lavar fios e tecidos"
    },
    {
        id: "761435",
        value: "Operador de rameuse"
    },
    {
        id: "761805",
        value: "Inspetor de estamparia (produ\u00e7\u00e3o t\u00eaxtil)"
    },
    {
        id: "761810",
        value: "Revisor de fios (produ\u00e7\u00e3o t\u00eaxtil)"
    },
    {
        id: "761815",
        value: "Revisor de tecidos acabados"
    },
    {
        id: "761820",
        value: "Revisor de tecidos crus"
    },
    {
        id: "762005",
        value: "Trabalhador polivalente do curtimento de couros e peles"
    },
    {
        id: "762110",
        value: "Descarnador de couros e peles, \u00e0 maquina"
    },
    {
        id: "762105",
        value: "Classificador de peles"
    },
    {
        id: "762115",
        value: "Estirador de couros e peles (prepara\u00e7\u00e3o)"
    },
    {
        id: "762120",
        value: "Fuloneiro"
    },
    {
        id: "762125",
        value: "Rachador de couros e peles"
    },
    {
        id: "762215",
        value: "Enxugador de couros"
    },
    {
        id: "762210",
        value: "Classificador de couros"
    },
    {
        id: "762205",
        value: "Curtidor (couros e peles)"
    },
    {
        id: "762220",
        value: "Rebaixador de couros"
    },
    {
        id: "762305",
        value: "Estirador de couros e peles (acabamento)"
    },
    {
        id: "762310",
        value: "Fuloneiro no acabamento de couros e peles"
    },
    {
        id: "762315",
        value: "Lixador de couros e peles"
    },
    {
        id: "762320",
        value: "Matizador de couros e peles"
    },
    {
        id: "762345",
        value: "Vaqueador de couros e peles"
    },
    {
        id: "762330",
        value: "Prensador de couros e peles"
    },
    {
        id: "762335",
        value: "Palecionador de couros e peles"
    },
    {
        id: "762340",
        value: "Preparador de couros curtidos"
    },
    {
        id: "762325",
        value: "Operador de m\u00e1quinas do acabamento de couros e peles"
    },
    {
        id: "763020",
        value: "Costureiro de roupa de couro e pele"
    },
    {
        id: "763005",
        value: "Alfaiate"
    },
    {
        id: "763010",
        value: "Costureira de pe\u00e7as sob encomenda"
    },
    {
        id: "763015",
        value: "Costureira de repara\u00e7\u00e3o de roupas"
    },
    {
        id: "763125",
        value: "Ajudante de confec\u00e7\u00e3o"
    },
    {
        id: "763120",
        value: "Riscador de roupas"
    },
    {
        id: "763115",
        value: "Enfestador de roupas"
    },
    {
        id: "763105",
        value: "Auxiliar de corte (prepara\u00e7\u00e3o da confec\u00e7\u00e3o de roupas)"
    },
    {
        id: "763110",
        value: "Cortador de roupas"
    },
    {
        id: "763215",
        value: "Costureiro, a  m\u00e1quina  na confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        id: "763210",
        value: "Costureiro na confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        id: "763205",
        value: "Costureiro de roupas de couro e pele, a  m\u00e1quina na  confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        id: "763310",
        value: "Bordador, \u00e0 m\u00e1quina"
    },
    {
        id: "763315",
        value: "Marcador de pe\u00e7as confeccionadas para bordar"
    },
    {
        id: "763320",
        value: "Operador de m\u00e1quina de costura de acabamento"
    },
    {
        id: "763325",
        value: "Passadeira de pe\u00e7as confeccionadas"
    },
    {
        id: "763305",
        value: "Arrematadeira"
    },
    {
        id: "764005",
        value: "Trabalhador polivalente da confec\u00e7\u00e3o de cal\u00e7ados"
    },
    {
        id: "764110",
        value: "Cortador de solas e palmilhas, a  m\u00e1quina"
    },
    {
        id: "764105",
        value: "Cortador de cal\u00e7ados, a  m\u00e1quina (exceto solas e palmilhas)"
    },
    {
        id: "764115",
        value: "Preparador de cal\u00e7ados"
    },
    {
        id: "764120",
        value: "Preparador de solas e palmilhas"
    },
    {
        id: "764205",
        value: "Costurador de cal\u00e7ados, a  m\u00e1quina"
    },
    {
        id: "764210",
        value: "Montador de cal\u00e7ados"
    },
    {
        id: "764305",
        value: "Acabador de cal\u00e7ados"
    },
    {
        id: "765010",
        value: "Chapeleiro de senhoras"
    },
    {
        id: "765005",
        value: "Confeccionador de artefatos de couro (exceto sapatos)"
    },
    {
        id: "765015",
        value: "Boneleiro"
    },
    {
        id: "765105",
        value: "Cortador de artefatos de couro (exceto roupas e cal\u00e7ados)"
    },
    {
        id: "765110",
        value: "Cortador de tape\u00e7aria"
    },
    {
        id: "765240",
        value: "Tapeceiro de autos"
    },
    {
        id: "765235",
        value: "Estofador de m\u00f3veis"
    },
    {
        id: "765225",
        value: "Confeccionador de velas n\u00e1uticas, barracas e toldos"
    },
    {
        id: "765215",
        value: "Confeccionador de brinquedos de pano"
    },
    {
        id: "765205",
        value: "Colchoeiro (confec\u00e7\u00e3o de colch\u00f5es)"
    },
    {
        id: "765230",
        value: "Estofador de avi\u00f5es"
    },
    {
        id: "765310",
        value: "Costurador de artefatos de couro, a  m\u00e1quina (exceto roupas e cal\u00e7ados)"
    },
    {
        id: "765315",
        value: "Montador de artefatos de couro (exceto roupas e cal\u00e7ados)"
    },
    {
        id: "765405",
        value: "Trabalhador do acabamento de artefatos de tecidos e couros"
    },
    {
        id: "766115",
        value: "Gravador de matriz para flexografia (clicherista)"
    },
    {
        id: "766105",
        value: "Copiador de chapa"
    },
    {
        id: "766155",
        value: "Programador visual gr\u00e1fico"
    },
    {
        id: "766150",
        value: "Operador de processo de tratamento de imagem"
    },
    {
        id: "766145",
        value: "Operador de sistemas de prova (anal\u00f3gico e digital)"
    },
    {
        id: "766140",
        value: "Gravador de matriz serigr\u00e1fica"
    },
    {
        id: "766135",
        value: "Gravador de matriz calcogr\u00e1fica"
    },
    {
        id: "766130",
        value: "Gravador de matriz para rotogravura (eletromec\u00e2nico e qu\u00edmico)"
    },
    {
        id: "766125",
        value: "Montador de fotolito (anal\u00f3gico e digital)"
    },
    {
        id: "766120",
        value: "Editor de texto e imagem"
    },
    {
        id: "766230",
        value: "Impressor digital"
    },
    {
        id: "766225",
        value: "Impressor de rotogravura"
    },
    {
        id: "766220",
        value: "Impressor de rotativa"
    },
    {
        id: "766215",
        value: "Impressor de ofsete (plano e rotativo)"
    },
    {
        id: "766240",
        value: "Impressor letterset"
    },
    {
        id: "766205",
        value: "Impressor (serigrafia)"
    },
    {
        id: "766235",
        value: "Impressor flexogr\u00e1fico"
    },
    {
        id: "766245",
        value: "Impressor tampogr\u00e1fico"
    },
    {
        id: "766250",
        value: "Impressor tipogr\u00e1fico"
    },
    {
        id: "766210",
        value: "Impressor calcogr\u00e1fico"
    },
    {
        id: "766310",
        value: "Impressor de corte e vinco"
    },
    {
        id: "766305",
        value: "Acabador de embalagens (flex\u00edveis e cartot\u00e9cnicas)"
    },
    {
        id: "766320",
        value: "Operador de guilhotina (corte de papel)"
    },
    {
        id: "766315",
        value: "Operador de acabamento (ind\u00fastria gr\u00e1fica)"
    },
    {
        id: "766325",
        value: "Preparador de matrizes de corte e vinco"
    },
    {
        id: "766405",
        value: "Laboratorista fotogr\u00e1fico"
    },
    {
        id: "766410",
        value: "Revelador de filmes fotogr\u00e1ficos, em preto e branco"
    },
    {
        id: "766420",
        value: "Auxiliar de radiologia (revela\u00e7\u00e3o fotogr\u00e1fica)"
    },
    {
        id: "766415",
        value: "Revelador de filmes fotogr\u00e1ficos, em cores"
    },
    {
        id: "768105",
        value: "Tecel\u00e3o (tear manual)"
    },
    {
        id: "768130",
        value: "Crocheteiro, a  m\u00e3o"
    },
    {
        id: "768125",
        value: "Chapeleiro (chap\u00e9us de palha)"
    },
    {
        id: "768120",
        value: "Redeiro"
    },
    {
        id: "768115",
        value: "Tricoteiro, \u00e0 m\u00e3o"
    },
    {
        id: "768110",
        value: "Tecel\u00e3o de tapetes, a  m\u00e3o"
    },
    {
        id: "768205",
        value: "Bordador, a  m\u00e3o"
    },
    {
        id: "768210",
        value: "Cerzidor"
    },
    {
        id: "768315",
        value: "Costurador de artefatos de couro, a  m\u00e3o (exceto roupas e cal\u00e7ados)"
    },
    {
        id: "768320",
        value: "Sapateiro (cal\u00e7ados sob medida)"
    },
    {
        id: "768325",
        value: "Seleiro"
    },
    {
        id: "768305",
        value: "Art\u00edfice do couro"
    },
    {
        id: "768310",
        value: "Cortador de cal\u00e7ados, a  m\u00e3o (exceto solas)"
    },
    {
        id: "768605",
        value: "Tip\u00f3grafo"
    },
    {
        id: "768630",
        value: "Confeccionador de carimbos de borracha"
    },
    {
        id: "768625",
        value: "Pintor de letreiros"
    },
    {
        id: "768620",
        value: "Paginador"
    },
    {
        id: "768615",
        value: "Monotipista"
    },
    {
        id: "768610",
        value: "Linotipista"
    },
    {
        id: "768705",
        value: "Gravador, \u00e0 m\u00e3o (encaderna\u00e7\u00e3o)"
    },
    {
        id: "768710",
        value: "Restaurador de livros"
    },
    {
        id: "770105",
        value: "Mestre (ind\u00fastria de madeira e mobili\u00e1rio)"
    },
    {
        id: "770110",
        value: "Mestre carpinteiro"
    },
    {
        id: "771120",
        value: "Tanoeiro"
    },
    {
        id: "771115",
        value: "Maquetista na marcenaria"
    },
    {
        id: "771110",
        value: "Modelador de madeira"
    },
    {
        id: "771105",
        value: "Marceneiro"
    },
    {
        id: "772105",
        value: "Classificador de madeira"
    },
    {
        id: "772110",
        value: "Impregnador de madeira"
    },
    {
        id: "772115",
        value: "Secador de madeira"
    },
    {
        id: "773125",
        value: "Serrador de madeira (serra circular m\u00faltipla)"
    },
    {
        id: "773130",
        value: "Serrador de madeira (serra de fita m\u00faltipla)"
    },
    {
        id: "773120",
        value: "Serrador de madeira"
    },
    {
        id: "773115",
        value: "Serrador de bordas no desdobramento de madeira"
    },
    {
        id: "773105",
        value: "Cortador de laminados de madeira"
    },
    {
        id: "773110",
        value: "Operador de serras no desdobramento de madeira"
    },
    {
        id: "773220",
        value: "Preparador de aglomerantes"
    },
    {
        id: "773215",
        value: "Prensista de compensados"
    },
    {
        id: "773210",
        value: "Prensista de aglomerados"
    },
    {
        id: "773205",
        value: "Operador de m\u00e1quina intercaladora e placas (compensados)"
    },
    {
        id: "773315",
        value: "Operador de fresadora (usinagem de madeira)"
    },
    {
        id: "773355",
        value: "Torneiro na usinagem convencional de madeira"
    },
    {
        id: "773350",
        value: "Operador de tupia (usinagem de madeira)"
    },
    {
        id: "773345",
        value: "Operador de torno autom\u00e1tico (usinagem de madeira)"
    },
    {
        id: "773340",
        value: "Operador de serras (usinagem de madeira)"
    },
    {
        id: "773335",
        value: "Operador de plaina desengrossadeira"
    },
    {
        id: "773330",
        value: "Operador de molduradora (usinagem de madeira)"
    },
    {
        id: "773325",
        value: "Operador de m\u00e1quina de usinagem madeira, em geral"
    },
    {
        id: "773320",
        value: "Operador de lixadeira (usinagem de madeira)"
    },
    {
        id: "773310",
        value: "Operador de entalhadeira (usinagem de madeira)"
    },
    {
        id: "773305",
        value: "Operador de desempenadeira na usinagem convencional de madeira"
    },
    {
        id: "773410",
        value: "Operador de m\u00e1quina de cortina d\u00b4\u00e1gua (produ\u00e7\u00e3o de m\u00f3veis)"
    },
    {
        id: "773405",
        value: "Operador de m\u00e1quina bordatriz"
    },
    {
        id: "773415",
        value: "Operador de m\u00e1quina de usinagem de madeira (produ\u00e7\u00e3o em s\u00e9rie)"
    },
    {
        id: "773420",
        value: "Operador de prensa de alta freq\u00fc\u00eancia na usinagem de madeira"
    },
    {
        id: "773505",
        value: "Operador de centro de usinagem de madeira (cnc)"
    },
    {
        id: "773510",
        value: "Operador de m\u00e1quinas de usinar madeira (cnc)"
    },
    {
        id: "774105",
        value: "Montador de m\u00f3veis e artefatos de madeira"
    },
    {
        id: "775115",
        value: "Lustrador de pe\u00e7as de madeira"
    },
    {
        id: "775110",
        value: "Folheador de m\u00f3veis de madeira"
    },
    {
        id: "775105",
        value: "Entalhador  de madeira"
    },
    {
        id: "775120",
        value: "Marcheteiro"
    },
    {
        id: "776430",
        value: "Vassoureiro"
    },
    {
        id: "776415",
        value: "Confeccionador de escovas, pinc\u00e9is e produtos similares (a m\u00e1quina)"
    },
    {
        id: "776420",
        value: "Confeccionador de m\u00f3veis de vime, junco e bambu"
    },
    {
        id: "776410",
        value: "Confeccionador de escovas, pinc\u00e9is e produtos similares (a m\u00e3o)"
    },
    {
        id: "776425",
        value: "Esteireiro"
    },
    {
        id: "776405",
        value: "Cesteiro"
    },
    {
        id: "777110",
        value: "Carpinteiro naval (embarca\u00e7\u00f5es)"
    },
    {
        id: "777115",
        value: "Carpinteiro naval (estaleiros)"
    },
    {
        id: "777105",
        value: "Carpinteiro naval (constru\u00e7\u00e3o de pequenas embarca\u00e7\u00f5es)"
    },
    {
        id: "777205",
        value: "Carpinteiro de carretas"
    },
    {
        id: "777210",
        value: "Carpinteiro de carrocerias"
    },
    {
        id: "780105",
        value: "Supervisor de embalagem e etiquetagem"
    },
    {
        id: "781110",
        value: "Condutor de processos robotizados de soldagem"
    },
    {
        id: "781105",
        value: "Condutor de processos robotizados de pintura"
    },
    {
        id: "781305",
        value: "Operador de ve\u00edculos subaqu\u00e1ticos controlados remotamente"
    },
    {
        id: "781705",
        value: "Mergulhador profissional (raso e profundo)"
    },
    {
        id: "782115",
        value: "Operador de guindaste m\u00f3vel"
    },
    {
        id: "782110",
        value: "Operador de guindaste (fixo)"
    },
    {
        id: "782105",
        value: "Operador de draga"
    },
    {
        id: "782120",
        value: "Operador de m\u00e1quina rodoferrovi\u00e1ria"
    },
    {
        id: "782140",
        value: "Operador de talha el\u00e9trica"
    },
    {
        id: "782145",
        value: "Sinaleiro (ponte-rolante)"
    },
    {
        id: "782135",
        value: "Operador de p\u00f3rtico rolante"
    },
    {
        id: "782130",
        value: "Operador de ponte rolante"
    },
    {
        id: "782125",
        value: "Operador de monta-cargas (constru\u00e7\u00e3o civil)"
    },
    {
        id: "782205",
        value: "Guincheiro (constru\u00e7\u00e3o civil)"
    },
    {
        id: "782210",
        value: "Operador de docagem"
    },
    {
        id: "782220",
        value: "Operador de empilhadeira"
    },
    {
        id: "782320",
        value: "Condutor de ambul\u00e2ncia"
    },
    {
        id: "782305",
        value: "Motorista de carro de passeio"
    },
    {
        id: "782310",
        value: "Motorista de furg\u00e3o ou ve\u00edculo similar"
    },
    {
        id: "782315",
        value: "Motorista de t\u00e1xi"
    },
    {
        id: "782410",
        value: "Motorista de \u00f4nibus urbano"
    },
    {
        id: "782405",
        value: "Motorista de \u00f4nibus rodovi\u00e1rio"
    },
    {
        id: "782415",
        value: "Motorista de tr\u00f3lebus"
    },
    {
        id: "782505",
        value: "Caminhoneiro aut\u00f4nomo (rotas regionais e internacionais)"
    },
    {
        id: "782510",
        value: "Motorista de caminh\u00e3o (rotas regionais e internacionais)"
    },
    {
        id: "782515",
        value: "Motorista operacional de guincho"
    },
    {
        id: "782615",
        value: "Maquinista de trem metropolitano"
    },
    {
        id: "782610",
        value: "Maquinista de trem"
    },
    {
        id: "782630",
        value: "Operador de telef\u00e9rico (passageiros)"
    },
    {
        id: "782605",
        value: "Operador de trem de metr\u00f4"
    },
    {
        id: "782625",
        value: "Auxiliar de maquinista de trem"
    },
    {
        id: "782620",
        value: "Motorneiro"
    },
    {
        id: "782735",
        value: "Marinheiro auxiliar de m\u00e1quinas (mar\u00edtimo e aquavi\u00e1rio)"
    },
    {
        id: "782730",
        value: "Marinheiro auxiliar de conv\u00e9s (mar\u00edtimo e aquaviario)"
    },
    {
        id: "782725",
        value: "Marinheiro de esporte e recreio"
    },
    {
        id: "782720",
        value: "Mo\u00e7o de m\u00e1quinas (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        id: "782715",
        value: "Mo\u00e7o de conv\u00e9s (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        id: "782705",
        value: "Marinheiro de conv\u00e9s (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        id: "782710",
        value: "Marinheiro de m\u00e1quinas"
    },
    {
        id: "782820",
        value: "Condutor de ve\u00edculos a pedais"
    },
    {
        id: "782815",
        value: "Boiadeiro"
    },
    {
        id: "782810",
        value: "Tropeiro"
    },
    {
        id: "782805",
        value: "Condutor de ve\u00edculos de tra\u00e7\u00e3o animal (ruas e estradas)"
    },
    {
        id: "783105",
        value: "Agente de p\u00e1tio"
    },
    {
        id: "783110",
        value: "Manobrador"
    },
    {
        id: "783205",
        value: "Carregador (aeronaves)"
    },
    {
        id: "783210",
        value: "Carregador (armaz\u00e9m)"
    },
    {
        id: "783215",
        value: "Carregador (ve\u00edculos de transportes terrestres)"
    },
    {
        id: "783220",
        value: "Estivador"
    },
    {
        id: "783235",
        value: "Trabalhador portu\u00e1rio de capatazia"
    },
    {
        id: "783230",
        value: "Bloqueiro (trabalhador portu\u00e1rio)"
    },
    {
        id: "783225",
        value: "Ajudante de motorista"
    },
    {
        id: "784105",
        value: "Embalador, a m\u00e3o"
    },
    {
        id: "784110",
        value: "Embalador, a m\u00e1quina"
    },
    {
        id: "784115",
        value: "Operador de m\u00e1quina de etiquetar"
    },
    {
        id: "784120",
        value: "Operador de m\u00e1quina de envasar l\u00edquidos"
    },
    {
        id: "784125",
        value: "Operador de prensa de enfardamento"
    },
    {
        id: "784205",
        value: "Alimentador de linha de produ\u00e7\u00e3o"
    },
    {
        id: "791105",
        value: "Artes\u00e3o bordador"
    },
    {
        id: "791110",
        value: "Artes\u00e3o ceramista"
    },
    {
        id: "791115",
        value: "Artes\u00e3o com material recicl\u00e1vel"
    },
    {
        id: "791120",
        value: "Artes\u00e3o confeccionador de bioj\u00f3ias e ecoj\u00f3ias"
    },
    {
        id: "791125",
        value: "Artes\u00e3o do couro"
    },
    {
        id: "791160",
        value: "Artes\u00e3o rendeiro"
    },
    {
        id: "791135",
        value: "Artes\u00e3o moveleiro (exceto reciclado)"
    },
    {
        id: "791140",
        value: "Artes\u00e3o tecel\u00e3o"
    },
    {
        id: "791145",
        value: "Artes\u00e3o tran\u00e7ador"
    },
    {
        id: "791150",
        value: "Artes\u00e3o crocheteiro"
    },
    {
        id: "791155",
        value: "Artes\u00e3o tricoteiro"
    },
    {
        id: "791130",
        value: "Artes\u00e3o escultor"
    },
    {
        id: "810110",
        value: "Mestre de produ\u00e7\u00e3o qu\u00edmica"
    },
    {
        id: "810105",
        value: "Mestre (ind\u00fastria petroqu\u00edmica e carboqu\u00edmica)"
    },
    {
        id: "810205",
        value: "Mestre (ind\u00fastria de borracha e pl\u00e1stico)"
    },
    {
        id: "810305",
        value: "Mestre de produ\u00e7\u00e3o farmac\u00eautica"
    },
    {
        id: "811005",
        value: "Operador de processos qu\u00edmicos e petroqu\u00edmicos"
    },
    {
        id: "811010",
        value: "Operador de sala de controle de instala\u00e7\u00f5es qu\u00edmicas, petroqu\u00edmicas e afins"
    },
    {
        id: "811105",
        value: "Moleiro (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811115",
        value: "Operador de britadeira (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811120",
        value: "Operador de concentra\u00e7\u00e3o"
    },
    {
        id: "811125",
        value: "Trabalhador da fabrica\u00e7\u00e3o de resinas e vernizes"
    },
    {
        id: "811130",
        value: "Trabalhador de fabrica\u00e7\u00e3o de tintas"
    },
    {
        id: "811110",
        value: "Operador de m\u00e1quina misturadeira (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811215",
        value: "Operador de tratamento qu\u00edmico de materiais radioativos"
    },
    {
        id: "811205",
        value: "Operador de calcina\u00e7\u00e3o (tratamento qu\u00edmico e afins)"
    },
    {
        id: "811330",
        value: "Operador de filtro-prensa (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811335",
        value: "Operador de filtros de parafina (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811325",
        value: "Operador de filtro-esteira (minera\u00e7\u00e3o)"
    },
    {
        id: "811320",
        value: "Operador de filtro de tambor rotativo (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811315",
        value: "Operador de filtro de secagem (minera\u00e7\u00e3o)"
    },
    {
        id: "811310",
        value: "Operador de explora\u00e7\u00e3o de petr\u00f3leo"
    },
    {
        id: "811305",
        value: "Operador de centrifugadora (tratamentos qu\u00edmicos e afins)"
    },
    {
        id: "811410",
        value: "Destilador de produtos qu\u00edmicos (exceto petr\u00f3leo)"
    },
    {
        id: "811405",
        value: "Destilador de madeira"
    },
    {
        id: "811415",
        value: "Operador de alambique de funcionamento cont\u00ednuo (produtos qu\u00edmicos, exceto petr\u00f3leo)"
    },
    {
        id: "811420",
        value: "Operador de aparelho de rea\u00e7\u00e3o e convers\u00e3o (produtos qu\u00edmicos, exceto petr\u00f3leo)"
    },
    {
        id: "811425",
        value: "Operador de equipamento de destila\u00e7\u00e3o de \u00e1lcool"
    },
    {
        id: "811430",
        value: "Operador de evaporador na destila\u00e7\u00e3o"
    },
    {
        id: "811505",
        value: "Operador de painel de controle (refina\u00e7\u00e3o de petr\u00f3leo)"
    },
    {
        id: "811510",
        value: "Operador de transfer\u00eancia e estocagem - na refina\u00e7\u00e3o do petr\u00f3leo"
    },
    {
        id: "811610",
        value: "Operador de carro de apagamento e coque"
    },
    {
        id: "811605",
        value: "Operador de britador de coque"
    },
    {
        id: "811615",
        value: "Operador de destila\u00e7\u00e3o e subprodutos de coque"
    },
    {
        id: "811650",
        value: "Operador de sistema de revers\u00e3o (coqueria)"
    },
    {
        id: "811645",
        value: "Operador de refrigera\u00e7\u00e3o (coqueria)"
    },
    {
        id: "811640",
        value: "Operador de reator de coque de petr\u00f3leo"
    },
    {
        id: "811635",
        value: "Operador de preserva\u00e7\u00e3o e controle t\u00e9rmico"
    },
    {
        id: "811630",
        value: "Operador de painel de controle"
    },
    {
        id: "811625",
        value: "Operador de exaustor (coqueria)"
    },
    {
        id: "811620",
        value: "Operador de enfornamento e desenfornamento de coque"
    },
    {
        id: "811705",
        value: "Bamburista"
    },
    {
        id: "811710",
        value: "Calandrista de borracha"
    },
    {
        id: "811715",
        value: "Confeccionador de pneum\u00e1ticos"
    },
    {
        id: "811725",
        value: "Confeccionador de velas por imers\u00e3o"
    },
    {
        id: "811775",
        value: "Trefilador de borracha"
    },
    {
        id: "811745",
        value: "Laminador de pl\u00e1stico"
    },
    {
        id: "811750",
        value: "Moldador de borracha por compress\u00e3o"
    },
    {
        id: "811760",
        value: "Moldador de pl\u00e1stico por compress\u00e3o"
    },
    {
        id: "811770",
        value: "Moldador de pl\u00e1stico por inje\u00e7\u00e3o"
    },
    {
        id: "811735",
        value: "Confeccionador de velas por moldagem"
    },
    {
        id: "811805",
        value: "Operador de m\u00e1quina de produtos farmac\u00eauticos"
    },
    {
        id: "811810",
        value: "Drageador (medicamentos)"
    },
    {
        id: "811820",
        value: "Operador de m\u00e1quina de fabrica\u00e7\u00e3o de produtos de higiene e limpeza (sab\u00e3o, sabonete, detergente, absorvente, fraldas cotonetes e outros)"
    },
    {
        id: "811815",
        value: "Operador de m\u00e1quina de fabrica\u00e7\u00e3o de cosm\u00e9ticos"
    },
    {
        id: "812105",
        value: "Pirot\u00e9cnico"
    },
    {
        id: "812110",
        value: "Trabalhador da fabrica\u00e7\u00e3o de muni\u00e7\u00e3o e explosivos"
    },
    {
        id: "813125",
        value: "Operador de produ\u00e7\u00e3o (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        id: "813110",
        value: "Operador de calandra (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        id: "813130",
        value: "T\u00e9cnico de opera\u00e7\u00e3o (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        id: "813120",
        value: "Operador de processo (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        id: "813115",
        value: "Operador de extrusora (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        id: "813105",
        value: "Cilindrista (petroqu\u00edmica e afins)"
    },
    {
        id: "818110",
        value: "Auxiliar de laborat\u00f3rio de an\u00e1lises f\u00edsico-qu\u00edmicas"
    },
    {
        id: "818105",
        value: "Assistente de laborat\u00f3rio industrial"
    },
    {
        id: "820105",
        value: "Mestre de siderurgia"
    },
    {
        id: "820110",
        value: "Mestre de aciaria"
    },
    {
        id: "820115",
        value: "Mestre de alto-forno"
    },
    {
        id: "820120",
        value: "Mestre de forno el\u00e9trico"
    },
    {
        id: "820125",
        value: "Mestre de lamina\u00e7\u00e3o"
    },
    {
        id: "820205",
        value: "Supervisor de fabrica\u00e7\u00e3o de produtos cer\u00e2micos, porcelanatos e afins"
    },
    {
        id: "820210",
        value: "Supervisor de fabrica\u00e7\u00e3o de produtos de vidro"
    },
    {
        id: "821105",
        value: "Operador de centro de controle"
    },
    {
        id: "821110",
        value: "Operador de m\u00e1quina de sinterizar"
    },
    {
        id: "821210",
        value: "Forneiro e operador (conversor a oxig\u00eanio)"
    },
    {
        id: "821215",
        value: "Forneiro e operador (forno el\u00e9trico)"
    },
    {
        id: "821220",
        value: "Forneiro e operador (refino de metais n\u00e3o-ferrosos)"
    },
    {
        id: "821225",
        value: "Forneiro e operador de forno de redu\u00e7\u00e3o direta"
    },
    {
        id: "821230",
        value: "Operador de aciaria (basculamento de convertedor)"
    },
    {
        id: "821235",
        value: "Operador de aciaria (dessulfura\u00e7\u00e3o de gusa)"
    },
    {
        id: "821240",
        value: "Operador de aciaria (recebimento de gusa)"
    },
    {
        id: "821245",
        value: "Operador de \u00e1rea de corrida"
    },
    {
        id: "821250",
        value: "Operador de desgaseifica\u00e7\u00e3o"
    },
    {
        id: "821255",
        value: "Soprador de convertedor"
    },
    {
        id: "821205",
        value: "Forneiro e operador (alto-forno)"
    },
    {
        id: "821315",
        value: "Operador de laminador de barras a quente"
    },
    {
        id: "821310",
        value: "Operador de laminador de barras a frio"
    },
    {
        id: "821305",
        value: "Operador de laminador"
    },
    {
        id: "821320",
        value: "Operador de laminador de metais n\u00e3o-ferrosos"
    },
    {
        id: "821325",
        value: "Operador de laminador de tubos"
    },
    {
        id: "821330",
        value: "Operador de montagem de cilindros e mancais"
    },
    {
        id: "821335",
        value: "Recuperador de guias e cilindros"
    },
    {
        id: "821415",
        value: "Marcador de produtos (sider\u00fargico e metal\u00fargico)"
    },
    {
        id: "821410",
        value: "Escarfador"
    },
    {
        id: "821405",
        value: "Encarregado de acabamento de chapas e metais  (t\u00eampera)"
    },
    {
        id: "821420",
        value: "Operador de bobinadeira de tiras a quente, no acabamento de chapas e metais"
    },
    {
        id: "821450",
        value: "Rebarbador de metal"
    },
    {
        id: "821445",
        value: "Preparador de sucata e aparas"
    },
    {
        id: "821440",
        value: "Operador de tesoura mec\u00e2nica e m\u00e1quina de corte, no acabamento de chapas e metais"
    },
    {
        id: "821435",
        value: "Operador de jato abrasivo"
    },
    {
        id: "821425",
        value: "Operador de cabine de lamina\u00e7\u00e3o (fio-m\u00e1quina)"
    },
    {
        id: "821430",
        value: "Operador de esc\u00f3ria e sucata"
    },
    {
        id: "822110",
        value: "Forneiro de forno-po\u00e7o"
    },
    {
        id: "822105",
        value: "Forneiro de cubil\u00f4"
    },
    {
        id: "822120",
        value: "Forneiro de reaquecimento e tratamento t\u00e9rmico na metalurgia"
    },
    {
        id: "822115",
        value: "Forneiro de fundi\u00e7\u00e3o (forno de redu\u00e7\u00e3o)"
    },
    {
        id: "822125",
        value: "Forneiro de rev\u00e9rbero"
    },
    {
        id: "823105",
        value: "Preparador de massa (fabrica\u00e7\u00e3o de abrasivos)"
    },
    {
        id: "823135",
        value: "Operador de atomizador"
    },
    {
        id: "823130",
        value: "Preparador de aditivos"
    },
    {
        id: "823125",
        value: "Preparador de esmaltes (cer\u00e2mica)"
    },
    {
        id: "823120",
        value: "Preparador de barbotina"
    },
    {
        id: "823115",
        value: "Preparador de massa de argila"
    },
    {
        id: "823110",
        value: "Preparador de massa (fabrica\u00e7\u00e3o de vidro)"
    },
    {
        id: "823210",
        value: "Extrusor de fios ou fibras de vidro"
    },
    {
        id: "823215",
        value: "Forneiro na fundi\u00e7\u00e3o de vidro"
    },
    {
        id: "823265",
        value: "Trabalhador na fabrica\u00e7\u00e3o de produtos abrasivos"
    },
    {
        id: "823255",
        value: "Temperador de vidro"
    },
    {
        id: "823250",
        value: "Operador de prensa de moldar vidro"
    },
    {
        id: "823245",
        value: "Operador de m\u00e1quina extrusora de varetas e tubos de vidro"
    },
    {
        id: "823240",
        value: "Operador de m\u00e1quina de soprar vidro"
    },
    {
        id: "823235",
        value: "Operador de banho met\u00e1lico de vidro por flutua\u00e7\u00e3o"
    },
    {
        id: "823220",
        value: "Forneiro no recozimento de vidro"
    },
    {
        id: "823230",
        value: "Moldador de abrasivos na fabrica\u00e7\u00e3o de cer\u00e2mica, vidro e porcelana"
    },
    {
        id: "823320",
        value: "Trabalhador da elabora\u00e7\u00e3o de pr\u00e9-fabricados (cimento amianto)"
    },
    {
        id: "823325",
        value: "Trabalhador da elabora\u00e7\u00e3o de pr\u00e9-fabricados (concreto armado)"
    },
    {
        id: "823330",
        value: "Trabalhador da fabrica\u00e7\u00e3o de pedras artificiais"
    },
    {
        id: "823305",
        value: "Classificador e empilhador de tijolos refrat\u00e1rios"
    },
    {
        id: "823315",
        value: "Forneiro (materiais de constru\u00e7\u00e3o)"
    },
    {
        id: "828105",
        value: "Oleiro (fabrica\u00e7\u00e3o de telhas)"
    },
    {
        id: "828110",
        value: "Oleiro (fabrica\u00e7\u00e3o de tijolos)"
    },
    {
        id: "830105",
        value: "Mestre (ind\u00fastria de celulose, papel e papel\u00e3o)"
    },
    {
        id: "831105",
        value: "Cilindreiro na prepara\u00e7\u00e3o de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        id: "831110",
        value: "Operador de branqueador de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        id: "831115",
        value: "Operador de digestor de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        id: "831120",
        value: "Operador de lavagem e depura\u00e7\u00e3o de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        id: "831125",
        value: "Operador de m\u00e1quina de secar celulose"
    },
    {
        id: "832110",
        value: "Operador de cortadeira de papel"
    },
    {
        id: "832105",
        value: "Calandrista de papel"
    },
    {
        id: "832115",
        value: "Operador de m\u00e1quina de fabricar papel  (fase \u00famida)"
    },
    {
        id: "832135",
        value: "Operador de rebobinadeira na fabrica\u00e7\u00e3o de papel e papel\u00e3o"
    },
    {
        id: "832125",
        value: "Operador de m\u00e1quina de fabricar papel e papel\u00e3o"
    },
    {
        id: "832120",
        value: "Operador de m\u00e1quina de fabricar papel (fase seca)"
    },
    {
        id: "833105",
        value: "Cartonageiro, a m\u00e1quina"
    },
    {
        id: "833110",
        value: "Confeccionador de bolsas, sacos e sacolas e papel, a m\u00e1quina"
    },
    {
        id: "833125",
        value: "Operador de prensa de embutir papel\u00e3o"
    },
    {
        id: "833120",
        value: "Operador de m\u00e1quina de cortar e dobrar papel\u00e3o"
    },
    {
        id: "833115",
        value: "Confeccionador de sacos de celofane, a m\u00e1quina"
    },
    {
        id: "833205",
        value: "Cartonageiro, a m\u00e3o (caixas de papel\u00e3o)"
    },
    {
        id: "840110",
        value: "Supervisor da ind\u00fastria de bebidas"
    },
    {
        id: "840120",
        value: "Chefe de confeitaria"
    },
    {
        id: "840115",
        value: "Supervisor da ind\u00fastria de fumo"
    },
    {
        id: "840105",
        value: "Supervisor de produ\u00e7\u00e3o da ind\u00fastria aliment\u00edcia"
    },
    {
        id: "841105",
        value: "Moleiro de cereais (exceto arroz)"
    },
    {
        id: "841110",
        value: "Moleiro de especiarias"
    },
    {
        id: "841115",
        value: "Operador de processo de moagem"
    },
    {
        id: "841210",
        value: "Refinador de sal"
    },
    {
        id: "841205",
        value: "Moedor de sal"
    },
    {
        id: "841310",
        value: "Operador de equipamentos de refina\u00e7\u00e3o de a\u00e7\u00facar (processo cont\u00ednuo)"
    },
    {
        id: "841305",
        value: "Operador de cristaliza\u00e7\u00e3o na refina\u00e7\u00e3o de a\u00e7ucar"
    },
    {
        id: "841320",
        value: "Operador de tratamento de calda na refina\u00e7\u00e3o de a\u00e7\u00facar"
    },
    {
        id: "841315",
        value: "Operador de moenda na fabrica\u00e7\u00e3o de a\u00e7\u00facar"
    },
    {
        id: "841484",
        value: "Trabalhador de prepara\u00e7\u00e3o de pescados (limpeza)"
    },
    {
        id: "841476",
        value: "Trabalhador de fabrica\u00e7\u00e3o de margarina"
    },
    {
        id: "841472",
        value: "Refinador de \u00f3leo e gordura"
    },
    {
        id: "841468",
        value: "Preparador de ra\u00e7\u00f5es"
    },
    {
        id: "841464",
        value: "Prensador de frutas (exceto oleaginosas)"
    },
    {
        id: "841460",
        value: "Operador de prepara\u00e7\u00e3o de gr\u00e3os vegetais (\u00f3leos e gorduras)"
    },
    {
        id: "841456",
        value: "Operador de c\u00e2maras frias"
    },
    {
        id: "841444",
        value: "Hidrogenador de \u00f3leos e gorduras"
    },
    {
        id: "841440",
        value: "Esterilizador de alimentos"
    },
    {
        id: "841432",
        value: "Desidratador de alimentos"
    },
    {
        id: "841428",
        value: "Cozinhador de pescado"
    },
    {
        id: "841420",
        value: "Cozinhador de frutas e legumes"
    },
    {
        id: "841416",
        value: "Cozinhador de carnes"
    },
    {
        id: "841408",
        value: "Cozinhador (conserva\u00e7\u00e3o de alimentos)"
    },
    {
        id: "841448",
        value: "Lagareiro"
    },
    {
        id: "841505",
        value: "Trabalhador de tratamento do leite e fabrica\u00e7\u00e3o de latic\u00ednios e afins"
    },
    {
        id: "841620",
        value: "Operador de extra\u00e7\u00e3o de caf\u00e9 sol\u00favel"
    },
    {
        id: "841630",
        value: "Misturador de ch\u00e1 ou mate"
    },
    {
        id: "841625",
        value: "Torrador de cacau"
    },
    {
        id: "841605",
        value: "Misturador de caf\u00e9"
    },
    {
        id: "841610",
        value: "Torrador de caf\u00e9"
    },
    {
        id: "841615",
        value: "Moedor de caf\u00e9"
    },
    {
        id: "841735",
        value: "Dessecador de malte"
    },
    {
        id: "841740",
        value: "Vinagreiro"
    },
    {
        id: "841745",
        value: "Xaropeiro"
    },
    {
        id: "841725",
        value: "Malteiro (germina\u00e7\u00e3o)"
    },
    {
        id: "841730",
        value: "Cozinhador de malte"
    },
    {
        id: "841720",
        value: "Trabalhador de fabrica\u00e7\u00e3o de vinhos"
    },
    {
        id: "841705",
        value: "Alambiqueiro"
    },
    {
        id: "841710",
        value: "Filtrador de cerveja"
    },
    {
        id: "841715",
        value: "Fermentador"
    },
    {
        id: "841810",
        value: "Operador de m\u00e1quinas de fabrica\u00e7\u00e3o de doces, salgados e massas aliment\u00edcias"
    },
    {
        id: "841805",
        value: "Operador de forno (fabrica\u00e7\u00e3o de p\u00e3es, biscoitos e similares)"
    },
    {
        id: "841815",
        value: "Operador de m\u00e1quinas de fabrica\u00e7\u00e3o de chocolates e achocolatados"
    },
    {
        id: "842135",
        value: "Operador de m\u00e1quina de prepara\u00e7\u00e3o de mat\u00e9ria prima para produ\u00e7\u00e3o de cigarros"
    },
    {
        id: "842125",
        value: "Operador de m\u00e1quina (fabrica\u00e7\u00e3o de cigarros)"
    },
    {
        id: "842120",
        value: "Auxiliar de processamento de fumo"
    },
    {
        id: "842115",
        value: "Classificador de fumo"
    },
    {
        id: "842105",
        value: "Preparador de melado e ess\u00eancia de fumo"
    },
    {
        id: "842110",
        value: "Processador de fumo"
    },
    {
        id: "842205",
        value: "Preparador de fumo na fabrica\u00e7\u00e3o de charutos"
    },
    {
        id: "842210",
        value: "Operador de m\u00e1quina de fabricar charutos e cigarrilhas"
    },
    {
        id: "842215",
        value: "Classificador de charutos"
    },
    {
        id: "842220",
        value: "Cortador de charutos"
    },
    {
        id: "842225",
        value: "Celofanista na fabrica\u00e7\u00e3o de charutos"
    },
    {
        id: "842235",
        value: "Degustador de charutos"
    },
    {
        id: "842230",
        value: "Charuteiro a m\u00e3o"
    },
    {
        id: "848110",
        value: "Salgador de alimentos"
    },
    {
        id: "848105",
        value: "Defumador de carnes e pescados"
    },
    {
        id: "848115",
        value: "Salsicheiro (fabrica\u00e7\u00e3o de ling\u00fci\u00e7a, salsicha e produtos similares)"
    },
    {
        id: "848205",
        value: "Pasteurizador"
    },
    {
        id: "848210",
        value: "Queijeiro na fabrica\u00e7\u00e3o de latic\u00ednio"
    },
    {
        id: "848215",
        value: "Manteigueiro na fabrica\u00e7\u00e3o de latic\u00ednio"
    },
    {
        id: "848305",
        value: "Padeiro"
    },
    {
        id: "848310",
        value: "Confeiteiro"
    },
    {
        id: "848315",
        value: "Masseiro (massas aliment\u00edcias)"
    },
    {
        id: "848325",
        value: "Trabalhador de fabrica\u00e7\u00e3o de sorvete"
    },
    {
        id: "848425",
        value: "Classificador de gr\u00e3os"
    },
    {
        id: "848420",
        value: "Degustador de vinhos ou licores"
    },
    {
        id: "848415",
        value: "Degustador de derivados de cacau"
    },
    {
        id: "848405",
        value: "Degustador de caf\u00e9"
    },
    {
        id: "848410",
        value: "Degustador de ch\u00e1"
    },
    {
        id: "848525",
        value: "Retalhador de carne"
    },
    {
        id: "848515",
        value: "Desossador"
    },
    {
        id: "848510",
        value: "A\u00e7ougueiro"
    },
    {
        id: "848505",
        value: "Abatedor"
    },
    {
        id: "848520",
        value: "Magarefe"
    },
    {
        id: "848605",
        value: "Trabalhador do beneficiamento de fumo"
    },
    {
        id: "860105",
        value: "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica (utilidades)"
    },
    {
        id: "860110",
        value: "Supervisor de opera\u00e7\u00e3o de fluidos (distribui\u00e7\u00e3o, capta\u00e7\u00e3o, tratamento de \u00e1gua, gases, vapor)"
    },
    {
        id: "860115",
        value: "Supervisor de opera\u00e7\u00e3o el\u00e9trica (gera\u00e7\u00e3o, transmiss\u00e3o e distribui\u00e7\u00e3o de energia el\u00e9trica)"
    },
    {
        id: "861120",
        value: "Operador de reator nuclear"
    },
    {
        id: "861115",
        value: "Operador de central termoel\u00e9trica"
    },
    {
        id: "861110",
        value: "Operador de quadro de distribui\u00e7\u00e3o de energia el\u00e9trica"
    },
    {
        id: "861105",
        value: "Operador de central hidrel\u00e9trica"
    },
    {
        id: "861205",
        value: "Operador de subesta\u00e7\u00e3o"
    },
    {
        id: "862155",
        value: "Operador de utilidade (produ\u00e7\u00e3o e distribui\u00e7\u00e3o de vapor, g\u00e1s, \u00f3leo, combust\u00edvel, energia, oxig\u00eanio)"
    },
    {
        id: "862150",
        value: "Operador de m\u00e1quinas fixas, em geral"
    },
    {
        id: "862140",
        value: "Operador de esta\u00e7\u00e3o de bombeamento"
    },
    {
        id: "862130",
        value: "Operador de compressor de ar"
    },
    {
        id: "862120",
        value: "Operador de caldeira"
    },
    {
        id: "862115",
        value: "Operador de bateria de g\u00e1s de hulha"
    },
    {
        id: "862105",
        value: "Foguista (locomotivas a vapor)"
    },
    {
        id: "862160",
        value: "Operador de abastecimento de combust\u00edvel de aeronave"
    },
    {
        id: "862110",
        value: "Maquinista de embarca\u00e7\u00f5es"
    },
    {
        id: "862205",
        value: "Operador de esta\u00e7\u00e3o de capta\u00e7\u00e3o, tratamento e distribui\u00e7\u00e3o de \u00e1gua"
    },
    {
        id: "862305",
        value: "Operador de esta\u00e7\u00e3o de tratamento de \u00e1gua e efluentes"
    },
    {
        id: "862310",
        value: "Operador de forno de incinera\u00e7\u00e3o no tratamento de \u00e1gua, efluentes e res\u00edduos industriais"
    },
    {
        id: "862405",
        value: "Operador de instala\u00e7\u00e3o de extra\u00e7\u00e3o, processamento, envasamento e distribui\u00e7\u00e3o de gases"
    },
    {
        id: "862505",
        value: "Operador de instala\u00e7\u00e3o de refrigera\u00e7\u00e3o"
    },
    {
        id: "862510",
        value: "Operador de refrigera\u00e7\u00e3o com am\u00f4nia"
    },
    {
        id: "862515",
        value: "Operador de instala\u00e7\u00e3o de ar-condicionado"
    },
    {
        id: "910130",
        value: "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas operatrizes e de usinagem"
    },
    {
        id: "910110",
        value: "Supervisor de manuten\u00e7\u00e3o de aparelhos t\u00e9rmicos, de climatiza\u00e7\u00e3o e de refrigera\u00e7\u00e3o"
    },
    {
        id: "910105",
        value: "Encarregado de manuten\u00e7\u00e3o mec\u00e2nica de sistemas operacionais"
    },
    {
        id: "910115",
        value: "Supervisor de manuten\u00e7\u00e3o de bombas, motores, compressores e equipamentos de transmiss\u00e3o"
    },
    {
        id: "910120",
        value: "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas gr\u00e1ficas"
    },
    {
        id: "910125",
        value: "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas industriais t\u00eaxteis"
    },
    {
        id: "910205",
        value: "Supervisor da manuten\u00e7\u00e3o e repara\u00e7\u00e3o de ve\u00edculos leves"
    },
    {
        id: "910210",
        value: "Supervisor da manuten\u00e7\u00e3o e repara\u00e7\u00e3o de ve\u00edculos pesados"
    },
    {
        id: "910910",
        value: "Supervisor de manuten\u00e7\u00e3o de vias f\u00e9rreas"
    },
    {
        id: "910905",
        value: "Supervisor de reparos linhas f\u00e9rreas"
    },
    {
        id: "911125",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de redutores"
    },
    {
        id: "911120",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de motores diesel (exceto de ve\u00edculos automotores)"
    },
    {
        id: "911115",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de compressores de ar"
    },
    {
        id: "911110",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de bombas"
    },
    {
        id: "911105",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de bomba injetora (exceto de ve\u00edculos automotores)"
    },
    {
        id: "911130",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de turbinas (exceto de aeronaves)"
    },
    {
        id: "911135",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de turbocompressores"
    },
    {
        id: "911205",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o e instala\u00e7\u00e3o de aparelhos de climatiza\u00e7\u00e3o e  refrigera\u00e7\u00e3o"
    },
    {
        id: "911305",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas, em geral"
    },
    {
        id: "911310",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas gr\u00e1ficas"
    },
    {
        id: "911315",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas operatrizes (lavra de madeira)"
    },
    {
        id: "911320",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas t\u00eaxteis"
    },
    {
        id: "911325",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas-ferramentas (usinagem de metais)"
    },
    {
        id: "913110",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de equipamento de minera\u00e7\u00e3o"
    },
    {
        id: "913105",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de aparelhos de levantamento"
    },
    {
        id: "913115",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas agr\u00edcolas"
    },
    {
        id: "913120",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas de constru\u00e7\u00e3o e terraplenagem"
    },
    {
        id: "914105",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de aeronaves, em geral"
    },
    {
        id: "914110",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de sistema hidr\u00e1ulico de aeronaves (servi\u00e7os de pista e hangar)"
    },
    {
        id: "914205",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de motores e equipamentos navais"
    },
    {
        id: "914305",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de ve\u00edculos ferrovi\u00e1rios"
    },
    {
        id: "914420",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de tratores"
    },
    {
        id: "914415",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de motocicletas"
    },
    {
        id: "914410",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de empilhadeiras e outros ve\u00edculos de cargas leves"
    },
    {
        id: "914425",
        value: "Mec\u00e2nico de ve\u00edculos automotores a diesel (exceto tratores)"
    },
    {
        id: "914405",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de autom\u00f3veis, motocicletas e ve\u00edculos similares"
    },
    {
        id: "915110",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de hidr\u00f4metros"
    },
    {
        id: "915105",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de instrumentos de medi\u00e7\u00e3o e precis\u00e3o"
    },
    {
        id: "915115",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de balan\u00e7as"
    },
    {
        id: "915205",
        value: "Restaurador de instrumentos musicais (exceto cordas arcadas)"
    },
    {
        id: "915210",
        value: "Reparador de instrumentos musicais"
    },
    {
        id: "915215",
        value: "Luthier (restaura\u00e7\u00e3o de cordas arcadas)"
    },
    {
        id: "915305",
        value: "T\u00e9cnico em manuten\u00e7\u00e3o de equipamentos e instrumentos m\u00e9dico-hospitalares"
    },
    {
        id: "915405",
        value: "Reparador de equipamentos fotogr\u00e1ficos"
    },
    {
        id: "919105",
        value: "Lubrificador industrial"
    },
    {
        id: "919115",
        value: "Lubrificador de embarca\u00e7\u00f5es"
    },
    {
        id: "919110",
        value: "Lubrificador de ve\u00edculos automotores (exceto embarca\u00e7\u00f5es)"
    },
    {
        id: "919205",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas cortadoras de grama, ro\u00e7adeiras, motosserras e similares"
    },
    {
        id: "919310",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de bicicletas e ve\u00edculos similares"
    },
    {
        id: "919305",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de aparelhos esportivos e de gin\u00e1stica"
    },
    {
        id: "919315",
        value: "Montador de bicicletas"
    },
    {
        id: "950105",
        value: "Supervisor de manuten\u00e7\u00e3o el\u00e9trica de alta tens\u00e3o industrial"
    },
    {
        id: "950110",
        value: "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica industrial, comercial e predial"
    },
    {
        id: "950205",
        value: "Encarregado de manuten\u00e7\u00e3o el\u00e9trica de ve\u00edculos"
    },
    {
        id: "950305",
        value: "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica"
    },
    {
        id: "951105",
        value: "Eletricista de manuten\u00e7\u00e3o eletroeletr\u00f4nica"
    },
    {
        id: "951315",
        value: "Monitor de sistemas eletr\u00f4nicos de seguran\u00e7a interno"
    },
    {
        id: "951320",
        value: "Monitor de sistemas eletr\u00f4nicos de seguran\u00e7a externo"
    },
    {
        id: "951310",
        value: "Mantenedor de sistemas eletroeletr\u00f4nicos de seguran\u00e7a"
    },
    {
        id: "951305",
        value: "Instalador de sistemas eletroeletr\u00f4nicos de seguran\u00e7a"
    },
    {
        id: "953105",
        value: "Eletricista de instala\u00e7\u00f5es (aeronaves)"
    },
    {
        id: "953115",
        value: "Eletricista de instala\u00e7\u00f5es (ve\u00edculos automotores e m\u00e1quinas operatrizes, exceto aeronaves e embarca\u00e7\u00f5es)"
    },
    {
        id: "953110",
        value: "Eletricista de instala\u00e7\u00f5es (embarca\u00e7\u00f5es)"
    },
    {
        id: "954105",
        value: "Eletromec\u00e2nico de manuten\u00e7\u00e3o de elevadores"
    },
    {
        id: "954110",
        value: "Eletromec\u00e2nico de manuten\u00e7\u00e3o de escadas rolantes"
    },
    {
        id: "954115",
        value: "Eletromec\u00e2nico de manuten\u00e7\u00e3o de portas autom\u00e1ticas"
    },
    {
        id: "954120",
        value: "Mec\u00e2nico de manuten\u00e7\u00e3o de instala\u00e7\u00f5es mec\u00e2nicas de edif\u00edcios"
    },
    {
        id: "954125",
        value: "Operador eletromec\u00e2nico"
    },
    {
        id: "954205",
        value: "Reparador de aparelhos eletrodom\u00e9sticos (exceto imagem e som)"
    },
    {
        id: "954210",
        value: "Reparador de r\u00e1dio, tv e som"
    },
    {
        id: "954305",
        value: "Reparador de equipamentos de escrit\u00f3rio"
    },
    {
        id: "991105",
        value: "Conservador de via permanente (trilhos)"
    },
    {
        id: "991110",
        value: "Inspetor de via permanente (trilhos)"
    },
    {
        id: "991115",
        value: "Operador de m\u00e1quinas especiais em conserva\u00e7\u00e3o de via permanente (trilhos)"
    },
    {
        id: "991120",
        value: "Soldador aluminot\u00e9rmico em conserva\u00e7\u00e3o de trilhos"
    },
    {
        id: "991205",
        value: "Mantenedor de equipamentos de parques de divers\u00f5es e similares"
    },
    {
        id: "991305",
        value: "Funileiro de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        id: "991310",
        value: "Montador de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        id: "991315",
        value: "Pintor de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        id: "992105",
        value: "Alinhador de pneus"
    },
    {
        id: "992120",
        value: "Lavador de pe\u00e7as"
    },
    {
        id: "992115",
        value: "Borracheiro"
    },
    {
        id: "992110",
        value: "Balanceador"
    },
    {
        id: "992205",
        value: "Encarregado geral de opera\u00e7\u00f5es de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        id: "992220",
        value: "Pedreiro de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        id: "992215",
        value: "Operador de ceifadeira na conserva\u00e7\u00e3o de vias permanentes"
    },
    {
        id: "992210",
        value: "Encarregado de equipe de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        id: "992225",
        value: "Auxiliar geral de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    }
];


